
window.theme = window.theme || {};
theme.const = {
  CART_REQUEST: "fetch:request", // fetch request
  CART_CHANGE: "cart-data:change", // change cart
  CART_REFRESH: "cart-data:refresh", // /cart.js request
};

function isTextMenuVersionFn(){
  return theme.isPrimaryMarket() //&& !!localStorage.getItem('menu-text-version')
}
if (isTextMenuVersionFn()) {
    if(theme.isMobile()){
      theme.templates["mobile-menu"].url =
   "/products/9-in-1-modular-raised-garden-bed?view=mobile-menu";
    // }else{ 
    //   // new one
    //   document
    //     .querySelector("#header-menu-v2")
    //     .classList.add("new-menu-text-version");
      ;
    }

}
theme.marketProductPath = () => {
  let p_path = "vego-garden-6-in-1-modular-raised-garden-bed-kit";
  if (isTextMenuVersionFn()) p_path = "9-in-1-modular-raised-garden-bed"; // menu text version
  if (theme.isAu()) p_path = "elevated-garden-bed-2-by-4";
  return p_path;
};
theme.recentlyViewed = theme.recentlyViewed || {
  recent: {}, // will store handle+url of recent products
  productInfo: {}, // will store product data to reduce API calls
}
window.$procuctCache = window.$procuctCache || {}
window._ajaxProductCallback = function (data, item) {
  var meta = data.product.metafields
  var imageMap = data.product.images.reduce(function (a, b) {
    a[b.id] = b
    return a
  }, {})
  var variants = [], isFirst = true, variantImages = [], avaliableG1Options = [], avaliableOptions = []

  for (var i = 0; i < data.product.variants.length; i++) {
    var variant = data.product.variants[i]
    var variantMeta = meta.variants.find(v => v.id == variant.id)
    variant.available = variantMeta.available
    var skipVariant = false
    // =============  To Display compare_at_price of Ca =========================
    //if (variantMeta.compareAtPrice && !variant.compare_at_price && variantMeta.compareAtPrice > variant.price && theme.pathMarketPrefix()) {
    if (variantMeta.compareAtPrice) {
      variant.compare_at_price = variantMeta.compareAtPrice
    } else {
      if (`${variant.compare_at_price}`.includes('.')) variant.compare_at_price = ((`${variant.compare_at_price}`.replace(',', '')) * 100).toFixed(0)
    }

    variant.compare_at_price = theme.unityCompareAtPrice(variant.compare_at_price, variant.id)
    if (variant.compare_at_price <= variant.price * 100) {
      variant.compare_at_price = null
    }
    if (variant.title === 'Default Title') {
      data.product.hasOnlyDefaultTitle = true
    }

    if (data.product.options[1] && data.product.options[1].name === 'Bracing Rod Width') {
      if (variant.option2 === '4.5\'') {
        skipVariant = true
      }
    }

    if (!(variantMeta.spec && variantMeta.spec.hide)) {
      if (data.product.options.length === 1) {
        var optionLabel = variant.option1.split('-')[0].trim()
        if (optionLabel.indexOf('G2') > -1) {
          avaliableG1Options.forEach(function (option) {
            if (optionLabel.indexOf(option) > -1) {
              skipVariant = true
            }
          })
        } else {
          if (variant.available) {
            avaliableG1Options.push(optionLabel)
          } else if (variantMeta.spec && variantMeta.spec.discontinued) {
            skipVariant = true
          }
        }
      } else {
        if (!variant.available && variantMeta.spec && variantMeta.spec.discontinued) {
          skipVariant = true
        }
      }
      if (theme.isAu() && variantMeta.spec && variantMeta.spec.auDisable) {
        skipVariant = true;
      } else if (theme.isCA() && variantMeta.spec && variantMeta.spec.caDisable) {
        skipVariant = true
      }
      if (skipVariant) {
        continue
      }
      for (var i1 = 1; i1 <= 3; i1++) {
        if (variant['option' + i1]) {
          if (!avaliableOptions[i1]) {
            avaliableOptions[i1] = []
          }
          if (!avaliableOptions[i1].includes(variant['option' + i1])) {
            avaliableOptions[i1].push(variant['option' + i1])
          }
        }
      }
      if (!variant.image_id) {
        variant.image_id = data.product.images[0].id
      }
      variant.image = {
        src: imageMap[variant.image_id].src,
        srcset: theme.Images.srcSetImages(imageMap[variant.image_id].src),
        alt: imageMap[variant.image_id].alt
      }
      variantImages.push({
        src: variant.image.src,
        srcset: variant.image.srcset,
        alt: variant.image.alt,
        id: variant.id
      })
      if (variantMeta.preOrder) {
        if (variantMeta.preOrder.toLowerCase() === 'true') {
          variant.preOrder = true
          variant.fulfillmentDate = ts2shortDateFormat(variantMeta.estimatedFulfillmentDateTs * 1000)
        }
      } else {
        if (meta.preOrder && meta.preOrder.toLowerCase() === 'true') {
          variant.preOrder = true
          variant.fulfillmentDate = ts2shortDateFormat(meta.estimatedFulfillmentDateTs * 1000)
        }
      }
      if (variantMeta.estimatedFulfillmentDateTs) {
        variant.fulfillmentDateTs = variantMeta.estimatedFulfillmentDateTs
      }
      if (item.variantId) {
        if (variant.id == item.variantId) {
          data.product.select = variant
        }
      } else if (isFirst && variant.available) {
        data.product.select = variant
        isFirst = false
        if (this.discount && this.discount[variant.id]) {
          var discount = this.discount[variant.id]
          if (discount.discountPercent) {
            data.product.discount = discount.discountPercent + '% OFF'
          } else if (discount.discountValue) {
            data.product.discount = 'SAVE $' + discount.discountValue
          }
        }
      }
      variants.push(variant)
    }
  }
  if (data.product.select) {
    data.product.available = true
  } else {
    return null
  }
  if (!variants.length) {
    return null
  }
  data.product.variants = variants
  data.product.variantImages = variantImages
  data.product.options.forEach(function (option, i) {
    option.select = data.product.select['option' + (i + 1)]
    if (option.name === 'Bracing Rod Width'
      && data.product.handle !== '11-tall-2-extension-kit-for-10-in-1-raised-garden-bed'
      && data.product.handle !== '17-tall-vego-garden-2-ft-extension-kit'
      && data.product.handle !== '32-tall-2-extension-kit-for-10-in-1-raised-garden-bed') {
      option.hide = true
    }
    if (option.name === "Generation") {
      option.hide = true
    }
    const values = []
    if (avaliableOptions[i + 1]) {
      for (var value of option.values) {
        if (avaliableOptions[i + 1].includes(value)) {
          values.push(value)
        }
      }
    }
    if (values.length) {
      option.values = values
    } else {
      option.hide = true
    }
  })
  data.product.variantJson = JSON.stringify(data.product.variants)
  data.product.image.srcset = theme.Images.srcSetImages(data.product.image.src)
  if (data.product.select.preOrder) {
    data.product.fulfillmentDate = data.product.select.fulfillmentDate
    data.product.fulfillmentDateTs = data.product.select.fulfillmentDateTs
  }
  data.product.singlePrice = theme.Currency.formatMoney(
    data.product.select.price,
    theme.settings.moneyFormat
  )
  data.product.compareAtPrice = theme.Currency.formatMoney(
    data.product.select.compare_at_price ?? 0,
    theme.settings.moneyFormat
  )
  data.product.compareAtPriceValue = (data.product.select.compare_at_price ?? 0) / 100
  return data
};
window._ajaxSingleProduct = async function (item) {
  var that = this
  return new Promise(function (resolve, reject) {
    if (!item.handle && item.product?.handle) item.handle = item.product?.handle
    if (that.$procuctCache[item.handle]) {
      var product = window._ajaxProductCallback(that.$procuctCache[item.handle], item)
      if (product) {
        item.product = product.product
        resolve(item)
      } else {
        resolve(null)
      }
    } else {
      $.get(`${window.route_prefix}products/${item.handle}.json`, function (data) {
        $.get(`${window.route_prefix}products/${item.handle}?view=metafields`, function (meta) {
          data.product.metafields = JSON.parse(meta)

          window.$procuctCache[item.handle] = data
          var product = window._ajaxProductCallback(data, item)
          if (product) {
            product.product.variants = formatVariantDataByDiscountPriceData(product.product.variants)
            item.product = product.product
            resolve(item)
          } else {
            resolve(null)
          }
        }).fail(function (err) {
          //console.log(item, err)
          resolve(null)
        })
      }).fail(function (err) {
        //console.log(item, err)
        resolve(null)
      })
    }
  })
}
if (theme.config.hasLocalStorage) {
  theme.recentlyViewed.localStorage =
    window.localStorage.getItem('theme-recent')

  if (theme.recentlyViewed.localStorage) {
    theme.recentlyViewed.recent = JSON.parse(
      theme.recentlyViewed.localStorage
    )
    if (!theme.recentlyViewed.recent.viewed) {
      var products = {}
      var viewed = []
      for (var k in theme.recentlyViewed.recent) {
        products[k] = theme.recentlyViewed.recent[k]
        viewed.push(k)
        delete theme.recentlyViewed.recent[k]
      }
      theme.recentlyViewed.recent.products = products
      theme.recentlyViewed.recent.viewed = viewed
    }
  }
}

theme.defer = theme.defer || {}
theme.cache = theme.cache || {}

  ; +(function ($) {
    $.qs = function () {
      const paramsArray = window.location.search.substring(1).split('&')
      let params = {}
      for (let i = 0; i < paramsArray.length; ++i) {
        let param = paramsArray[i].split('=', 2)
        if (param.length !== 2) continue
        if (!params[param[0]]) {
          params[param[0]] = []
        }
        params[param[0]].push(decodeURIComponent(param[1].replace(/\+/g, ' ')))
      }
      return params
    }
  })(jQuery);

const cacheAjaxGet = async (url) => {
  url = url.includes(theme.pathMarketPrefix()) ? url : `${theme.pathMarketPrefix()}${url}`;
  if (theme.cache[url]) return theme.cache[url];
  let p = await fetch(url)
  p = await p.text()
  let html_cache = new DOMParser().parseFromString(`<div>${p}</div>`, 'text/html')
  theme.cache[url] = html_cache;
  return theme.cache[url]
}

// theme.defer.mobileSearchFn = async () => {
//   let sc = document.querySelector('.mobile-sub-nav-content-search'), sl = '.search-layout'
//   if (sc.querySelector(sl)) return;
//   let res_el = await cacheAjaxGet(`/products/vego-garden-6-in-1-modular-raised-garden-bed-kit?view=search`)
//   sc.prepend(res_el.querySelector(sl))
//   if (theme.settings.predictiveSearch) {
//     theme.predictiveSearch?.init?.()
//   }
// }
theme.defer.openMobileMenuFn = async (el, preLoad = false, onLoaded) => {
  let sc = document.querySelector('.mobile-menu-placeholder'), sl = 'mobile-menu'
  if (preLoad) { // preload mobile menu only

    let res_el = await cacheAjaxGet(theme.templates['mobile-menu'].url)
    sc.replaceWith(res_el.querySelector(sl))
    new theme.Modals(
      'LanguageChanger',
      'language-changer'
    )
    onLoaded && onLoaded()
    return

  }
  if (!el) return;
  if (sc && !sc?.textContent) {
    let res_el = await cacheAjaxGet(theme.templates['mobile-menu'].url)
    sc.replaceWith(res_el.querySelector(sl))
    el.classList.remove('btn--loading');
    if (theme.isMobile()) {
      setTimeout(() => {
        el.click()
        setTimeout(() => {
          if (!document.querySelector('mobile-menu')?.isOpen()) {
            el?.click?.()
          }
        }, 400)
      }, 400)
    }
    judgeMarketFn?.()
    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch?.init?.()
      window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets && window.yotpoWidgetsContainer.initWidgets()

    }

    // Reset Serach
    document.querySelector('mobile-menu')?.searchReset?.()

    // resize menu height
    document.querySelector('mobile-menu')?.resize?.()

    new theme.Modals(
      'LanguageChanger',
      'language-changer'
    )
    onLoaded && onLoaded()
  };
}

theme.defer.openPcMenuLoading = true;
const hoverMsg = {
  'solar-garden-light': `Let your garden light the way with Vego's Solar Garden Lights! `,
  'rippled-solar-garden-light': `Transform your garden with elegant, magnetic, solar-powered Vego Garden Lights. `,
  'vego-garden-cover-system-g2': `Vego Garden System offers customizable pest control with mesh. `,
  'metal-frame-string-trellis': `Vego Vertical Gardens: Easy & Affordable. All-Season Support, Effortless Teardown! `,
  'garden-arch-trellis': `1.5-7ft lengths | 7.5ft height (↑8ft) | Customizable. `,
  'modular-wall-trellis-system': `Trellises expand space and success. Grow a vertical herb garden for year-round freshness. `,
  'vego-garden-tool-box': `Your garden set up just got more convenient. Introducing the Vego Garden Tool Box! `,
  'worm-farm-worm-composter': `The Vego Garden Worm Composter easily converts organic waste into fertilizer. `,
  'vego-irrigation-kit': `Tired of messy watering? Vego Irrigation makes garden care effortless and reliable. `,
  'soil-saving-floor-for-32-classic-and-novel-beds': `The Vego Soil-Saving Floor cuts soil use by 53% in 32" beds, reducing costs.`,
  'self-watering-wicking-floor': `Self-watering wicking floors for Classic/Novel beds! `,
  'wicking-cells': `Vego's wicking cell system ensures optimal moisture for thriving plants, perfect for patios. `,
  'garden-bed-mister': `Watering is simpler! Easy-install tubes clip securely and mist plants. `,
  'vego-trellis-anchors': `Secure your trellis with Vego Anchors for a thriving garden! Ideal for Arched Trellis systems. `,
  'vego-soil-saving-intermediate-floor-for-modern-garden-bed': `Save 60% soil with our strong, space-saving garden floors!`,
  'vego-modern-privacy-trellis': `Vertical gardening with a sleek, modern look. Don’t settle for messy, hard to manage trellises. `,
  'extension-kit': `In Texas, we have a saying, "Go big or go home".  Here we bring to you the Extension Kit.  `,
  'stainless-steel-gopher-net-staples-kit': `Toxin-free Gopher Net—safe, humane burrower protection! `,
  'tree-surround-watering-ring-kit': `Boost tree growth—mulch containment & lawn protection kit! `,
}
theme.defer.hoverAddOns = () => {

  $('.add-on-list-content a').hover((evt) => {
    let href = evt.target.getAttribute('href').split('?')[0].split('/').slice(-1)[0]
    $('.add-on-img-container-v1').attr('data-add-ons-type', href)
    $('.add-on-img-container-v1').parent().find('h5').text($(evt.target).text())
    $('.add-on-img-container-v1').parent().find('p').text(hoverMsg[href.trim()])
    $('.add-on-img-container-v1').parent().find('a').attr('href', evt.target.getAttribute('href'))
  })
}
theme.defer.openPcMenuFn = async ($ele) => {
  if (theme.defer.openPcMenuLoading) {
    // let line_nav_items = Array.from(document.querySelectorAll('#StickyHeaderWrap .header-inline-container .header-nav-menu >li'))
    // let res_el = await cacheAjaxGet(
    //   `${window.route_prefix}products/${theme.marketProductPath()}?view=pc-menu`
    // );
    // Array.from(res_el.querySelectorAll('li.allow-sub-menu-load')).forEach((item, index) => {
    //     debugger;
    //   if (item.querySelector('.inline-dropdown-collection') && !line_nav_items[index].querySelector('.inline-dropdown-collection'))
    //     line_nav_items[index].appendChild(item.querySelector('.inline-dropdown-collection'))
    // })
    judgeMarketFn?.()
    function setActiveBottom($item) {
      var $con = $item.closest('.inline-dropdown')
      if ($('#' + $item.data('target') + '-bottom').length) {
        $con.find('.header-inline-nav-bottom ').addClass('hide')
        $('#' + $item.data('target') + '-bottom').removeClass('hide')
      }
    }

    // if (localStorage.getItem('menu-gardenbeds') && localStorage.getItem('menu-gardenbeds') == '1' && window.location.href.indexOf('/en-ca') == -1) {
    //   $('.inline-dropdown-menu-abtest-2').addClass('hide')
    //   $('.inline-dropdown-menu-abtest-1').removeClass('hide')
    // } else {
    //   $('.inline-dropdown-menu-abtest-2').removeClass('hide')
    //   $('.inline-dropdown-menu-abtest-1').addClass('hide')
    // }
    // if (localStorage.getItem('menu-elevatedbeds') && localStorage.getItem('menu-elevatedbeds') == '2' && window.location.href.indexOf('/en-ca') == -1) {
    //   $('.menu-elevated-garden-beds-abtest-2').removeClass('hide')
    //   $('.menu-elevated-garden-beds-abtest-1').addClass('hide')
    // } else {
    //   $('.menu-elevated-garden-beds-abtest-2').addClass('hide')
    //   $('.menu-elevated-garden-beds-abtest-1').removeClass('hide')
    // }
    var activeItem = $ele.closest('.header-nav-item').find('.inline-dropdown-menu-tab-item.active')
    if (activeItem.length) {
      activeItem.each((index, item) => {
        setActiveBottom($(item))
      })
    }
    $('.inline-dropdown-menu-tab-item').on('mouseenter', function (event) {
      event.stopPropagation()
      var $con = $(this).closest('.inline-dropdown')
      $con.find('.inline-dropdown-menu-tab-item, .dropdown-menu-tab-content').removeClass('active')
      $(this).addClass('active')
      $('#' + $(this).data('target')).addClass('active')
      setActiveBottom($(this))
      if ($(this).data('target') == 'menu-tab-digital-yard-sale') {
        $('.service-highlight-return').hide()
      } else {
        $('.service-highlight-return').show()
      }
    })
    $('.inline-dropdown-menu-tab-item').on('keydown', function (event) {
      event.stopPropagation()
      if (event.key == 'Enter') {
        var $con = $(this).closest('.inline-dropdown')
        $con.find('.inline-dropdown-menu-tab-item, .dropdown-menu-tab-content').removeClass('active')
        $(this).addClass('active')
        $('#' + $(this).data('target')).addClass('active')
        setActiveBottom($(this))
        if ($(this).data('target') == 'menu-tab-digital-yard-sale') {
          $('.service-highlight-return').hide()
        } else {
          $('.service-highlight-return').show()
        }
      }
    })
    $('.inline-dropdown-menu-tab-item .nav-item-link-arrow-level2').on('click', function (event) {
      event.stopPropagation()
      var $con = $(this).closest('.inline-dropdown')
      $con.find('.inline-dropdown-menu-tab-item, .dropdown-menu-tab-content').removeClass('active')
      $(this).closest('.inline-dropdown-menu-tab-item').addClass('active')
      $('#' + $(this).closest('.inline-dropdown-menu-tab-item').data('target')).addClass('active')
      setActiveBottom($(this))
    })
    theme.defer.hoverAddOns()
    //window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets()

  }
  // this.openPcMenuLoading = false

}

theme.defer.mobileCartFn = async () => {
  let sc = document.querySelector('.cart-drawer-container')//,sl= '#CartDrawer'
  if (sc) return;

  let res_el = await cacheAjaxGet(
    `${window.route_prefix}products/${theme.marketProductPath()}?view=cart`
  );
  let src = res_el.querySelector('#cart-drawer-script').getAttribute('src')

  await new Promise((resolve, reject) => {
    let el = document.createElement('script')
    el.src = src;
    el.addEventListener('load', () => {
      resolve()
    })
    document.head.append(el)
  })
  document.body.append(res_el.querySelector('.cart-drawer-container'))
}

theme.initSearchEvents = function initSearchEvents() {
  $('.site-header__search-form').each(function () {
    const $form = $(this)
    if ($form.data('inited')) {
      return
    }
    $form.on('click', '.site-header-clear', function () {
      $qInput = $form.find('input[name=q]')
      $qInput.val('')
      const $layout = $form.closest('.search-layout')
      $layout.find('.search-terms').removeClass('hide')
      $layout.find('.search-suggest-empty-result').addClass('hide')
      $layout.find('.search-suggest-item').removeClass('hide')
      $layout.find('.predictive-results').addClass('hide')
    })

    $form.find('input[name=q]').on('focus', function () {
      $(this).closest('.search-header-btn-box').addClass('focused')

    })
    $form.find('input[name=q]').on('input', function () {
      if ($(this).val() !== '') {
        $(this).closest('.search-header-btn-box').find('.site-header-clear').show()
      } else {
        $(this).closest('.search-header-btn-box').find('.site-header-clear').hide()
      }
    })

    $form.find('input[name=q]').on('paste', function () {
      if ($(this).val() !== '') {
        $(this).closest('.search-header-btn-box').find('.site-header-clear').show()
      } else {
        $(this).closest('.search-header-btn-box').find('.site-header-clear').hide()
      }
    })
    $form.find('input[name=q]').on('blur', function () {
      $(this).closest('.search-header-btn-box').removeClass('focused')
    })
    $form.data('inited', true)
  })
}

function readVariantPriceFromCart(variant_id, lineItemData) {
  let lineItem = lineItemData ?? (window.cartData?.items ?? []).find(item => item.variant_id == variant_id)
  if (lineItem) {
    return {
      price: lineItem.final_price / 100,
      title: lineItem.product_title
    }
  } else {
    return null
  }
}

// 待统计rdt 数据队列
window.rdtSequence = []

async function rbtAddtoCart(data, lineItem) {
  let dataObj = data;
  if (!lineItem) {
    // format paramters of `add to cart` call
    dataObj = decodeURIComponent(data[1].body).split('&').reduce((res, item) => {
      let str = item.split('=')
      res[str[0]] = str[1]
      return res
    }, {})
  }

  let variantObj = readVariantPriceFromCart(dataObj.id, lineItem)
  if (variantObj) {
    let quantity = dataObj.quantity || 1

    rdt('track', 'AddToCart', {
      "currency": "USD",
      "itemCount": quantity,
      "value": variantObj.price * quantity,
      "products": [
        {
          "id": dataObj.id,
          "name": [variantObj.title, dataObj.Color].join('-'),
          "category": "Vego Garden"
        }
      ]
    });
  } else { // push sequence to wait cart update
    if (!window.rdtSequence) window.rdtSequence = []
    window.rdtSequence.push(dataObj)
  }

}
document.addEventListener('cart-data:refresh', function (evt) {
  let varaintIdObj = (window.cartData?.items ?? []).reduce((res, item) => {
    res[item.variant_id] = item;
    return res;
  }, {})
  // rdt 统计在购物车可以找到的variant 数据, 同时从队列中移除已统计的数据
  window.rdtSequence = (window.rdtSequence ?? []).filter(item => {
    if (varaintIdObj[item.id]) rbtAddtoCart(item, varaintIdObj[item.id])
    return !varaintIdObj[item.id]
  })
});

(function (ns, fetch) {
  ns.fetch = function () {
    const response = fetch.apply(this, arguments);
    let argumentsData = arguments
    response.then(async (res) => {
      if (res.url.indexOf(theme.routes.cart) > -1 && !!res.url) {
        window.cartData = await res.clone().json()
        document.dispatchEvent(new CustomEvent('cart-data:refresh'));
      }
      if (res.url.indexOf(theme.routes.cartAdd) > -1 && !!res.url) {
        rbtAddtoCart(argumentsData);
      }
    });
    return response;
  };
})(window, window.fetch);
/*============================================================================
      Things that require DOM to be ready
    ==============================================================================*/
function DOMready(callback) {
  if (document.readyState != 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}



; (function () {
  ; ('use strict')

  function formatDateText(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
    if (!date) {
      return ''
    }
    if (typeof date === 'string') {
      date = new Date(date.replace(/-/g, '/'))
    }
    if (typeof date === 'number') {
      date = new Date(date)
    }
    date = new Date(date.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }))
    var monthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_')
    var o = {
      'M+': date.getMonth() + 1,
      'D+': date.getDate(),
      'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    }
    if (/(Y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    if (/(d+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, monthsShort[date.getMonth()])
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }

  window.formatDateText = formatDateText


  theme.isCA = theme.isCa

  theme.loadTemplate = function (tag) {
    return new Promise(function (resolve, reject) {
      fetch(theme.templates[tag].url).then(response => {
        response.text().then(text => {
          const dom = new DOMParser().parseFromString(text, 'text/html')
          var script = document.createElement('script');
          window[tag] = function (data) {
            delete window[tag]
            document.body.removeChild(script)
            resolve(data)
          }
          script.innerHTML = dom.querySelector('script').innerHTML
          document.body.appendChild(script)
        }).catch(reject)
      }).catch(reject)
    })
  }
  theme.htmlEncode = function (str) {
    var s = "";
    if (!str || str.length == 0) return "";
    s = str.replace(/&/g, "&amp;");
    s = s.replace(/</g, "&lt;");
    s = s.replace(/>/g, "&gt;");
    s = s.replace(/\'/g, "&#39;");
    s = s.replace(/\"/g, "&quot;");
    return s;
  }
  theme.bgsetInit = function () {
    if ('IntersectionObserver' in window) {
      function applyBg(element, url) {
        const parts = url.split(',')
        if (parts.length > 1) {
          let bgImage
          for (const part of parts) {
            const sources = part.split(/\s+/).filter(e => !!e)
            const src = sources[0].trim()
            const width = sources[1].replace('w', '')
            if (window.innerWidth * window.devicePixelRatio > width) {
              bgImage = `url('${src}')`
            }
          }
          if (bgImage) {
            element.style.backgroundImage = bgImage
          }
        } else {
          element.style.backgroundImage = `url('${url}')`
        }
      }

      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            // Item has crossed our observation
            // threshold - load src from data-src
            const bgset = entry.target.dataset.bgset
            const bgsets = bgset.split('|')
            let mediaSource = {}, defaultSource = ''
            bgsets.forEach(e => {
              const match = e.trim().match(/\[(.+)\]/)
              if (match) {
                mediaSource[match[1]] = e.replace(match[0], '').trim()
              } else {
                defaultSource = e.trim()
              }
            })
            let matchQuery = false
            for (const mediaq in mediaSource) {
              if (window.matchMedia(mediaq).matches) {
                applyBg(entry.target, mediaSource[mediaq])
                matchQuery = true
                break
              }
            }
            if (!matchQuery) {
              applyBg(entry.target, defaultSource)
            }
            // Job done for this item - no need to watch it!
            observer.unobserve(entry.target);
          }
        });
      }

      const bgLazyLoads = $('.lazyload[data-bgset]')

      const observer = new IntersectionObserver(
        handleIntersection,
        { rootMargin: "100px" }
      );
      bgLazyLoads.each((i, ele) => {
        if (!$(ele).data('lazyload')) {
          observer.observe(ele)
          $(ele).data('lazyload', true)
        }
      });
    }
  }

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus',
      }

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
      var elArray = [].slice.call(focusableEls)
      var focusableElements = elArray.filter((el) => el.offsetParent !== null)

      var firstFocusable = focusableElements[0]
      var lastFocusable = focusableElements[focusableElements.length - 1]

      if (!options.elementToFocus) {
        options.elementToFocus = options.container
      }

      options.container.setAttribute('tabindex', '-1')
      options.elementToFocus.focus()

      document.documentElement.off('focusin')
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown)
      })

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable)
          return

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt)
        })
      })

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault()
          lastFocusable.focus()
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin'

      if (options.container) {
        options.container.removeAttribute('tabindex')
      }

      document.documentElement.off(eventName)
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement
      el.on('touchmove' + namespace, function () {
        return true
      })
    },

    unlockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement
      el.off('touchmove' + namespace)
    },
  }

  theme.Sections = function Sections() {
    this.constructors = {}
    this.instances = []

    document.addEventListener(
      'shopify:section:load',
      this._onSectionLoad.bind(this)
    )
    document.addEventListener(
      'shopify:section:unload',
      this._onSectionUnload.bind(this)
    )
    document.addEventListener(
      'shopify:section:select',
      this._onSelect.bind(this)
    )
    document.addEventListener(
      'shopify:section:deselect',
      this._onDeselect.bind(this)
    )
    document.addEventListener(
      'shopify:block:select',
      this._onBlockSelect.bind(this)
    )
    document.addEventListener(
      'shopify:block:deselect',
      this._onBlockDeselect.bind(this)
    )
  }

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute('data-section-id')
      var type = container.getAttribute('data-section-type')

      constructor = constructor || this.constructors[type]

      if (typeof constructor === 'undefined') {
        return
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id)
        if (instanceExists) {
          this._removeInstance(id)
        }
      }

      //      },

      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container,
      })

      this.instances.push(instance)
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i]
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length
      var instance

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i]
          this.instances.splice(i, 1)
          break
        }
      }

      return instance
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      //@deprecated
      if (AOS) {
        AOS.refreshHard()
      }
      theme.initGlobals()

      var container = subSection ? subSection : evt.target
      var section = subSection
        ? subSection
        : evt.target.querySelector('[data-section-id]')

      if (!section) {
        return
      }

      this._createInstance(section)

      var instance = subSection
        ? subSectionId
        : this._findInstance(evt.detail.sectionId)

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]')
      if (haveSubSections.length) {
        this._loadSubSections()
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt)
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'))
      }, 200)
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt)
          }
        }

        return !isEventInstance
      })
    },

    _loadSubSections: function () {
      //@deprecated
      if (AOS) {
        AOS.refreshHard()
      }

      document.querySelectorAll('[data-subsection]').forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId)
      })
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId)

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt)
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId)

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt)
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId)

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt)
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId)

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt)
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor

      var sections = document.querySelectorAll(
        '[data-section-type="' + type + '"]'
      )

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]')
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope)
        }.bind(this)
      )
    },
  })

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */

  theme.Currency = (function () {
    var moneyFormat = '${{amount}}'

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat
      }

      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }
      var value = ''
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
      var formatString = format || moneyFormat

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2)
        thousands = theme.utils.defaultTo(thousands, ',')
        decimal = theme.utils.defaultTo(decimal, '.')

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        var parts = number.split('.')
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        )
        var centsAmount = parts[1] ? decimal + parts[1] : ''

        return dollarsAmount + centsAmount
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2)
          break
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0)
          break
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',')
          break
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',')
          break
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ')
          break
      }

      return formatString.replace(placeholderRegex, value)
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return
      }

      if (
        !variant.unit_price_measurement ||
        !variant.unit_price_measurement.reference_value
      ) {
        return
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    }
  })()

  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */

  theme.Images = (function () {
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x' // default based on theme
      }

      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      )

      if (match !== null) {
        return match[1]
      } else {
        return null
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src
      }

      if (size == null) {
        return src
      }

      if (size === 'master') {
        return this.removeProtocol(src)
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      )

      if (match != null) {
        var prefix = src.split(match[0])
        var suffix = match[0]

        return this.removeProtocol(prefix[0] + '_' + size + suffix)
      }

      return null
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '')
    }

    function lazyloadImagePath(string) {
      var image

      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, '_{width}x$1')
      }

      return image
    }
    const sizes = {
      'sm': ['120', '360', '540', '720'],
      'lg': ['360', '540', '720', '900', '1080']
    }

    function srcSetImages(src, size) {
      if (!size) {
        size = 'sm'
      }
      if (sizes[size]) {
        let set = ''
        for (const s of sizes[size]) {
          set = set + src + '&width=' + s + ' ' + s + 'w,\n'
        }
        return set.trim(',')
      }
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath,
      srcSetImages: srcSetImages

    }
  })()

  /**
   * @deprecated consider remove
   * @param {*} container 
   * @returns 
   */
  theme.loadImageSection = function (container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed')
      container.classList.add('loaded')
    }

    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded')
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded()
      return
    }

    if (checkForLazyloadedImage()) {
      setAsLoaded()
      return
    }

    var interval = setInterval(function () {
      if (checkForLazyloadedImage()) {
        clearInterval(interval)
        setAsLoaded()
      }
    }, 80)
  }

  theme.Variants = (function () {
    function Variants(options) {
      this.container = options.container
      this.variants = formatVariantDataByDiscountPriceData(options.variants)
      this.singleOptionSelector = options.singleOptionSelector
      this.originalSelectorId = options.originalSelectorId
      this.enableHistoryState = options.enableHistoryState
      this.productId = options.productId
      this.currentVariant = this._getVariantFromOptions()
      this.discount = theme.config.discountInfo
      $(this.container).find(`.product-options ${this.singleOptionSelector}`).on('change', this._onSelectChange.bind(this))
      $('.product-recommend-item .grid-product-variant-input').on('change', e => {
        const compareAtPrice = $(e.target).find('option[value=' + e.target.value + ']').data('compareAtPrice')
        $(e.target).closest('.grid-product-box__body').find('name="items[1][properties][original_price]"')?.val?.(compareAtPrice)
      })

      var $option = $(
        this.originalSelectorId + ' option[value=' + this.currentVariant.id + ']'
      )
      var preOrder = $option.data('preorder')
      if (!this.currentVariant.available || preOrder) {
        $(this.container).find('.payment-prediction').hide()
      }
      this._updateSpec(this.currentVariant)
      
      setTimeout(() => {
        this._updatePrice(this.currentVariant)
      }, 0)
      $('.grid-configs-assemble .btn-config').on('click', e => {
        var text = $(e.target).text()
        for (var variant of this.variants) {
          if (variant.title.includes(text) && variant.available) {
            $('.product-single__meta .variant-select:enabled').vselect('select', variant.title)
            document.documentElement.scrollTo({
              behavior: "smooth",
              top: 0
            })
            break
          }
        }
      })
      this.judgeSubscription?.()
      this.updateUiforHoseReel(this.currentVariant)
      this._updateProductPoints(this.currentVariant)
      this._updateDetailFeatureImage(this.currentVariant)
      this.updateTabForClassicRollingTreePlanter(this.currentVariant)
      this._updateUserManual(this.currentVariant)
      this._updateTrellisInfo(this.currentVariant)
      this.updateUiForGreenhouse(this.currentVariant)
      this._updateColorFulfillment(this.currentVariant)
      this.updateGH_PDPshippingFee(this.currentVariant.id);
      if ($('.product__photos-v2').length) {
        $('.product__photos-v2 .product-main-slide').eq(0).find('.photoswipe__image').attr('srcset', theme.Images.srcSetImages(this.currentVariant.featured_image.src))
        $('.product__photos-v2 .product-main-slide').eq(0).find('.photoswipe__image').attr('data-photoswipe-src', this.currentVariant.featured_image.src)
        $('.product__photos-v2 .product__thumb-item').eq(0).find('img').attr('srcset', this.currentVariant.featured_image.src + '&width=66')
        $('.product__photos-v2 .product__thumb-item').eq(0).find('a').attr('href', this.currentVariant.featured_image.src+ '&width=66')
      }

    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var result = [];
        $(this.container)
          .find(".product-options")
          .find(this.singleOptionSelector + ":enabled")
          .each(function () {
            var type = this.getAttribute("type");
            if (type === "radio" || type === "checkbox") {
              if (this.checked) {
                result.push({
                  value: this.value,
                  index: this.dataset.index,
                });
              }
            } else {
              result.push({
                value: this.value,
                index: this.dataset.index,
              });
            }
          });
        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);
        return result;
      },

      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
        variants.forEach(function (variant) {
          var match = true;
          selectedValues.forEach(function (option) {
            let value = option.value
            if (option.value.indexOf('_____') > -1) {
              value = option.value.split(('_____'))[0]
            }
            if (match) {
              match = variant[option.index] === value;
            }
          });

          if (match) {
            found = variant;
          }
        });
        if (found) {
          selectedValues.forEach(function (option) {
            if (option.value.indexOf('_____') > -1) {
              found[`${option.index}Last`] = option.value.split(('_____'))[1]
            }
          })
        }
        return found || null;
      },

      updateGH_PDPshippingFee: function (vId) {
        
        let cfg_el = document.querySelector(
          "#pdp_green_house_shipping_fee_config"
        );
        if (!cfg_el) return cfg_el;
        let green_house_shipping_fee_config = JSON.parse(cfg_el.value);
        let config = green_house_shipping_fee_config.reduce((res, item) => {
          if (item.variant_item) {
            res[item.variant_item.split("/").slice(-1)[0]] = parseFloat(
              item.option_shipping_fee
            );
          } else if (item.product) {
            item.product.forEach(e => {
              res[e.split("/").slice(-1)[0]] = parseFloat(
                item.option_shipping_fee
              )
            })
          }
          return res;
        }, {});
        let currentConfig = config[vId]
        if (!currentConfig) {
          currentConfig = config[this.productId]
        }
        if (currentConfig) {
          let gh_pdp_shipping_fee_el = document.querySelector(
            ".gh-pdp-shiping-fee"
          );
          if (gh_pdp_shipping_fee_el) {
            gh_pdp_shipping_fee_el.innerHTML = `Shipping Fee: $${currentConfig}/${
              window.location.pathname.indexOf("vego-garden-planter-mix") > -1
                ? "bag"
                : "unit"
            }`;
          }
        }
        //return config[vId]
      },
      updateClassicBundleVariant(variant) {
        let selectVariant = []
        this.variants.map((v) => {
          if (v.options[0] == variant.options[0] && $(`.variant__button-label-new-quantity`).length) {
            let eachPrice = v.price / Number($(`.variant__button-label-new-quantity[data-target="${v.option2}"]`).attr('data-quantity'))
            $(`.variant__button-label-new-quantity[data-target="${v.option2}"] .variant__button-label-each`).text(`( ${theme.Currency.formatMoney(
              eachPrice,
              theme.settings.moneyFormat
            )}/each )`)
          }
        })

        // console.log(this.variants);
        // console.log(variant)

      },
      /**
       * # -------------------------------- composter subscription action --------------------------------
       * ## special for composter in pdp page
       * 1. update subscriptions when updating size. for example: 1 bag to Quarterly Subscription, 2 bags to Semi-Annual Subscription
       * 2. link options between options in pdp and bottom bars options
       * @param {*} e       current selected option element
       * @param {*} value   current selected option value
       */
      judgeSubscription: function (e, value) {
        if (!e) {
          e = { target: this.container.querySelector('[name="Size"]:checked') };
        }
        if (!value) {
          value = e.target?.value;
        }
        let class_ =
          window.innerWidth > 768
            ? `.mobile-sticky-product-details-pc`
            : `.mobile-sticky-product-details-pc+div`;
        if (e?.target?.getAttribute?.("name") == "Subscription") {
          e.target
            .closest("form")
            ?.querySelector?.(`[name="Subscription"][value="${value}"]`)
            ?.closest?.("label.product-subscription-label-content")
            ?.click?.();
        } else if (
          e.target?.name == "Size" &&
          e.target?.closest("form").querySelector('[name="Subscription"]')
        ) {
          let form = e.target.closest("form");
          if (["3-month supplies", "1 bag"].includes(value?.toLowerCase?.())) {
            let quarterlyEl = form.querySelector(
              '[name="Subscription"][value="Quarterly Subscription"]'
            );
            quarterlyEl.closest(".product-subscription").style.display =
              "block";
            if (
              !$(form)
                .find("product-subscription")?.[0]
                ?.querySelector(".product-subscription-label-content.active")
                ?.closest?.(".product-subscription")
                ?.getAttribute?.("data-id")
                ?.trim?.()
            ) {
              // not one time purchase
              quarterlyEl
                .closest("label.product-subscription-label-content")
                ?.click?.();
            }
            // document?.querySelector('.one-time-purchase-texts')?.classList = 'one-time-purchase-texts active-1'
            $(".one-time-purchase-2").hide();
            $(".one-time-purchase-1").show();

            $(form)
              .find(`${class_} [data-value="Quarterly Subscription"]`)
              .show();
            if (
              !$(form).find(`[data-value="Quarterly Subscription"].active`)
                .length
            ) {
              $(form).find(`[data-value="Quarterly Subscription"]`).click();
            }
            $(form)
              .find(`${class_}  [data-value="Semi-Annual Subscription"]`)
              .hide();

            form
              .querySelector(
                '[name="Subscription"][value="Semi-Annual Subscription"]'
              )
              .closest(".product-subscription").style.display = "none";
          } else if (
            e.target?.name == "Size" &&
            ["half-year supplies", "2 bags"].includes(value?.toLowerCase?.())
          ) {
            let semiAnnualEl = form.querySelector(
              '[name="Subscription"][value="Semi-Annual Subscription"]'
            );
            $(".one-time-purchase-1").hide();
            $(".one-time-purchase-2").show();
            // document.querySelector('.one-time-purchase-texts').classList = 'one-time-purchase-texts active-2'
            semiAnnualEl.closest(".product-subscription").style.display =
              "block";
            if (
              !$(form)
                .find("product-subscription")?.[0]
                .querySelector(".product-subscription-label-content.active")
                ?.closest?.(".product-subscription")
                ?.getAttribute?.("data-id")
                ?.trim?.()
            ) {
              // not one time purchase
              semiAnnualEl
                .closest("label.product-subscription-label-content")
                ?.click?.();
            }
            $(form)
              .find(`${class_} [data-value="Quarterly Subscription"]`)
              .hide();
            $(form)
              .find(`${class_} [data-value="Semi-Annual Subscription"]`)
              .show();
            if (
              !$(form).find(`[data-value="Semi-Annual Subscription"].active`)
                .length
            ) {
              $(form).find(`[data-value="Semi-Annual Subscription"]`).click();
            }
            form
              .querySelector(
                '[name="Subscription"][value="Quarterly Subscription"]'
              )
              .closest(".product-subscription").style.display = "none";
          }
        }
      },
      /**
       *  special handle for `Vego Retractable Hose Reel Set` pdp ui
       */
      updateUiforHoseReel: function (variant) {
        let hoseConfig = document.querySelector(".hose-config-hidden")?.value;
        let optionPosition =
          document.querySelector(".hose-config-hidden")?.dataset
            .optionPosition || "option2";
        if (hoseConfig) {
          hoseConfig = JSON.parse(hoseConfig);
          let key =
            "hose_" +
            `${variant[optionPosition]}`
              .toLowerCase()
              .replace("'", "")
              .replace("ft", "")
              .replace(".", "")
              .trim();
          Object.keys(hoseConfig[key]).forEach((key1) => {
            Array.from(
              document.querySelectorAll(`[data-config-${key1}]`)
            ).forEach((el) => {
              el.innerHTML = hoseConfig[key][key1];
            });
          });
        }
      },

      updateUiForGreenhouse: function (variant) {
        $('.page-section-wall-type').addClass('hide')
        if ($(".page-section-wall-type").length)
          $(
            `.page-section-wall-type[data-target-option-name="${variant.option2}"]`
          ).removeClass("hide");
      },

      updateTabForClassicRollingTreePlanter: function(variant) {
        Array.from($('.engineered-content-tab-image-item')).map((el)=>{
          $(el).removeClass('active')
          if (variant.option2.includes($(el).data('option'))) {
            $(el).addClass('active')
          }
        })
      },

      _onSelectChange: function (e) {
        var variant = this._getVariantFromOptions();
        var _this = this;
        let option_str = "";
        if (e.target.getAttribute("name") == "Subscription") {
          if (window.location.href.indexOf("kitchen-composter") > -1) {
            option_str = variant.option2;
          } //(window.location.href.indexOf('carbon-refill-kit') > -1)
          else {
            option_str = variant.option1;
          }
        } else {
          option_str = variant.option1;
        }
        this.judgeSubscription(e, option_str);
        if ($('.product__photos-v2').length) {
          $('.product__photos-v2 .product-main-slide').eq(0).find('.photoswipe__image').attr('srcset', theme.Images.srcSetImages(variant.featured_image.src))
          $('.product__photos-v2 .product-main-slide').eq(0).find('.photoswipe__image').attr('data-photoswipe-src', variant.featured_image.src)
          $('.product__photos-v2 .product__thumb-item').eq(0).find('img').attr('srcset', variant.featured_image.src + '&width=66')
          $('.product__photos-v2 .product__thumb-item').eq(0).find('a').attr('href', variant.featured_image.src+ '&width=66')
        }

        this.updateUiforHoseReel(variant);
        if (
          window.location.href.indexOf("vegotabs") > -1 ||
          window.location.href.indexOf("carbon-refill-kit") > -1 ||
          window.location.href.indexOf("kitchen-composter") > -1
        ) {
          variant = this._getVariantFromOptions();
        }

        this.needReset = !variant;
        this.container.dispatchEvent(
          new CustomEvent("variantChange", {
            detail: {
              variant: variant,
            },
          })
        );
        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: {
              variant: variant,
            },
          })
        );

        if (!variant) {
          return;
        }
        this.updateGH_PDPshippingFee(variant.id);
        /**
         *  选中规格和sticky中规格联动
         */
        let stickEle = $(this.container.querySelector(this.originalSelectorId))
          .closest("form")
          .find(".mobile-sticky-product-details");
        if (stickEle.length) {
          stickEle
            .find(
              ".mobile-sticky-product-details-pc .mobile-sticky-img-box>div a "
            )
            .html(variant.public_title);
          var hasVariantImage = false;
          $(
            ".mobile-sticky-img-box .mobile-sticky-img-box-featured-img img"
          ).each(function (i, img) {
            img.style.display = "none";
            if (
              variant.featured_image &&
              variant.featured_image.src &&
              img.srcset
                .replace(/(http|https):/, "")
                .includes(
                  variant.featured_image.src.replace(/(http|https):/, "")
                )
            ) {
              img.style.display = "inline";
              hasVariantImage = true;
            }
          });
          if (!hasVariantImage) {
            $(".mobile-sticky-img-box img.featured-image").css(
              "display",
              "inline"
            );
          }
          var optionIndex = $(e.target).data("index");
          stickEle
            .find(
              '[data-ui="select"][data-target="data-index=' + optionIndex + '"]'
            )
            .vselect("select", variant[optionIndex]);
        }
        if ($(".choose-panel").length) {
          var optionName = e.target.name;
          var optionIndex = $(e.target).data("index");
          if (optionName.toLowerCase() == "color") {
            $(".choose-panel").cp("check", variant[optionIndex]);
          } else {
            $(".action-bar")
              .find('[data-ui="select"][data-target="' + optionName + '"]')
              .vselect("select", variant[optionIndex]);
          }
        }

        this._updateColorName(variant, e);
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this._updateEstField(variant);
        this._updateColorFulfillment(variant);
        this._updateTrellisInfo(variant);
        this.updateUiForGreenhouse(variant)
        this._updateAmazon(variant);
        this._updateSpec(variant);
        this._updateProductPoints(variant);
        this.updateClassicBundleVariant(variant)
        this.updateTabForClassicRollingTreePlanter(variant)

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
        this._updateDetailFeatureImage(variant);
        this._updateUserManual(variant);

        this.currentVariant = variant;

        if ($("[data-composter-variant]").length) {
          $("[data-composter-variant]").removeClass("show");
          $("[data-composter-variant]").each(function () {
            var composterVariant = $(this).data("composterVariant") + "";
            var variantId = variant.id + "";
            if (composterVariant.indexOf(variantId) > -1) {
              $(this).addClass("show");
            }
          });
        }
        if (
          !this.productSelectorVariantsMapping &&
          $("#ProductSelectorVariantsMapping").length
        ) {
          this.productSelectorVariantsMapping = JSON.parse(
            $("#ProductSelectorVariantsMapping").text()
          );
        }
        function replaceQuery(url, key, value) {
          const s1 = url.split("?");
          const queryParams = {};
          if (s1[1]) {
            const s2 = s1[1].split("&");
            for (let i = 0; i < s2.length; i++) {
              const s3 = s2[i].split("=");
              queryParams[s3[0]] = s3[1];
            }
          }
          queryParams[key] = value;
          return `${s1[0]}?${Object.keys(queryParams)
            .map((k) => `${k}=${queryParams[k]}`)
            .join("&")}`;
        }

        if (this.productSelectorVariantsMapping) {
          $(".vego-product-size-options-style-link").each(function () {
            if ($(this).hasClass("active")) {
              $(this).attr(
                "href",
                replaceQuery($(this).attr("href"), "variant", variant.id)
              );
            } else {
              if (_this.productSelectorVariantsMapping[variant.id]) {
                $(this).attr(
                  "href",
                  replaceQuery(
                    $(this).attr("href"),
                    "variant",
                    _this.productSelectorVariantsMapping[variant.id]
                  )
                );
              }
            }
          });
        }
      },

      _updateUserManual: function (variant) {
        let selector =
          ".user-manual-download-btn, .assembly-container .assembly-item";
        if ($(selector).length) {
          $(selector).each(function () {
            let variantId = $(this).data("variant");
            if (variantId) {
              if (variantId == variant.id) {
                $(this).removeClass("hide");
              } else {
                $(this).addClass("hide");
              }
            }
          });
        }
      },

      _updateDetailFeatureImage: function (variant) {
        // console.log($('.product-section.is-modal'));
        
        if($('.product-section.is-modal').length > 0) return
        var selector = "elevated-feature-img-pc,.media-with-variant";
        if (theme.isMobile()) {
          selector = "elevated-feature-img-mobile,.media-with-variant";
        }
        if ($("." + selector).length) {
          $("." + selector).each(function () {
            var variantId = $(this).data("variant");
            if (variantId) {
              if (variantId == variant.id) {
                $(this).removeClass("hide");
              } else {
                $(this).addClass("hide");
              }
            }
          });
        }
        $("[data-variant-class]").each(function () {
          const config = $(this).data("variantClass");
          var allClasses = [];
          for (var key in config) {
            if (!allClasses.includes(config[key])) {
              allClasses.push(config[key]);
            }
          }
          $(this).removeClass(allClasses);
          if (config[variant.id]) {
            $(this).addClass(config[variant.id]);
          }
        });
      },

      _updateProductPoints: function (variant) {
        theme.productForm.updateProductPoints(variant);
      },

      _updateColorFulfillment: function (variant) {
        var dates = [];
        var _this = this;
        
        this.variants.forEach(function (v) {
          if (v.option2 == variant.option2 && v.option3 == variant.option3) {
            var $option = $(
              _this.originalSelectorId + " option[value=" + v.id + "]"
            );
            if (v.available) {
              dates.push($option.data("fulfillment"));
            } else {
              dates.push("-");
            }
          }
        });
        $(".choose-panel button").each(function (idx) {
          if (dates[idx]) {
            if (dates[idx] == "-") {
              $(this).find(".color-fulfillment").text("Sold Out");
            } else {
              $(this).find(".color-fulfillment").text(dates[idx]);
            }
          } else {
            $(this).find(".color-fulfillment").text("2 days");
          }
        });
      },

      _updateEstField: function (variant) {
        var $option = $(
          this.originalSelectorId + " option[value=" + variant.id + "]"
        );
        var preOrder = $option.data("preorder");
        var estFulfillment;
        var fulfillmentTs = $option.data("fulfillmentTs");
        if (!variant.available) {
          $(this.container).find(".payment-prediction").hide();
          $(this.container)
            .find(".grid-product-est .grid-product-variant-title__left")
            .text("Shipping Status");
          $(this.container)
            .find(".grid-product-est .grid-product-variant-title__tip")
            .hide();
          $(this.container)
            .find(
              ".grid-product-est__wrapper:not(.grid-product-est__wrapper_exclude)"
            )
            .html('<span class="grid-product-est__field">Out of Stock</span>');
          $(this.container).find(".product-quantity-info").addClass("hide");
        } else {
          if (preOrder && !theme.isAu()) {
            // estFulfillment = formatDateText(fulfillmentTs * 1000, 'DD/MM/YYYY')
            estFulfillment = ts2shortDateFormat(fulfillmentTs * 1000);
            $(this.container).find(".payment-prediction").hide();
            if (fulfillmentTs) {
              var duration = fulfillmentTs - Math.round(Date.now() / 1000);
              var fullflllText = "";
              if (duration > 0) {
                if (duration < 691200) {
                  fullflllText = "Ships in 1 week";
                } else if (duration < 1296000) {
                  fullflllText = "Ships in 2 weeks";
                }
              } else {
                $(this.container).find(".payment-prediction").show();
                $(this.container)
                  .find(".grid-product-est .grid-product-variant-title__left")
                  .text("Shipping Status");
                $(this.container)
                  .find(".grid-product-est .grid-product-variant-title__tip")
                  .hide();
                $(this.container)
                  .find(
                    ".grid-product-est__wrapper:not(.grid-product-est__wrapper_exclude)"
                  )
                  .html(
                    '<span class="grid-product-est__field">In Stock</span>'
                  );
                return;
              }
              if (fullflllText) {
                $(this.container)
                  .find(".grid-product-est .grid-product-variant-title__left")
                  .text("Shipping Status");
                $(this.container)
                  .find(".grid-product-est .grid-product-variant-title__tip")
                  .hide();
                $(this.container)
                  .find(
                    ".grid-product-est__wrapper:not(.grid-product-est__wrapper_exclude)"
                  )
                  .html(
                    `<span class="grid-product-est__field">In Stock (${fullflllText})</span>`
                  );
                // Mother's day promotion tips. TOTO remove after 5.8
                $(".product-promotion-tip").addClass("hide");
                return;
              }
            }
            $(this.container)
              .find(".grid-product-est .grid-product-variant-title__left")
              .text("Ships by");
            $(this.container)
              .find(".grid-product-est .grid-product-variant-title__tip")
              .show();
            $(this.container)
              .find(
                ".grid-product-est__wrapper:not(.grid-product-est__wrapper_exclude)"
              )
              .html(
                '<div class="grid-product-est__field">' +
                estFulfillment +
                "</div>"
              );
            // Mother's day promotion tips. TOTO remove after 5.8
            $(".product-promotion-tip").addClass("hide");
          } else {
            $(this.container).find(".payment-prediction").show();
            $(this.container)
              .find(".grid-product-est .grid-product-variant-title__left")
              .text("Shipping Status");
            $(this.container)
              .find(".grid-product-est .grid-product-variant-title__tip")
              .hide();
            $(this.container)
              .find(
                ".grid-product-est__wrapper:not(.grid-product-est__wrapper_exclude)"
              )
              .html('<span class="grid-product-est__field">In Stock</span>');
            // Mother's day promotion tips. TOTO remove after 5.8
            $(".product-promotion-tip").removeClass("hide");
          }
          $(this.container).find(".product-quantity-info").removeClass("hide");
        }
      },

      _updateColorName: function (variant, e) {
        let color = variant.option1;
        // if (variant.id == '40482229682211' || variant.id == '40482229747747') {
        //   color = variant.option1 + ' + Gift package'
        // }
        if (e.target.name.toLowerCase() === "color") {
          this.container.dispatchEvent(
            new CustomEvent("variantColorChange", {
              detail: {
                variant: variant,
                color,
              },
            })
          );
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
        if ($('.product__photos-v2').length) {
          $('.product__photos-v2 .product-main-slide').eq(0).find('.photoswipe__image').attr('srcset', theme.Images.srcSetImages(variantImage.src))
          $('.product__photos-v2 .product__thumb-item').eq(0).find('img').attr('srcset', variantImage.src + '&width=66')
          $('.product__photos-v2 .product__thumb-item').eq(0).find('a').attr('href', variantImage.src+ '&width=66')
        }
        // if ($('.product__photos-v2').length) {
        //   $('.product__photos-v2 .product-main-slide .photoswipe__image').eq(0).attr('srcset', variantImage.src)
        //   $('.product__photos-v2 .product__thumb-item').eq(0).find('img').attr('srcset', variantImage.src)
        //   $('.product__photos-v2 .product__thumb-item').eq(0).find('a').attr('href', variantImage.src)
        // }
        if (
          !variant.featured_image ||
          variantImage.src === currentVariantImage.src
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantImageChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updatePrice: function (variant) {
        if (this.discount && this.discount[variant.id]) {
          this.container.dispatchEvent(
            new CustomEvent("variantPriceChange", {
              detail: {
                variant: variant,
                discount: this.discount[variant.id],
              },
            })
          );
        } else {
          this.container.dispatchEvent(
            new CustomEvent("variantPriceChange", {
              detail: {
                variant: variant,
              },
            })
          );
        }
      },

      _updateUnitPrice: function (variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantUnitPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateSKU: function (variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantSKUChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }
        const query = $.qs();
        query.variant = variant.id;
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          $.param(query, true);
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      _updateMasterSelect: function (variant) {
        this.container.querySelector(this.originalSelectorId).value =
          variant.id;
        theme.productForm.updatePreOrder(
          $(this.originalSelectorId),
          $(this.originalSelectorId).closest("form"),
          variant
        );
        if (window.cartDrawerInstance) {
          window.cartDrawerInstance.initRecommendProduct();
        }
      },

      _updateTrellisInfo: function (variant) {
        var tag = variant.option1.split("-")[0];
        tag = tag.split('(')[0].trim()
        if (tag.includes("G2")) {
          tag = tag.replace("G2", "");
        }
        tag = tag.trim();
        if (variant.option1 == "2.0' Round (Herb Twin Pack)") {
          tag = "2.0' Round (Herb Twin Pack)"
        }
        if ($(".cover-description").length) {
          var $tagEle
          if ($('[data-variant-target="' + tag + '"]').length) {
            $tagEle = $('[data-variant-target="' + tag + '"]')
          } else if (variant.option1Last && $('[data-variant-target="' + variant.option1Last + '"]').length) {
            $tagEle = $('[data-variant-target="' + variant.option1Last + '"]')
          }
          if ($tagEle) {
            if ($("[data-variant-target]").length) {
              $("[data-variant-target]").removeClass("active");
              $tagEle.addClass("active");
            }
            var containerWidth = $(".cover-description")[0].offsetWidth
            var left = $tagEle[0].offsetLeft - containerWidth
            if (left < 0) {
              left = 0
            } else {
              left = left + 80
            }
            $(".cover-description").scrollLeft(left);
          }
        }
      },

      _updateAmazon: function (variant) {
        var $option = $(
          this.originalSelectorId + " option[value=" + variant.id + "]"
        );
        var asin = $option.data("asin");
        if (asin) {
          $(".product-single__form .payment-more").removeClass("hide");
          var $link = $(".product-single__form .payment-more > a");
          var template = $link.data("template");
          template && $link.attr("href", template.replace("{ASIN}", asin));
        } else {
          $(".product-single__form .payment-more").addClass("hide");
        }
      },
      _updateSpec: function (variant) {
        var $option = $(
          this.originalSelectorId + " option[value=" + variant.id + "]"
        );
        var spec = $option.data("spec");
        if (spec) {
          for (var k in spec) {
            if ($("#" + k).length) {
              var value = spec[k];
              var $el = $("#" + k);
              if (value) {
                $el.text("x" + value);
                $el.closest(".assembly-item").removeClass("hide");
              } else {
                $el.closest(".assembly-item").addClass("hide");
              }
            }
          }
        }

        if ($(".manual-download")) {
          $(".manual-download").addClass("hide");
          $(".manual-download").each(function (e) {
            if ($(this).data("id") == variant.id) {
              $(this).removeClass("hide");
            }
          });
        }
      },
    });

    return Variants
  })()

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach((table) => {
      var wrapWith = document.createElement('div')
      wrapWith.classList.add('table-wrapper')
      theme.utils.wrap(table, wrapWith)
    })

    // Wrap video iframe embeds so they are responsive
    document
      .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
      .forEach((iframe) => {
        wrapVideo(iframe)
      })
    document
      .querySelectorAll('.rte iframe[src*="player.vimeo"]')
      .forEach((iframe) => {
        wrapVideo(iframe)
      })

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src
      var wrapWith = document.createElement('div')
      wrapWith.classList.add('video-wrapper')
      theme.utils.wrap(iframe, wrapWith)
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach((img) => {
      img.parentNode.classList.add('rte__image')
    })
  }

  theme.LibraryLoader = (function () {
    var types = {
      link: 'link',
      script: 'script',
    }

    var status = {
      requested: 'requested',
      loaded: 'loaded',
    }

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/'

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script,
      },
      // vimeo: {
      //   tagId: 'vimeo-api',
      //   src: 'https://player.vimeo.com/api/player.js',
      //   type: types.script,
      // },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script,
      },
      // modelViewerUi: {
      //   tagId: 'shopify-model-viewer-ui',
      //   src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
      //   type: types.script,
      // },
      // modelViewerUiStyles: {
      //   tagId: 'shopify-model-viewer-ui-styles',
      //   src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      //   type: types.link,
      // },
    }

    function load(libraryName, callback) {
      var library = libraries[libraryName]

      if (!library) return
      if (library.status === status.requested) return

      callback = callback || function () { }
      if (library.status === status.loaded) {
        callback()
        return
      }

      library.status = status.requested

      var tag

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback)
          break
        case types.link:
          tag = createLinkTag(library, callback)
          break
      }

      tag.id = library.tagId
      library.element = tag

      var firstScriptTag = document.getElementsByTagName(library.type)[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script')
      tag.src = library.src
      tag.addEventListener('load', function () {
        library.status = status.loaded
        callback()
      })
      return tag
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link')
      tag.href = library.src
      tag.rel = 'stylesheet'
      tag.type = 'text/css'
      tag.addEventListener('load', function () {
        library.status = status.loaded
        callback()
      })
      return tag
    }

    return {
      load: load,
    }
  })()

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true
    document.dispatchEvent(new CustomEvent('youTubeReady'))
  }

  /*============================================================================
      YouTube SDK method
      Parameters:
        - player div id (required)
        - arguments
          - videoId (required)
          - videoParent (selector, optional for section loading state)
          - events (object, optional)
    ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable',
    }

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
      },
    }

    var playerObject = {};

    function YouTube(divId, options) {
      this.divId = divId
      this.iframe = null
      this.attemptedToPlay = false

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this),
      }

      this.options = Object.assign({}, defaults, options)

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document
            .getElementById(this.divId)
            .closest(this.options.videoParent)
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1
          this.options.playerVars.autoplay = 0
        }
      }

      this.setAsLoading()

      if (theme.config.youTubeReady) {
        this.init()
      } else {
        theme.LibraryLoader.load('youtubeSdk')
        document.addEventListener('youTubeReady', this.init.bind(this))
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options)
      },

      doToggleMute(id) {
        var idKey = "YouTubeVideo-" + id;
        var player = playerObject[idKey];
        if (player) {
          if (player.isMuted()) {
            player.unMute();
            document.getElementById("youtube-video-mute-" + id + "-icon-mute").setAttribute("style", "display:block");
            document.getElementById("youtube-video-mute-" + id + "-icon-unmute").setAttribute("style", "display:none");
          } else {
            player.mute();
            document.getElementById("youtube-video-mute-" + id + "-icon-mute").setAttribute("style", "display:none");
            document.getElementById("youtube-video-mute-" + id + "-icon-unmute").setAttribute("style", "display:block");
          }
        }
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId) // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1')

        if (this.options.style !== 'sound') {
          evt.target.mute()
        }
        evt.target.playVideo();

        var id = evt.target.getIframe().getAttribute('id');
        if (id) {
          var simpleId = id.replace('YouTubeVideo-', '')
          playerObject[id] = evt.target;

          var muteBtn = document.getElementById("youtube-video-mute-" + simpleId);
          if (muteBtn) {
            muteBtn.style.display = "block";
          }
          var loadContainer = document.querySelector(".loading-container-" + simpleId);
          if (loadContainer) {
            loadContainer.style.display = "none";
          }
        }

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play()
              } else {
                this.pause()
              }
            })
          },
          { rootMargin: '0px 0px 50px 0px' }
        )

        observer.observe(this.iframe)
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded()
              this.enableInteraction()
            }
            break
          case 0: // ended, loop it
            this.play(evt)
            break
          case 1: // playing
            this.setAsLoaded()
            break
          case 3: // buffering
            this.attemptedToPlay = true
            break
        }
      },

      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },

      setAsLoaded: function () {
        document.getElementById(this.divId).classList.add("loaded");
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        if (Shopify && Shopify.designMode) {
          ////@deprecated
          AOS && AOS.refreshHard()
        }
      },

      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },

      play: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.playVideo === 'function'
        ) {
          this.videoPlayer.playVideo()
        }
      },

      pause: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.pauseVideo === 'function'
        ) {
          this.videoPlayer.pauseVideo()
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === 'function'
        ) {
          this.videoPlayer.destroy()
        }
      },
    })

    return YouTube
  })()

  // window.vimeoApiReady = function () {
  //   theme.config.vimeoLoading = true

  //   // Because there's no way to check for the Vimeo API being loaded
  //   // asynchronously, we use this terrible timeout to wait for it being ready
  //   checkIfVimeoIsReady().then(function () {
  //     theme.config.vimeoReady = true
  //     theme.config.vimeoLoading = false
  //     document.dispatchEvent(new CustomEvent('vimeoReady'))
  //   })
  // }

  // function checkIfVimeoIsReady() {
  //   var wait
  //   var timeout

  //   var deferred = new Promise((resolve, reject) => {
  //     wait = setInterval(function () {
  //       if (!Vimeo) {
  //         return
  //       }

  //       clearInterval(wait)
  //       clearTimeout(timeout)
  //       resolve()
  //     }, 500)

  //     timeout = setTimeout(function () {
  //       clearInterval(wait)
  //       reject()
  //     }, 4000) // subjective. test up to 8 times over 4 seconds
  //   })

  //   return deferred
  // }


  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading')
      document.querySelectorAll('.cart__checkout').forEach((el) => {
        el.classList.remove('btn--loading')
      })
    }

    // Fix: back-forward cache
    if (
      window.location.href.indexOf('products/') > -1 &&
      evt.persisted ||
      (window.performance &&
        window.performance.getEntriesByType &&
        String(window.performance.getEntriesByType('navigation')[0].type) === 'back_forward')
    ) {
      window.location.reload();
    }
  }


  theme.AjaxProduct = (function () {
    var status = {
      loading: false,
    }

    function ProductForm() {
      $(document).on('submit', `form[action="${window.route_prefix}cart/add"]`, this.addItemFromForm.bind(this))
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      getFieldEle: function (form, opt) {
        let selling_plan = form.querySelector(`[name="${opt.name}"]`)
        if (!selling_plan) {
          selling_plan = document.createElement('input')
          selling_plan.type = 'hidden'
          selling_plan.name = opt.name
          form.append(selling_plan)
        }
        return selling_plan
      },
      subscriptionFnCondition: function (form) {
        let url = form.querySelector('.grid-product__link')?.getAttribute?.('href') //list
        if (url) { // list page
          return {
            activeId: form.querySelector('[name="Subscription"] option:checked')?.getAttribute('data-sell_plan'),
            handle: url.split('?')[0].split('/').slice(-1)[0]
          }
        } else { // detail page
          return {
            activeId: form.querySelector('product-subscription')?.getActive?.()?.trim?.(),
            handle: location.href.split('?')[0].split('/').slice(-1)[0]
          }
        }
      },
      /**
       * # -------------------------------- composter subscription action --------------------------------
       * @param {*} form 
       */
      subscriptionFn: function (form) {
        let subscription = this.subscriptionFnCondition(form)
        let index = 1
        if (form.closest('.product-recommend-item')) index = 2
        if (form.closest('.product-recommend-item')) {  // You May Also Like
        } else if (subscription.activeId && subscription.handle) { // exist subscription  [PDP page]
          let handle = subscription.handle
          let activePlanId = subscription.activeId
          if (activePlanId) { // subscription active
            if (handle == 'kitchen-composter') {  // Composter
              this.getFieldEle(form, { name: `items[${index}]selling_plan` }).value = `${activePlanId}`
              let isQuarterly = [
                '40480660815907',  // Quarterly Subscription / Black / 4L
                '40480660848675'   // Quarterly Subscription / White / 4L
              ].includes(form.querySelector('[name=id]').value)
              this.getFieldEle(form, { name: `items[${index}]id` }).value = isQuarterly ? `40481728757795` : '40481728790563' // QUARTERLY :40481728757795, ANNUAL: 40481728790563
              this.getFieldEle(form, { name: `items[${index}]quantity` }).value = form.querySelector('[name="quantity"]')?.value ?? 1
              this.getFieldEle(form, { name: 'properties[__composter]' }).value = '__bundle_' + (form.querySelector('[name="id"]').value)
              this.getFieldEle(form, { name: `items[${index}][properties][__composter]` }).value = '__bundle_' + (form.querySelector('[name="id"]').value)
              this.getFieldEle(form, { name: `items[${index}][properties][_is_preorder]` }).value = 'Note: Pre-order item'
              if (!isQuarterly) {
                this.getFieldEle(form, { name: `items[${index}][properties][original_price]` }).value = '239.80' //
              } else {
                form.querySelector(`[name="items[${index}][properties][original_price]"]`)?.remove?.()
              }
              // 
              this.getFieldEle(form, { name: `items[${index}][properties][_is_fullfillDate]` }).value = 'In Stock'

            } else { //Carbon Filter Refill Kit & VegoTab Bundle
              let selling_plan = this.getFieldEle(form, { name: 'selling_plan' })
              selling_plan.value = `${activePlanId}`
            }
          }
        } else { // collection page

          form.querySelector('[name="selling_plan"]')?.remove?.()
          form.querySelector(`[name="items[${index}]selling_plan"]`)?.remove?.()
          form.querySelector(`[name="items[${index}]id"]`)?.remove?.()
          form.querySelector(`[name="items[${index}]quantity"]`)?.remove?.()
          form.querySelector(`[name*="items[${index}][properties][__composter"]`)?.remove?.()
          form.querySelector(`[name="items[${index}][properties][original_price]"`)?.remove?.()
          form.querySelector(`[name*="properties[__composter"`)?.remove?.()
          form.querySelector(`[name="items[1][properties][_is_fullfillDate]"]`)?.remove?.()
          form.querySelector(`[name="items[1][properties][_is_preorder]"]`)?.remove?.()
        }
      },
      greenhouseDeliveryFee: function (form) {
        if (form.querySelector('[name="properties[_is_upgrade_delivery]"]')?.value == 'true' || form.querySelector('[name="items[1][properties][_is_upgrade_delivery]"]')?.value == 'true') {
          this.getFieldEle(form, { name: `items[${1}][quantity]` }).value = form.querySelector('[name="quantity"]')?.value ?? 1
        }
      },
      addItemFromForm: function (evt, callback) {

        evt.preventDefault()
        const add = () => {
          if (status.loading) {
            return
          }
          const $form = $(evt.currentTarget)
          const $addToCart = $form.find('.add-to-cart')

          // Loading indicator on add to cart button
          if (!$form.hasClass('no-loading'))
            $addToCart.addClass('btn--loading')
          status.loading = true
          const emailCookie = theme.getEmailLinkCookie()
          if (emailCookie) {
            const emailEle = document.createElement('input')
            emailEle.type = 'hidden'
            emailEle.value = emailCookie
            emailEle.name = `properties[_${theme.EMAIL_KEY}]`
            if (!$form[0]?.querySelector(`[name*=${theme.EMAIL_KEY}]`)) {
              $form[0].append(emailEle)
            }
          }
          //## =============     Subscription Code  =======
          let op_el_0 = $form[0].querySelector('[name="items[0][properties][original_price]"]')
          if (op_el_0) op_el_0.value = op_el_0.value.replace(',', '')

          let op_el_1 = $form[0].querySelector('[name="items[1][properties][original_price]"]')
          if (op_el_1) op_el_1.value = op_el_1.value.replace(',', '')

          let op_el = $form[0].querySelector('[name="properties[original_price]"]')
          if (op_el) op_el.value = op_el.value.replace(',', '')

          this.subscriptionFn($form[0])
          this.greenhouseDeliveryFee($form[0])
          var data = theme.utils.serialize($form[0])
          if (window.navigator.userAgent.includes('VegoGarden Mobile')) {
            let quantity = '1'
            let el_quantity = $form[0].querySelector('[name="quantity"]')
            if (el_quantity) quantity = el_quantity.value
            let message = {
              method: 'addToMobileCart',
              params: {
                quantity,
                variantId: $form[0].querySelector('[name="id"]')?.value
              }
            };
            return window.FlutterChannel?.postMessage?.(JSON.stringify(message));
          }
          fetch(theme.routes.cartAdd, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then((response) => response.json())
            .then(
              function (data) {
                if (data.status === 422) {
                  this.error(product, $addToCart, data, $form)
                } else {
                  var product = data
                  this.success(product, $form, $addToCart)
                }

                status.loading = false
                $addToCart.removeClass('btn--loading')
              }.bind(this)
            )
        }
        setTimeout(add, 200)
      },

      success: function (product, $form, $addToCart) {
        $form.find('.errors').remove()

        //------------------------ Mother's Day ------------------------------
        if (window.location.pathname === '/pages/vego-garden-mathers-day') {
          window.location.href = `${window.route_prefix}products/${product.handle}?openCart=true`;
          return;
        }


        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: product,
              drawer: true,
              addToCartBtn: $addToCart[0],
            },
          })
        )
      },

      error: function (product, $addToCart, error, $form) {
        if (!error.description) {
          console.warn(error)
          return
        }

        $form.find('.errors') && $form.find('.errors').remove();

        var errorDiv = document.createElement('div')
        errorDiv.classList.add('errors', 'text-center')

        errorDiv.textContent = error.message || error.description
        $form.find('.product-options').append(errorDiv)
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: product,
              addToCartBtn: $addToCart[0],
              drawer: 0
            },
          })
        )
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: error.description,
            },
          })
        )
      },
    })

    return ProductForm
  })()

  /**
   *
   * Popup class here: open, close, container
   */
  theme.Popop = {
    openHandlerClass: `.js-sign-up-open`,
    containerClass: `.newsletter-popup-open`,
    closeHandlerClass: `.newsletter-popup-close`,
  }
  /**
   *
   * @returns {[variantId]:[perOrder]}
   */
  theme.getPreOrderData = async () => {

    try {
      let res = await fetch(`https://app.vegogarden.com/info-three-d/goods-list?accessToken=llqDnQqqeG801Cmi2iEKjERdM5OQiBFX`)
      res = await res.json()
      const preOrder = res.data.items.reduce((res, item) => {
        item.variants.forEach(vItem => {
          if (vItem.pre_order_date) {
            //res[vItem.id] = formatDateText(+new Date(vItem.pre_order_date), 'DD/MM/YYYY')
            res[vItem.id] = ts2shortDateFormat(+new Date(vItem.pre_order_date))
          } else {
            res[vItem.id] = vItem.pre_order_title;
          }
        })
        return res;
      }, {})
      return preOrder;
    } catch (error) {
      console.log(error)
      return {}
    }
  }
  /**
   * handle a links in blog posts
   */
  theme.handleCa = () => {

    if (theme.isCA()) {
      let caProducts = [
        'vego-soil-saving-intermediate-floor-for-modern-garden-bed',
        '4-pack-17-tall-9-in-1-modular-metal-raised-garden-bed-kit',
        '4-pack-32-extra-tall-10-in-1-modular-metal-raised-garden-bed-kit',
        '4-pack-17-tall-10-in-1-modular-metal-raised-garden-bed-kit',
        '4-pack-17-tall-6-in-1-modular-metal-raised-garden-bed-kit',
        'arched-trellis-2-5-x-9-5-bundle-2-garden-beds-trellis',
        "9-in-1-modular-raised-garden-bed", "10-in-1-modular-metal-raised-garden-bed-kit",
        "32-extra-tall-10-in-1-modular-raised-garden-bed-kit",
        "32-tall-6-in-1-medium-novel-modular-metal-raised-garden-bed-kit",
        "32-tall-9-in-1-large-novel-modular-metal-raised-garden-bed-kit",
        "self-watering-rolling-tomato-planter-pot-with-trellis",
        "32-extra-tall-9-in-1-modular-raised-garden-bed-kit", "hi-flow-retractable-hose-reel-set-100", "17-tall-modern-raised-garden-bed-2783",
        "17-tall-6-in-1-novel-modular-metal-raised-garden-bed-kit",
        "17-tall-9-in-1-novel-modular-metal-raised-garden-bed-kit",
        "17-tall-10-in-1-novel-modular-metal-raised-garden-bed-kit",
        "32-tall-10-in-1-jumbo-novel-modular-metal-raised-garden-bed-kit",
        "retractable-hose-reel-set-130", "vego-garden-6-in-1-modular-raised-garden-bed-kit", "32-extra-tall-6-in-1-modular-raised-garden-bed-kit", "17-tall-modern-raised-garden-bed-2753", "17-tall-modern-raised-garden-bed-4283", "32-tall-modern-raised-garden-beds-4283", "32-tall-modern-raised-garden-beds-2783", "elevated-rolling-garden-bed", "garden-arch-trellis", "garden-bed-cover-systems", "17-tall-42-wide-round-metal-raised-garden-bed", "17-tall-4-in-1-modular-metal-raised-garden-bed-kit", "17-inch-tall-kids-first-raised-bed",
        "herb-garden-24-wide-17-tall-twin-pack",
        "32extra-tall-42-round-metal-garden-bed", "17-tall-modern-raised-garden-bed-4242",
        "32-tall-modern-raised-garden-beds-2753", "32-tall-modern-raised-garden-beds-4242", "32-tall-modern-raised-garden-beds-8383", "17-tall-modern-raised-garden-bed-8383", "modular-wall-trellis-system", "11-tall-9-in-1-modular-metal-raised-garden-bed-kit", "32-extra-tall-4-in-1-modular-raised-garden-bed-kit", "17-tall-u-shaped-raised-garden-bed-kit-jumbo-size", "17-tall-l-shaped-raised-garden-bed-kit-large-size", "cascading-raised-garden-bed-kit-standard-size", "17-tall-u-shaped-raised-garden-bed-kit-standard-size", "rolling-planter-twin-pack", "11-tall-10-in-1-modular-metal-raised-garden-bed-kit", "17-tall-l-shaped-raised-garden-bed-kit-standard-size", "self-watering-garden-bed", "17-tall-berry-garden-bed-30-wide-twin-pack", "vego-garden-cover-system-g2", "11-tall-4-in-1-modular-metal-raised-garden-bed-kit", "11-tall-6-in-1-modular-metal-raised-garden-bed-kit", "17-tall-u-shaped-raised-garden-bed-kit-large-size",
        "11-tall-42-wide-round-metal-raised-garden-bed-kit", "wicking-cells", "dragon-fruit-rolling-planter", "rolling-self-watering-garden-bed", "self-watering-planter", "vego-extension-kit-41-for-17-modern-raised-garden-beds", "vego-extension-kit-41-for-32-modern-raised-garden-beds",
        'solar-garden-light', 'rippled-solar-garden-light', 'elevated-garden-bed-2-by-4', 'elevated-garden-bed-2-x-6', 'elevated-garden-bed-2-x-8',
        'evergrove-raised-garden-bed-4-x-4', 'evergrove-raised-garden-bed-4-x-8', 'evergrove-raised-garden-bed-2-x-8', 'soil-saving-floor-for-32-classic-and-novel-beds',
        'the-vego-grow-light', 'the-vego-grow-light-stand', 'the-tabletop-grow-light-garden-1-tier', 'the-tabletop-grow-light-garden-2-tier', 'the-grow-light-garden-series-f4s-pro',
        'the-grow-light-garden-series-f4s', 'the-grow-light-garden-series-f4', 'the-grow-light-garden-series-f2',
        'elevated-garden-bed-v-series-2-x-4-with-wheels', 'elevated-garden-bed-v-series-2-x-6-with-wheels', 'elevated-garden-bed-v-series-2-x-8-with-wheels',
        "26-tall-9-in-1-modular-metal-raised-garden-bed-kit",
        '26-tall-10-in-1-jumbo-modular-metal-raised-garden-bed-kit',
        '26-tall-4-in-1-modular-metal-raised-garden-bed-kit',
        '26-tall-6-in-1-modular-metal-raised-garden-bed-kit',
        'modern-metal-compost-bin',
        'the-ezcube-planter-21-x-24',
        'the-ezcube-planter-21-x-48',
        'the-ezcube-planter-21-x-24-elevated',
        'the-ezcube-planter-21-x-48-elevated',
        'self-watering-herb-planter-box-with-trellis',
        'ez-home-planter',
        'ezcube-4-in-1-cover-and-trellis-system',
        'ezcube-cover-cage',
        'ezcube-elevated-rolling-planter-cart',
        'ezcube-extension-kit',
        'self-watering-wicking-floor',
        '4-in-1-trellis-cover-system',
        'trellis-and-cover-system-for-s-series',
        'vego-modern-privacy-trellis',
        'vego-irrigation-kit',
        'modern-in-bed-composter',
        'modular-compost-bin'

      ]
      let caCollections = [
        'gifts-under-400',
        'gifts-under-300',
        'gifts-under-200',
        'gifts-under-150',
        'gifts-under-100',
        'gifts-under-50',
        'on-sale',
        'garden-beds',
        'bundles',
        'help-me-choose',
        'elevated-garden-beds',
        'advanced-beds',
        'add-ons',
        'planters',
        'ezcube-planter',
        'vego-watering',
        'vego-composting',
        'all',
        'best-sellers',
        'novel-raised-garden-beds',
        'vego-garden-11-down-to-earth',
        'vego-garden-17-standard-kits',
        'extra-tall-32-raised-bed',
        'extension-kit',
        'rectangle-metal-raised-garden-beds',
        'round-metal-raised-garden-beds',
        'l-shaped-metal-raised-garden-beds',
        'u-shaped-metal-raised-garden-beds',
        'help-me-choose-add-ons',
        'classic-metal-raised-garden-beds',
        'retractable-hose-reel-set',
        'new-arrivals',
        'modern-metal-raised-garden-beds',
        'indoor-gardening',
        'evergrove-garden-bed',
        "composting",
        "vego-composting",
        "ezcube-planter",
        'vego-garden-26-standard-kits',
        'classic-novel-add-ons',
        'modern-add-ons',
        'elevated-add-ons',
        'grow-light-garden'
      ]

      let otherLinks = [
        //  '/pages/kids-program'
      ]
      // find product a link element exclude caProducts
      let excludeProductALinkEls = [...document.querySelectorAll('a')].filter(item => {
        let href = item.getAttribute('href');
        if (!href) return true
        if (href.indexOf('/products/') == -1 && href.indexOf('/collections') == -1 && !otherLinks.some(e => href.indexOf(e) > -1)) {
          return false
        }
        let contains = otherLinks.some(e => href.indexOf(e) > -1)
        if (contains) {
          return true
        }
        contains = caProducts.some(url => {
          return href.indexOf('/products/') > -1 && href.indexOf('products/' + url) > -1 // products
        })
        if (contains) {
          return false
        }
        contains = caCollections.some(url => {
          return href.indexOf('/collections') > -1 && href.indexOf('collections/' + url) > -1
        })
        return !contains
      })
      excludeProductALinkEls.forEach(el => {
        el.setAttribute('href', 'javascript:void(0)')
      })

    }

  }
  /**
   * unvalidate links handle, redirect to home page
   */
  theme.handleUnvalidLink = () => {
    if (Shopify.routes.root != '/') {
      let links = [`${Shopify.routes.root}collections/bundle-sale`, `${Shopify.routes.root}products/do-not-ship-item`]
      if (links.includes(location.pathname)) {
        window.location.href = `${Shopify.routes.root}`
      }
    }
  }
  /**
   * ## handle 3D param from 3D program
   *
   * https://vegogarden.com/?items=[id]:[quantity]:[pre-order]:[pre-order-date],[id]:[quatity]:[pre-order]:[pre-order-date]
   * eg: https://vegogarden.com/?items=39569223450659:1,39569223483427:1
   * 1. id: variant id
   * 2. quantity: quantity
   * 3. pre-order： is pre-order product，optional
   * 4. pre-order-date： pre-order ship date，optional
   */
  theme.handle3D = async () => {
    try {
      /**
       * @param {*} preOrderObj  {[variantId]:[perOrder]}
       * @returns
       */
      let t = new URLSearchParams(location.search)
      if (!t.get('items')) return; // no address 
      const gtmData = []
      let totalPrice = 0
      const getItems = (preOrderObj) => {
        let t = new URLSearchParams(location.search)
        let items = t.get('items')
        let threeD = t.get('ref_app')
        if (items) {
          let pItems = items.split(',').map((item, index) => {
            let variantId = item.split(':')[0];
            let itemData = [
              `items[${index}][id]=${variantId}`,
              `items[${index}][quantity]=${item.split(':')[1]}`,
              `items[${index}][properties][_${theme.TRHEE_D_KEY}]=${threeD}`,
            ];
            const gtmItemData = {
              item_id: variantId,
              quantity: item.split(':')[1] || 1,
              price: item.split(':')[2] ? item.split(':')[2] / 100 : 0
            }
            gtmData.push(gtmItemData)
            totalPrice += gtmItemData.price * gtmItemData.quantity
            if (preOrderObj[variantId]) {

              itemData.push(`items[${index}][properties][_is_fullfillDate]=Ships by: ` + preOrderObj[variantId])
              try {
                itemData.push(`items[${index}][properties][_is_fullfillDate_ts]=` + (new Date(preOrderObj[variantId]).getTime()) / 1000)
              } catch (error) {
                console.log(error)
              }
              //'Note: Pre-order item'
              itemData.push(`items[${index}][properties][_is_preorder]=Note: Pre-order item`)
            }
            return itemData;
          }, {})
          return pItems.flat(2);
        }
        return []
      }
      const preOrderData = await theme.getPreOrderData()
      window._preOrderData = preOrderData;

      let itemsObj = getItems(preOrderData)
      // window.gtag && window.gtag('event', '3d_checkout', {
      //   value: totalPrice,
      //   items: gtmData
      // })
      if (itemsObj.length) {
        theme.cart.addCart(itemsObj.join('&'))
          .then(() => {
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: {},
              })
            )
          })
          .catch(e => {
            if (e?.status == 422 && e.description) {
              alert(e.description)
            }
            console.log(alert)
          })
      }
    } catch (error) {
      console.log(error)
    }

  }
  /**
   * @deprecated
   */
  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true,
      }

      this.id = id
      this.modal = document.getElementById(id)

      if (!this.modal) {
        return false
      }

      this.modalContent = this.modal.querySelector('.modal__inner')

      this.config = Object.assign(defaults, options)
      this.modalIsOpen = false
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.modal
      this.isSolid = this.config.solid

      this.init()
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false')
        btn.addEventListener('click', this.open.bind(this))
      })

      this.modal.querySelectorAll(this.config.close).forEach((btn) => {
        btn.addEventListener('click', this.close.bind(this))
      })

      // Close modal if a drawer is opened
      document.addEventListener(
        'drawerOpen',
        function () {
          this.close()
        }.bind(this)
      )
    }

    Modal.prototype.open = function (evt) {
      evt.stopPropagation()
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false
      // don't open an opened modal
      if (this.modalIsOpen) {
        return
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault()
      } else {
        externalCall = true
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation()
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute(
          'aria-expanded',
          'true'
        )
      }

      if (this.modalIsOpen && !externalCall) {
        this.close()
      }

      this.modal.classList.add(this.config.openClass)

      document.documentElement.classList.add(this.config.bodyOpenClass)

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass)
      }

      this.modalIsOpen = true

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus',
      })

      if (evt.target.closest('.view-icon')) {
        var btn = evt.target.closest('.view-icon')
        if (btn.dataset.src) {
          var image = new Image()
          image.src = btn.dataset.src
          this.modal.querySelector('.modal__inner').classList.add('loading')
          image.onload = () => {
            this.modal.querySelector('img').src = btn.dataset.src
            this.modal.querySelector('.modal__inner').classList.remove('loading')
          }
        }
      }

      document.dispatchEvent(new CustomEvent('modalOpen', {
        detail: this.id
      }))
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id))

      this.bindEvents()
    }

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return
        }
      }

      // deselect any focused form elements
      document.activeElement.blur()

      this.modal.classList.remove(this.config.openClass)
      this.modal.classList.add(this.config.closingClass)

      document.documentElement.classList.remove(this.config.bodyOpenClass)
      document.documentElement.classList.add(this.config.bodyClosingClass)

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(
            this.config.bodyClosingClass
          )
          this.modal.classList.remove(this.config.closingClass)
          if (
            this.activeSource &&
            this.activeSource.getAttribute('aria-expanded')
          ) {
            this.activeSource.setAttribute('aria-expanded', 'false').focus()
          }
        }.bind(this),
        500
      ) // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(
          this.config.bodyOpenSolidClass
        )
      }

      this.modalIsOpen = false

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus',
      })

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id))

      this.unbindEvents()
    }

    Modal.prototype.bindEvents = function () {
      window.on(
        'keyup.modal',
        function (evt) {
          if (evt.keyCode === 27) {
            this.close()
          }
        }.bind(this)
      )

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this))
      }
    }

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off('.modal')

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal')
      }
    }

    return Modal
  })()


  theme.productForm = {
    updatePreOrder: function (optionSelect, productForm, variant) {
      if ($('a.klaviyo-bis-trigger-extra').length) {
        $('a.klaviyo-bis-trigger-extra').remove()
      }
      if (optionSelect.length) {
        const productForm = optionSelect.closest('form')
        const $addToCart = $('.add-to-cart, .klaviyo-bis-trigger', productForm)
        if (!optionSelect.val()) {
          const $textSoldOut = 'Notify me when available'
          if ($addToCart.find('span').length) {
            $addToCart.find('span').html($textSoldOut)
          } else if ($addToCart[0].tagName === 'BUTTON') {
            $addToCart.html($textSoldOut)
          } else if ($addToCart[0].tagName === 'INPUT') {
            $addToCart.val($textSoldOut)
          }
          $addToCart.addClass('klaviyo-bis-trigger').removeClass('add-to-cart').attr('type', 'button').show()
          $('.klaviyo-bis-trigger').each(function () {
            if (!$(this).hasClass('btn--secondary')) {
              $(this).remove()
            }
          })
          $('.bar-variant-qty, .mobile-sticky-add-qty').hide()
        } else {
          var $option = $(
            'option[value=' + optionSelect.val() + ']',
            optionSelect
          );
          const preorder = $option.data('preorder')
          var fulfillmentTs = $option.data('fulfillmentTs')
          let $textPreOrder = 'Pre-Order'
          let $textAddtoCart = 'Add to Cart'
          $('.gPreorderProperty', productForm).remove()
          $('.gFullfillTsProperty', productForm).remove()
          if (preorder && !theme.isAu()) {
            if (fulfillmentTs) {
              var duration = fulfillmentTs - Math.round(Date.now() / 1000)
              if (duration > 0) {
                if (duration < 691200) {
                  $textPreOrder = $textAddtoCart
                } else if (duration < 1296000) {
                  $textPreOrder = $textAddtoCart
                }
              } else {
                $textPreOrder = $textAddtoCart
              }
              productForm.append(
                '<input type="hidden" class="gFullfillTsProperty" name="properties[_is_fullfillDate_ts]" value="' + fulfillmentTs + '">'
              )
            }
            productForm.append(
              '<input type="hidden" class="gPreorderProperty" name="properties[_is_preorder]" value="Note: Pre-order item">'
            )
            $('.gFullfillProperty', productForm).val(
              // "Ships by: " + formatDateText(fulfillmentTs * 1000, 'DD/MM/YYYY')
              "Ships by: " + ts2shortDateFormat(fulfillmentTs * 1000)
            )
            if ($addToCart.find('span').length) {
              $addToCart.find('span').html($textPreOrder)
            } else if ($addToCart[0].tagName === 'BUTTON') {
              $addToCart.html($textPreOrder)
            } else if ($addToCart[0].tagName === 'INPUT') {
              $addToCart.val($textPreOrder)
            }
            if ($('.shopify-payment-button', productForm).text().toUpperCase().indexOf('BUY IT NOW') == -1) {
              $('.shopify-payment-button', productForm).hide()
            }
            $('.discount-info--btn-text').text($textPreOrder)
          } else {
            $('.gFullfillProperty', productForm).val(
              "In Stock"
            )
            if ($addToCart.find('span').length) {
              $addToCart.find('span').html($textAddtoCart)
            } else if ($addToCart[0].tagName === 'BUTTON') {
              $addToCart.html($textAddtoCart)
            } else if ($addToCart[0].tagName === 'INPUT') {
              $addToCart.val($textAddtoCart)
            }

            $('.shopify-payment-button', productForm).css('display', '')
            $('.discount-info--btn-text').text($textAddtoCart)
          }
          $addToCart.addClass('add-to-cart').removeClass('klaviyo-bis-trigger').attr('type', 'submit').show()
          $('.bar-variant-qty, .mobile-sticky-add-qty').show()
        }
      } else {
        const $addToCart = $('.add-to-cart, .klaviyo-bis-trigger', productForm)
        const $textSoldOut = 'Notify me when available'
        if ($addToCart.find('span').length) {
          $addToCart.find('span').html($textSoldOut)
        } else if ($addToCart[0].tagName === 'BUTTON') {
          $addToCart.html($textSoldOut)
        } else if ($addToCart[0].tagName === 'INPUT') {
          $addToCart.val($textSoldOut)
        }
        $addToCart.addClass('klaviyo-bis-trigger').removeClass('add-to-cart').attr('type', 'button').show()
        $('.klaviyo-bis-trigger').each(function () {
          if (!$(this).hasClass('btn--secondary')) {
            $(this).remove()
          }
        })
        $('.bar-variant-qty, .mobile-sticky-add-qty').hide()
      }
    },
    preOrder: function (target) {
      const productForm = $(target).closest('form.product-single__form')
      if (productForm.length) {
        const optionSelect = $('select[data-type=preOrder]', productForm)
        theme.productForm.updatePreOrder(optionSelect, productForm)
      }
    },
    updateProductPoints: function (variant) {
      
      if ($('.page-product-v2').length && $('.service-highlight-item-loyalty').length) {
        var qty = $(".product-single__meta input.js-qty__num").val()
        
        var total = Math.floor(variant.price / 100) * qty * 2 * 100
        var totalText = (total / 100).toFixed(0)
        $('.service-highlight-item-loyalty .service-highlight-text').html(`Earn ${totalText}<br> Points`)
        $('.yotpo-product-points-widget-points-amount').html(`${totalText} points`)
      }
    },
  }

  /**
   * re-render option
   */
  theme.reRenderOption = () => {
    try {
      if (!theme.isMobile()) {
        $('.you-might-also-like .vego-cart-recommend-item:not(:nth-child(3)) select.grid-product-variant-input:enabled').vselect()
        $('.you-might-also-like .vego-cart-recommend-item:nth-child(3) select.grid-product-variant-input:enabled').vselect({
          placement: 'top'
        })
      } else {
        $(
          '.you-might-also-like select.grid-product-variant-input:enabled'
        ).vselect()
      }
      $('.you-might-also-like  [data-ui="select"]').vselect()
    } catch (e) {
      console.log(e)
    }
  }
  /**
   * @deprecated
   * @param {*} total 
   * @returns 
   */
  // theme.judgeDiscount = (total = 0) => {
  //   const range = [24900, 39900, 49900];
  //   // margin: value that far from next level, index: level index
  //   const res = { index: -1, margin: 0 }
  //   range.forEach((item, index) => {
  //     if (total >= item) {
  //       res.index = index;
  //       res.margin = range[index] - total;
  //     }
  //   })
  //   return res;
  // }
  theme.getMaxHeight = () => {
    let savedHeight = parseFloat(document.body.dataset.sheight ?? `${window.innerHeight}`)
    let maxHeight = Math.max(savedHeight, window.innerHeight)
    document.body.setAttribute('data-sheight', maxHeight)
    return maxHeight;
  }




  // fix mobile menu issue
  // document.querySelector('#NavDrawer .mobile-nav').addEventListener("scroll", () => {
  //   setTimeout(() => {
  //     if (window.location.hash && theme.isMobile()) window.history.pushState({}, '', window.location.pathname);
  //   }, 500)
  // });
  theme.collapsibles = (function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
    }

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
    }

    var namespace = '.collapsible'

    var isTransitioning = false

    function init(scope) {
      var el = scope ? scope : document
      el.querySelectorAll(selectors.trigger).forEach((trigger) => {
        var state = trigger.classList.contains(classes.open)
        trigger.setAttribute('aria-expanded', state)
        trigger.on('click' + namespace, toggle)
      })
    }
    function scrollToActiveMenu(target) {

      if (theme.isMobile()) {

        setTimeout(() => {
          let tIndex = 0;
          try {
            let target_ = target
            if (target_.tagName == 'DIV') target_ = target_.closest('li')
            Array.from(target_.closest('ul').children)
              .forEach((item, index) => {
                let h = window.getComputedStyle(item).getPropertyValue('height').replace('px', '')
                if (item == target_) {
                  target_.closest('ul').scrollTo({
                    top: tIndex * 67
                  })
                }
                if (h != 'auto') {
                  tIndex++
                }

              })
          } catch (e) {
            console.log(e)
          }
        }, 340)

      }
    }
    function toggle(evt, skipCloseSiblings = false) {
      if (isTransitioning) {
        return
      }

      isTransitioning = true

      var el = evt.currentTarget
      var isOpen = el.classList.contains(classes.open) // already opened or not

      /**
       * close other menu item for openning the current menu
       */
      if (!isOpen) {
        const $btn = $(
          '.mobile-nav .mobile-nav__item .mobile-nav__has-sublist .mobile-nav__toggle button[type="button"], .drawer-menu-collapsible-nav .collapsible-trigger'
        )
        const $content = $('.mobile-nav .mobile-nav__item .collapsible-content, .drawer-menu-collapsible-nav .collapsible-content')
        $btn.attr('aria-expanded', false).removeClass('is-open')
        $content.removeClass('is-open').css('height', 0)
      }

      var moduleId = el.getAttribute('aria-controls')
      var container = document.getElementById(moduleId)
      if (!container) {
        isTransitioning = false
        return
      }
      var height = container.querySelector(selectors.moduleInner).offsetHeight
      var isAutoHeight = container.classList.contains(classes.autoHeight)
      var parentCollapsibleEl = container.parentNode.closest(selectors.module)
      var childHeight = height

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0
          setTransitionHeight(container, height, isOpen, isAutoHeight)
        }, 0)
      } else {
        scrollToActiveMenu(container)
      }

      if (isOpen && !isAutoHeight) {
        height = 0
      }

      el.setAttribute('aria-expanded', !isOpen)
      if (isOpen) {
        el.classList.remove(classes.open)
      } else {
        if (!skipCloseSiblings) {
          $(el)
            .closest('li')
            .siblings('li')
            .each((index, item) => {
              if ($(item).find('button.is-open').length) {
                toggle(
                  { currentTarget: $(item).find('button.is-open')[0] },
                  true
                )
              }
            })
        }
        el.classList.add(classes.open)
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight)

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false)
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview')
        if (!btn) {
          return
        }
        btn.off('click' + namespace)
        btn.on('click' + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight
          setTransitionHeight(container, height, isOpen, isAutoHeight)
        })
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide)
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + 'px'
        if (isOpen) {
          container.classList.remove(classes.open)
        } else {
          container.classList.add(classes.open)
        }
      })

      if (!isOpen && isAutoHeight) {
        var o = container
        window.setTimeout(function () {
          o.css('height', 'auto')
          isTransitioning = false
        }, 500)
      } else {
        isTransitioning = false
      }
    }

    return {
      init: init,
    }
  })()


  // ===============   END    Search result list

  // ===============   BEGIN    Products Bundle

  /**
   * bundle app here
   */
  theme.BundleProducts = (function () {
    const SELETOR = {
      bundleAdd: `.bundle-add`,
      group: `.bundle-group`,
      productClass: `.bundle-product`,
      priceBunlde: `.bundle-price`,
      priceBunldeOriginal: `.bundle-original-price`,
      priceBunldeSave: `.bundle-save-price`,
    }

    return {
      init: () => {
        try {
          //no bundle add find
          if (!$(SELETOR.bundleAdd).length) return
          //init price
          $(SELETOR.group).each((index, group) => {
            let total = 0
            $(SELETOR.productClass, group).each((productIndex, product) => {
              if (!!$(product).find(`[data-count]`).length)
                total +=
                  parseInt($(product).find(`[data-count]`).data('count')) *
                  parseFloat(
                    $(product)
                      .find('.grid-product__price')
                      .text()
                      .replace('from', '')
                      .replace('$', '')
                      .trim()
                  )
            })
            $('.page-section-products .variant-radio  .color-swatch__label ', group).click((e) => {
              const colorLabel = $(e.currentTarget).text().trim()
              $(e.currentTarget).closest('.bundle-group').find(`.grid-product-variant-title__right`).html(colorLabel)
              $(e.currentTarget).closest('.bundle-group').find(`.page-section-box [value="${colorLabel}"]`)
                .each((index, item) => {
                  $(item).siblings('label').click()
                })
            })

            let save = (saveStr = $(group).find(`[data-save]`).data('save'))
            if (`${save}`.indexOf('%') > -1) {
              save = total * (parseInt(`${save}`.replace('%', '')) / 100)
            } else {
              save = parseFloat(save)
            }

            //
            $(group)
              .find(SELETOR.priceBunldeOriginal)
              .html(`$` + total.toFixed(2))
            $(group)
              .find(SELETOR.priceBunlde)
              .html(`$` + (total - save).toFixed(2));

            $(group)
              .find(SELETOR.priceBunldeSave)
              .html(
                `Save Extra ` +
                (`${saveStr}`.indexOf('%') > -1
                  ? saveStr
                  : `$${parseInt(saveStr).toFixed(2)}`) + ` ` + $(group).find(SELETOR.priceBunldeSave).data('extramsg')
              )
          })

          $(SELETOR.bundleAdd).click(async (e) => {
            const itemsObj = []
            $(e.target)
              .closest(SELETOR.group)
              .find(SELETOR.productClass)
              .map((index, product) => {
                const $form = $(product).find('form'),
                  $count = $(product).find('[data-count]').data('count')
                if (!$form.find('[name="quantity"]').length) {
                  $form.append(
                    `<input type="hidden" name="quantity" value="${$count}" />`
                  )
                } else {
                  $form.find('[name="quantity"]').val($count)
                }
                if ($(product).find('form').length) {
                  itemsObj.push(
                    `items[${index}][id]=${$(product)
                      .find('form')
                      .find('[name="id"]')
                      .val()}`
                  )
                  itemsObj.push(`items[${index}][quantity]=${$count}`)

                  //fulfill date
                  let $fulFillDate = $(product).find(
                    '[name="properties[_is_fullfillDate]"]'
                  )
                  if ($fulFillDate.length) {
                    itemsObj.push(
                      `items[${index}][properties][_is_fullfillDate]=${$fulFillDate.val()}`
                    )
                  }

                  //pro order
                  let $preOrder = $(product).find(
                    '[name="properties[_is_preorder]"]'
                  )
                  if ($preOrder.length) {
                    itemsObj.push(
                      `items[${index}][properties][_is_preorder]=${$preOrder.val()}`
                    )
                  }

                  //add bundle tag
                  const $bundleEle = $(product)
                    .find('form')
                    .find('[bundle-type]')
                  itemsObj.push(
                    `items[${index}][properties][_${$bundleEle.val()}]=` +
                    $bundleEle.val()
                  )
                }
              })
            theme.cart.addCart(itemsObj.join('&')).then(() => {
              document.dispatchEvent(
                new CustomEvent('ajaxProduct:added', {
                  detail: {
                    addToCartBtn: e.target,
                  },
                })
              )
            })
          })
          document.addEventListener(BUNDLE_CHANGE_VARIANT, e => {
            let $text = e.detail;
            let $form = $(e.target).closest('.bundle-group').find(`[value="${$text}"]`).closest('form');
            let $json = formatChangeReturnDiscount(JSON.parse($form.find('.variant-json').text()))
            let $itemId = $json.find(item => item.title == $text).id;
            $form.find('[name="id"]').val($itemId);
          });

        } catch (e) {
          console.log(`BUNDLE ERROR:` + e)
        }
      },
    }
  })()

  // ===============   END      Products Bundle



  theme.ProductMedia = (function () {
    var modelJsonSections = {}
    var models = {}
    var xrButtons = {}

    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]',
    }

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false,
      }

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId
        var modelViewerElement = container.querySelector('model-viewer')
        var modelId = modelViewerElement.dataset.modelId

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup)
          var xrButton = mediaGroup.querySelector(selectors.xrButton)
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId,
          }
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement,
        }
      })

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr,
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi,
        },
      ])

      theme.LibraryLoader.load('modelViewerUiStyles')
    }

    function setupShopifyXr(errors) {
      if (errors) return

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function () {
          setupShopifyXr()
        })
        return
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId]

          if (modelSection.loaded) continue

          var modelJson = document.querySelector('#ModelJson-' + sectionId)

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML))
          modelSection.loaded = true
        }
      }
      window.ShopifyXR.setupXRElements()
    }

    function setupModelViewerUi(errors) {
      if (errors) return

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key]
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element)
          }
          setupModelViewerListeners(model)
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId]

      model.container.addEventListener('mediaVisible', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId)
        if (theme.config.isTouch) return
        model.modelViewerUi.play()
      })

      model.container.addEventListener('mediaHidden', function () {
        xrButton.element.setAttribute(
          'data-shopify-model3d-id',
          xrButton.defaultId
        )
        model.modelViewerUi.pause()
      })

      model.container.addEventListener('xrLaunch', function () {
        model.modelViewerUi.pause()
      })
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key]
          if (model.sectionId === sectionId) {
            delete models[key]
          }
        }
      }
      delete modelJsonSections[sectionId]
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels,
    }
  })()

  theme.chatBot = {
    openChat: () => {
      window.fcWidget.open()
      window.fcWidget.show()
    },
  }
  /**
   * happy customer
   */
  theme.happyCustomers = (function () {
    var args = {
      autoPlay: 10000,
      adaptiveHeight: true,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left',
      pageDots: true,
    }
    var bar
    var flickity

    function init() {
      bar = document.getElementById('happy-customer')
      if (!bar) {
        return
      }

      unload()

      if (bar.dataset.blockCount === 1) {
        return
      }

      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider()
      }

      document.addEventListener('matchSmall', function () {
        unload()
        initSlider()
      })

      document.addEventListener('unmatchSmall', function () {
        unload()
        if (bar.dataset.compact === 'true') {
          initSlider()
        }
      })
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args)
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id)
      var index = parseInt(slide.dataset.index)

      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index)
        flickity.pause()
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play()
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy()
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload,
    }
  })()
  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left',
    }
    var bar
    var flickity = []

    function init() {
      bar = $('.announcement-slider')
      if (!bar.length) {
        return
      }
      unload()

      bar.each(function (i, e) {
        $(this).attr('data-version', i)
        if (this.dataset.blockCount === 1) {
          return
        }
        if (theme.config.bpSmall || this.dataset.compact === 'true') {
          initSlider(this, i)
        }
      })


      document.addEventListener('matchSmall', function () {
        unload()
        bar.each(function (i, e) {
          initSlider(this, i)
        })
      })

      document.addEventListener('unmatchSmall', function () {
        unload()
        bar.each(function (i, e) {
          if (this.dataset.compact === 'true') {
            initSlider(this, i)
          }
        })
      })
    }

    function initSlider(instance, version) {

      /**
       * Judage countdown exists and split countdown to another slide for announcement bar
       **/
      if (theme.isMobile()) {
        $(instance).find('.announcement-slider__slide .count-down-component').each(function () {
          let time = theme.getTimeDiff($(this))
          if (!time.expire && time.isStart) {
            // $(instance).find(".announcement-text .activity-span").remove();

            /**
             let currentSlide = countdown.closest('.announcement-slider__slide')
            let t = currentSlide.cloneNode(true)
            countdown.remove()
            t.setAttribute('id', 'AnnouncementSlide-clone')
            t.classList = [...t.classList].filter(item => item != 'is-selected').join(' ')

            t.querySelector('.count-down-component').nextElementSibling.remove()
            var parent = currentSlide.parentNode;
            if (parent.lastChild == currentSlide) {
            parent.appendChild(t);
            }
            else {
            parent.insertBefore(t, currentSlide.nextSibling);
            }
            */
          }
        })
        //flickity[version] = new theme.Slideshow(instance, args)
      }

      let prevArrow = `<button type="button" class="slick-prev announcement-bar-btn" role="button"><span class="sr-only">previous</span><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_593_3564)"><path d="M5.5 1.5L0.999995 6.00001L5.5 10.5" stroke="#FEF9EB" stroke-width="1.47059" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_593_3564"><rect width="7" height="12" fill="white" transform="matrix(-1 0 0 1 7 0)"/></clipPath></defs></svg></button>`;
      let nextArrow = `<button type="button" class="slick-next announcement-bar-btn" role="button"><span class="sr-only">previous</span><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_593_3588)"><path d="M1.5 1.5L6 6.00001L1.5 10.5" stroke="#FEF9EB" stroke-width="1.47059" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_593_3588"><rect width="7" height="12" fill="white"/></clipPath></defs></svg></button>`;
      if (
        $("#AnnouncementSlider").children().length > 1 &&
        !theme.isAu() &&
        !theme.isCa()
      )
        $("#AnnouncementSlider").slick({
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            //fade:true,
            prevArrow,
            nextArrow,
            verticalSwiping: true,
            vertical: true,
            // responsive: [
            //   {
            //     breakpoint: 768,
            //     settings: {
            //       prevArrow,
            //       nextArrow,
            //       draggable: true,
            //       adaptiveHeight: false,
            //       slidesToShow: 1,
            //       slidesToScroll: 1,
            //       centerMode: true,
            //     },
            //   },
            // ],
          });

    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.find('#AnnouncementSlide-' + id)
      var index = parseInt(slide.data('index'))
      var thisBar = slide.closest('.announcement-slider')
      var flickityItem = flickity[thisBar.attr('version')]
      if (flickityItem && typeof flickityItem.pause === 'function') {
        flickityItem.goToSlide(index)
        flickityItem.pause()
      }
    }

    function onBlockDeselect() {
      flickity.forEach(function (e) {
        if (typeof e.play === 'function') {
          e.play()
        }
      })
    }

    function unload() {
      flickity.forEach(function (e) {
        if (typeof e.destroy === 'function') {
          e.destroy()
        }
      })
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload,
    }
  })()

  theme.parallaxSections = {}
  /**
   * @deprecated
   */
  theme.Parallax = (function () {
    var speed = 0.85
    var reset = false

    function parallax(container, args) {
      this.isInit = false
      this.isVisible = false
      this.container = container
      this.image = container.querySelector('.parallax-image')
      this.namespace = args.namespace
      this.desktopOnly = args.desktopOnly

      if (!this.container || !this.image) {
        return
      }

      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener(
          'matchSmall',
          function () {
            this.destroy()
          }.bind(this)
        )

        document.addEventListener(
          'unmatchSmall',
          function () {
            this.init(true)
          }.bind(this)
        )
      }

      this.init(this.desktopOnly)
    }

    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function (desktopOnly) {
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy()
        }

        this.isInit = true

        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return
        }

        // Set position on page load
        this.setSizes()
        this.scrollHandler()

        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              this.isVisible = entry.isIntersecting
              if (this.isVisible) {
                window.on('scroll' + this.namespace, this.onScroll.bind(this))
              } else {
                window.off('scroll' + this.namespace)
              }
            })
          },
          { rootMargin: '200px 0px 200px 0px' }
        )

        observer.observe(this.container)

        window.on(
          'resize' + this.namespace,
          theme.utils.debounce(250, this.setSizes.bind(this))
        )

        document.addEventListener(
          'shopify:section:reorder',
          theme.utils.debounce(250, this.onReorder.bind(this))
        )
      },

      onScroll: function () {
        if (!this.isVisible) {
          return
        }

        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes()
          reset = true
        }

        requestAnimationFrame(this.scrollHandler.bind(this))
      },

      scrollHandler: function () {
        var shiftDistance = (window.scrollY - this.elTop) * speed
        //this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
      },

      setSizes: function () {
        var rect = this.container.getBoundingClientRect()
        this.elTop = rect.top + window.scrollY
      },

      onReorder: function () {
        this.setSizes()
        this.onScroll()
      },

      destroy: function () {
        this.image.style.transform = 'none'
        window.off('scroll' + this.namespace)
        window.off('resize' + this.namespace)
      },
    })

    return parallax
  })()

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active',
    }

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause',
    }

    var productSelectors = {
      thumb: '.product__thumb-item:not(hide)',
      links: '.product__thumb-item:not(hide) a',
      arrow: '.product__thumb-arrow',
    }

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      fade: false,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      setGallerySize: true,
      wrapAround: true,
    }

    function slideshow(el, args) {
      this.el = el
      this.args = Object.assign({}, defaults, args)

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this),
      }

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(
          productSelectors.thumb
        )
        this.childNavLinks = this.args.childNav.querySelectorAll(
          productSelectors.links
        )
        this.arrows = this.args.childNav.parentElement.querySelectorAll(
          productSelectors.arrow
        )
        if (this.childNavLinks.length) {
          this.initChildNav()
        }
        // Setup optional arrows
        if (this.arrows && this.arrows.length) {
          this.arrows.forEach((arrow) => {
            arrow.addEventListener('click', this.arrowClick.bind(this))
          })
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el)
      }

      this.slideshow = new Flickity(el, this.args)
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper)
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton)
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this))
        }
      }

      // Reset dimensions on resize
      window.on(
        'resize',
        theme.utils.debounce(
          300,
          function () {
            this.resize()
          }.bind(this)
        )
      )

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return
        var firstChild = el.firstChild
        while (firstChild != null && firstChild.nodeType == 3) {
          // skip TextNodes
          firstChild = firstChild.nextSibling
        }
        var style = document.createElement('style')
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`
        document.head.appendChild(style)
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide)

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit()
          }
        }

        //@deprecated
        AOS?.refresh()
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade) {
          this.currentSlide.classList.add(classes.animateOut)
          this.currentSlide.addEventListener(
            'transitionend',
            function () {
              this.currentSlide.classList.remove(classes.animateOut)
            }.bind(this)
          )
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index)
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index)
          }
        }

        // Show/hide arrows depending on selected index
        // if (this.arrows && this.arrows.length) {
        //   this.arrows[0].classList.toggle('hide', index === 0)
        //   this.arrows[1].classList.toggle(
        //     'hide',
        //     index === this.childNavLinks.length - 1
        //   )
        // }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
            slide.classList.remove(classes.animateOut)
          })
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide)

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex)
        }
      },
      destroy: function () {
        this.slideshow.destroy()
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused)
          this.slideshow.playPlayer()
        } else {
          this.pauseBtn.classList.add(classes.isPaused)
          this.slideshow.pausePlayer()
        }
      },
      resize: function () {
        this.slideshow.resize()
      },
      play: function () {
        this.slideshow.playPlayer()
      },
      pause: function () {
        this.slideshow.pausePlayer()
      },
      goToSlide: function (i) {
        this.slideshow.select(i, false, true)
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable
        this.slideshow.updateDraggable()
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex]?.classList.add('is-active')
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i)
          link.addEventListener('click',
            function (evt) {
              evt.preventDefault()
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }.bind(this)
          )
          link.addEventListener(
            'focus',
            function (evt) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }.bind(this)
          )
          link.addEventListener(
            'keydown',
            function (evt) {
              if (evt.keyCode === 13) {
                this.goToSlide(this.getChildIndex(evt.currentTarget))
              }
            }.bind(this)
          )
        })
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index)
      },

      childNavGoTo: function (index) {
        if (!this.childNavLinks.length) {
          return
        }
        this.childNavLinks.forEach((a) => {
          a.classList.remove(classes.isActive)
        })

        var el = this.childNavLinks[index]
        el.classList.add(classes.isActive)
        if (this.args.childVertical) {
          var elTop = el.offsetTop
          this.args.childNavScroller.scrollTop = elTop - 100
        } else {
          var elLeft = el.offsetLeft
          this.args.childNavScroller.scrollLeft = elLeft - 100
        }
        if (window.innerWidth < 768) {
          var elLeft = el.offsetLeft
          this.args.childNavScroller.scrollLeft = elLeft - 70
        }
      },

      arrowClick: function (evt) {
        if (
          evt.currentTarget.classList.contains('product__thumb-arrow--prev')
        ) {
          this.slideshow.previous()
        } else {
          this.slideshow.next()
        }
      },
    })

    return slideshow
  })()

  /**
   * @deprecated
   * @returns 
   */
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer

    var videoHolderId = 'VideoHolder'
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound',
    }

    var youtubeTriggers = document.querySelectorAll(selectors.youtube)
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger)

    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return
    }

    var videoHolderDiv = document.getElementById(videoHolderId)

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk')
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true,
    })

    youtubeTriggers.forEach((btn) => {
      btn.addEventListener('click', triggerYouTubeModal)
    })

    mp4Triggers.forEach((btn) => {
      btn.addEventListener('click', triggerMp4Modal)
    })

    document.addEventListener('modalClose.VideoModal', closeVideoModal)

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return
      }

      evt.preventDefault()
      emptyVideoHolder()

      modal.open(evt)

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'))
      youtubePlayer = new theme.YouTube(videoHolderId, {
        videoId: videoId,
        style: 'sound',
        events: {
          onReady: onYoutubeReady,
        },
      })
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder()

      var el = evt.currentTarget
      var player = el.parentNode.querySelector(selectors.mp4Player)

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true)
      playerClone.classList.remove('hide')

      videoHolderDiv.append(playerClone)
      modal.open(evt)

      // Play new video element
      videoHolderDiv.querySelector('video').play()
    }

    function onYoutubeReady(evt) {
      evt.target.unMute()
      evt.target.playVideo()
    }

    function getYoutubeVideoId(url) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
      var match = url.match(regExp)
      return match && match[7].length == 11 ? match[7] : false
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = ''
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy()
      } else {
        emptyVideoHolder()
      }
    }
  }

  // clear number when you want to clear cart item
  const CLEAR_NUM = -1
  theme.QtySelector = (function () {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus',
      clear: '.js-qty__adjust--minus-0', //clear cart item
    }

    function QtySelector(el, options) {
      this.wrapper = el
      this.plus = el.querySelector(selectors.plus)
      this.minus = el.querySelector(selectors.minus)
      this.clear = $(el).closest('.ajaxcart__row').find(selectors.clear)[0]
      this.input = el.querySelector(selectors.input)
      this.minValue = this.input.getAttribute('min') || 1

      var defaults = {
        namespace: null,
        key: this.input.dataset.id,
      }

      this.options = Object.assign({}, defaults, options)

      this.init()
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      getKey: function (keyStr) {
        let key = keyStr;
        if (key) {
          key = key.split(':')[0];
          if (document.querySelectorAll(`.cart-area-items-data [data-v-id="${key}"]`).length != 1) {
            key = keyStr;
          }
        }
        return key;
      },
      init: function () {
        let that = this;
        /**
         * Stop submitting form when click enter key on mouse focusing on quantity input field
         */
        this.input.addEventListener('keydown', (evt) => {
          if (evt.which == 13) {
            evt.preventDefault();
            evt.stopPropagation();
            return false;
          }
        })

        if (!this.plus.getAttribute('inited')) {
          this.plus.setAttribute('inited', true)
          this.plus.addEventListener(
            'click',
            function (e) {
              if (this.clear) {
                if (this.plus.classList.contains('btn--loading')) return;
              }
              window.cartPlusMinusQty = 1; // flag to plus
              var qty = this._getQty()
              this.input.value = qty + 1;
              let rowEl = e.target.closest('.ajaxcart__product')
              if (rowEl) {
                let key = that.getKey(rowEl.dataset.key);
                this._change(qty + 1, key, this.plus)
              } else {
                this._change(qty + 1, '', this.plus)
              }
            }.bind(this)
          )
        }
        if (!this.minus.getAttribute('inited')) {
          this.minus.setAttribute('inited', true)
          this.minus.addEventListener(
            'click',
            function (e) {

              if (this.clear) {
                if (this.plus.classList.contains('btn--loading')) return;
              }
              window.cartPlusMinusQty = -1;  // flag to minus
              var qty = this._getQty()
              this.input.value = qty - 1 < 0 ? 0 : qty - 1;         // set quatity
              let rowEl = e.target.closest('.ajaxcart__product')

              if (rowEl) {
                let key = that.getKey(rowEl.dataset.key);
                this._change(qty - 1, key, this.minus)
              } else {
                this._change(qty - 1, '', this.minus)
              }
            }.bind(this)
          )
        }

        /**
         * clear cart item
         */
        this.clear &&
          this.clear.addEventListener(
            'click',
            function (e) {
              let ap = arguments[0].target?.closest?.('.ajaxcart__product').dataset
              let href = arguments[0].target?.closest?.('.ajaxcart__product')?.querySelector?.('a').getAttribute?.('href')

              ///      DISABLE AUTO ADD TO CART     ///
              if (href && href.indexOf("free-microgreens-planter-gift") > -1) {
                localStorage.setItem(
                  "disable-auto-add-cart",
                  ts2shortDateFormat()
                );
                document
                  .querySelector(".free-gift-progress-pic")
                  ?.classList?.add?.("disable-auto-add-cart");
              }
              //
              //debugger;
              let key = that.getKey(ap.key);
              //let key = ap.key ?? ap.vId ?? this.options.key
              document.dispatchEvent(
                new CustomEvent('cart:quantity' + this.options.namespace, {
                  detail: [key, CLEAR_NUM],
                })
              )
            }.bind(this)
          )
        let getQuantityAndKey = (e) => {
          let key = e.target?.closest?.(".ajaxcart__product")?.dataset.key;
          let prev_quantity = window.cartData.items.find(
            (item) => item.key == key
          )?.quantity;
          let quantity = this._getQty();
          window.cartPlusMinusQty = quantity - prev_quantity;
          return { quantity, key }
        }
        this.input.addEventListener(
          'change', (function (e) {
            let res = getQuantityAndKey(e);
            // let key = e.target?.closest?.(".ajaxcart__product")?.dataset.key;
            // let prev_quantity = window.cartData.items.find((item) => item.key == key)?.quantity;
            // let quantity = this._getQty()
            // window.cartPlusMinusQty = quantity - prev_quantity;
            this._change(res.quantity, res.key);
          }.bind(this))
        )
        this.input.addEventListener(
          'blur', (function (e) {
            let res = getQuantityAndKey(e);
            this._change(res.quantity, res.key);
          }.bind(this))
        )
      },

      _getQty: function () {
        var qty = this.input.value
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1
        }
        return parseInt(qty)
      },
      //_plusMinusLoading: false, // whether handling plus/minus or not.
      _change: theme.utils.debounce(700, (function (qty, key, el) {
        // if(this.plus.classList.contains('btn--loading')||this.minus.classList.contains('btn--loading')) return;
        if (this.plus.classList.contains('btn--loading') || this.minus.classList.contains('btn--loading')) {
          //   this._plusMinusLoading = true
          // } else {
          // _this.plus.classList.remove('btn--loading')
          // _this.minus.classList.remove('btn--loading')
          return;
        } else {
          if (el && this.clear) el.classList.add('btn--loading')
        }
        let _this = this
        if (qty <= this.minValue) {
          qty = this.minValue
        }
        this.input.value = qty

        if (this.clear) {
          theme.cart.getCart()
            .then(res => {
              let idsAndKeysIncart = res.items.map(item => [`${item.id}`, item.key,]).flat(1)
              /**
               * exclude id or key no exist in cart
               */
              if (!idsAndKeysIncart.includes(key)) {
                //setTimeout(() => { _this._plusMinusLoading = false; }, 500)
                _this.plus.classList.remove('btn--loading')
                _this.minus.classList.remove('btn--loading')
                return
              }
              if (_this.options.onChange) {
                this.options.onChange.call(_this, qty)
              }
              ///setTimeout(() => { _this._plusMinusLoading = false; }, 500)
              document.dispatchEvent(
                new CustomEvent('cart:quantity' + _this.options.namespace, {
                  detail: [key, qty],
                  //detail: [this.options.key, qty],
                })
              )

            })
            .catch(err => {
              //setTimeout(() => { _this._plusMinusLoading = false; }, 500)
              document.dispatchEvent(
                new CustomEvent('cart:quantity' + _this.options.namespace, {
                  detail: [key, qty],
                  //detail: [this.options.key, qty],
                })
              )
            })
            .finally(() => {
              //   _this.plus.classList.remove('btn--loading')
              // _this.minus.classList.remove('btn--loading')
            })
        } else {
          if (_this.options.onChange) {
            this.options.onChange.call(_this, qty)
          }
          document.dispatchEvent(
            new CustomEvent('cart:quantity' + _this.options.namespace, {
              detail: [key, qty],
              //detail: [this.options.key, qty],
            })
          )
        }
      })),
    })

    return QtySelector
  })()


  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name,
      }

      this.nodes = {
        page: document.querySelector('#MainContent'),
      }

      this.drawer = document.querySelector('#' + id)
      this.isOpen = false
      this.isSearchOpen = false

      if (!this.drawer) {
        return
      }

      this.init()
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach((openBtn) => {
          openBtn.setAttribute('aria-expanded', 'false')
          openBtn.addEventListener('click', this.open.bind(this))
        })

        if (this.drawer
          .querySelector(this.config.close)) {
          this.drawer
            .querySelector(this.config.close)
            .addEventListener('click', this.close.bind(this))
        }

        // Close modal if a drawer is opened
        document.addEventListener(
          'modalOpen',
          function () {
            this.close()
          }.bind(this)
        )

        if (this.config.id == 'NavDrawer2' || this.config.id == 'NavDrawer3') {
          var _this = this
          $(this.drawer).find('.mobile-nav__item .collapsible-trigger__icon').on('click', function () {
            if ($(this).closest('.collapsible-trigger').length) {
              return
            }
            var $content = $(this).closest('.mobile-nav, .mobile-sub-nav-content')
            var $navItem = $(this).closest('.mobile-nav__item')
            document.querySelector('mobile-menu')?.resizeSubMenu?.($content, $navItem)

            // $('.main-mobile-nav-bottom').show()


          })

          $('.mobile-sub-nav-content .menu-size-item-heading').on('click', function () {
            $content = $(this).closest('.menu-size-item').find('.menu-size-item-content')
            var isOpen = $content.hasClass('open')
            if ($content.hasClass('is-transitioning')) {
              return
            }
            var _this = this
            if (isOpen) {
              $content.css('height', $content.height())
              theme.utils.prepareTransition($content[0], () => {
                $content.css('height', 0)
                $(_this).find('span').text('+')
                setTimeout(function () {
                  $content.removeClass('open')
                }, 350)
              })
            } else {
              $content.css('height', 'auto')
              var height = $content.height()
              $content.css('height', '0')
              $(_this).find('span').text('-')
              theme.utils.prepareTransition($content[0], () => {
                $content.addClass('open')
                $content.css('height', height)
              })
            }
          })
          var _this = this
          $('.js-search-mobile-trigger').on('click', function (e) {
            e.preventDefault()
            if ($(this).attr('data-drawer') !== _this.config.id) {
              return
            }
            if (!_this.isOpen) {
              var $content = $(_this.drawer).find(`.mobile-nav:visible, .mobile-sub-nav-content:visible`)
              if ($content.hasClass('mobile-nav')) {
                _this.previousOpen = '.mobile-nav'
              } else {
                _this.previousOpen = '#' + $content.attr('id')
              }
              $content.hide()
              $(_this.drawer).find('#mobile-sub-content-search').show()
              var headerHeight = $('#header-menu-v2').outerHeight()
              let height2 = $(_this.drawer).find('#mobile-sub-content-search').find('.mobile-nav-bottom').outerHeight()
              $(_this.drawer).find('#mobile-sub-content-search .search-layout').innerHeight(window.innerHeight - headerHeight - height2)
              $(_this.drawer).find('.drawer__scrollable > .toolbar__item').hide()
              _this.open(e)
              $('.main-mobile-nav-bottom').hide()
              _this.isSearchOpen = true
            }
            setTimeout(() => {
              $(_this.drawer).find('.search-form-item input[name=q]').focus()
            }, 100)
          })
        }

        $('#NavDrawer ul.mobile-nav .vego-menudrop-combination-content-svg').each((index, item) => {
          if ($(item).css('background-image') === 'none') {
            if (window.innerWidth < 768 && $(item).data().bgM && !$(item).hasClass('vego-menudrop-combination-content-connectors')) {
              $(item).css('background-image', `url(${$(item).data().bgM ?? $(item).data().bg})`)
              if ($(item).data().bgM) {
                $(item).attr('aspect-ratio', '335:87')
                item.classList.add('mode-mobile')
              } else {
                $(item).attr('aspect-ratio', '4:3')
                item.classList.remove('mode-mobile')
              }
            } else {
              item.classList.remove('mode-mobile')
              $(item).css('background-image', `url(${$(item).data().bg})`)
              $(item).attr('aspect-ratio', '4:3')
            }
            if ($(item).hasClass('vego-menudrop-combination-content-connectors')) {
              var menubox = $('<div class="vego-menu-mobile-group"></div>')
              var menuItem = $(item).closest('.vego-gd-item');
              var group = menuItem.siblings('.vego-menu-group')
              menuItem.parent().append(menubox)
              menuItem.appendTo(menubox)
              group.appendTo(menubox)
            }
          }
        })

        theme.collapsibles.init(document.getElementById('NavDrawer2'))
      },

      /***
       * ## Open Drawer : Menu, cart
       */
      open: function (evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault?.()
        }
        //if (evt.currentTarget?.querySelector?.('.icon-search') && theme.isMobile()) theme.defer.mobileSearchFn()
        if (this.isOpen) return

        ///lazyload for mobile menu
        if (!loadedMenuResource) {
          loadedMenuResource = true
        }
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation()
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true')
          this.activeSource = evt.currentTarget
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true')
          this.activeSource = returnFocusEl
        }
        theme.utils.prepareTransition(
          this.drawer,
          function () {
            $('.main-mobile-nav-bottom').show()
            if (this.drawer.tagName != 'CART-DRAWER') {
              this.drawer.classList.add(this.config.activeDrawer)
            } else { // open cart
              document.dispatchEvent(
                new CustomEvent('ajaxProduct:added', {
                  detail: {
                    drawer: true,
                    addToCartBtn: null,
                  },
                })
              )
            }


            /** update mobile menu size begin */
            let toolbarHeight = document.querySelector(`${this.config.id == 'CartDrawer' ? "" : `#${this.config.id}`} .drawer__contents .drawer__scrollable>.toolbar__item`)?.getBoundingClientRect?.().height ?? 0
            let headerHeight = document.querySelector('#header-menu-v2').getBoundingClientRect().height
            let mainMobileAnnouncementContent = document.querySelector('.announcement-ctner').getBoundingClientRect().height;
            let mainMobileNavContent = document.querySelector('#NavDrawer .drawer__scrollable .mobile-nav');
            let extraHeight = 0
            if (headerHeight == 0) {
              headerHeight = document.querySelector(`.header-inline-top`).getBoundingClientRect().height
              mainMobileNavContent = document.querySelector(`${this.config.id == 'CartDrawer' ? "" : `#${this.config.id}`} .drawer__scrollable .mobile-nav`);
              extraHeight = document.querySelector(`${this.config.id == 'CartDrawer' ? "" : `#${this.config.id}`} .main-mobile-nav-bottom`).getBoundingClientRect().height
            }
            if (toolbarHeight > 0 && mainMobileNavContent) {
              mainMobileNavContent.style.height = `${window.innerHeight - toolbarHeight - headerHeight - mainMobileAnnouncementContent - extraHeight}px`
            }
            /** update mobile menu size end */
            // if ($(evt.target).hasClass('icon-search') || $(evt.target).hasClass('js-search-mobile-trigger')) {
            //   $(this.drawer).css('top', headerHeight)
            // }
            $('#tolstoyWidgetElement').hide()

            /**
             * #deprecated
             */
            //theme.setCartHeightOfMainContent()
            //resize cart
            //#deprecated
            //theme.resizeCart()
            //#deprecated: consider new method 
            //theme.reRenderOption()
          }.bind(this)
        )
        if (!$(evt.target).hasClass('icon-search') && !$(evt.target).hasClass('js-search-mobile-trigger')) {
          document.querySelector('mobile-menu')?.resizeSubMenuTrigger?.()
        }
        document.querySelector('mobile-menu')?.resize?.()
        document.documentElement.classList.add(this.config.openClass)
        this.isOpen = true

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus',
        })

        document.dispatchEvent(new CustomEvent('drawerOpen'))
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id))
        //hide sticky add to cart button if any
        if ($('.mobile-sticky-product-details')) {
          $('.mobile-sticky-product-details').removeClass('out')
        }
        this.bindEvents()
      },

      close: function (evt) {
        if (!this.isOpen) {
          return
        }
        if (evt?.target?.tagName == 'SHOPIFY-INSTALLMENTS-PREQUAL-MODAL') return;
        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (
            evt.target.closest('.drawer') ||
            evt.target?.closest('shopify-installments-sample-plans-modal') // shopify-payment-terms打开的弹框关闭时, 不关闭购物车
          ) {
            return
          }
        }

        // deselect any focused form elements
        document.activeElement.blur()

        theme.utils.prepareTransition(
          this.drawer,
          function () {
            this.drawer.classList.remove(this.config.activeDrawer)
          }.bind(this)
        )

        document.documentElement.classList.remove(this.config.openClass)
        document.documentElement.classList.add(this.config.closingClass)
        window.setTimeout(
          function () {
            document.documentElement.classList.remove(this.config.closingClass)
            if (
              this.activeSource &&
              this.activeSource.getAttribute('aria-expanded')
            ) {
              this.activeSource.setAttribute('aria-expanded', 'false')
              this.activeSource.focus()
            }
            if (this.isSearchOpen) {
              $(this.drawer).find('#mobile-sub-content-search').hide()
              $(this.drawer).find(this.previousOpen).show()
              if (this.previousOpen == '.mobile-nav') {
                $(this.drawer).find('.drawer__scrollable > .toolbar__item').show()
              }
              this.isSearchOpen = false
            }
            $('#tolstoyWidgetElement').show()
          }.bind(this),
          0
        )

        this.isOpen = false

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus',
        })

        this.unbindEvents()
      },

      bindEvents: function () {
        // Clicking out of drawer closes it
        window.on(
          'click' + this.config.namespace,
          function (evt) {

            // handle click event for `National Gardening Day`
            // add variant gift
            let svgEl = evt.target
            if (evt.target.tagName.toUpperCase() !== 'SVG') {
              svgEl = evt.target.closest('svg');
            }
            //handle click event for `National Gardening Day`

            if (
              svgEl &&
              svgEl.closest(".free-gift-progress-pic") &&
              svgEl.closest("span") &&
              [...svgEl.classList].includes("cart-add")
            ) {
              evt.stopPropagation();
              evt.preventDefault();
              //debugger;
              /**
               * # Cancel auto add to cart functional for none US Market
               */
              if (theme.isCA()) return;
              return fetch(theme.routes.cartAdd, {
                method: "POST",
                body: JSON.stringify({
                  id: evt.target.closest("span").dataset.id,
                  quantity: 1,
                }),
                credentials: "same-origin",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              })
                .then((response) => response.json())
                .then(function (cart) {
                  // enable auto add to cart

                  ///      DISABLE AUTO ADD TO CART     ///
                  localStorage.removeItem("disable-auto-add-cart");
                  document
                    .querySelector(".free-gift-progress-pic")
                    ?.classList?.remove?.("disable-auto-add-cart");

                  //theme.cart.getCart().then(this.buildCart.bind(this))
                  //return cart
                  document.dispatchEvent(
                    new CustomEvent("ajaxProduct:added", {
                      detail: {
                        addToCartBtn: evt.target,
                      },
                    })
                  );
                });
              return;
            }
            //do not close cart when `newsletter discount` from cart
            if ($(evt.target).closest('.newsletter-discount-box').length) return;
            this.close(evt)
            return
          }.bind(this)
        )

        // Pressing escape closes drawer
        window.on(
          'keyup' + this.config.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              this.close()
            }
          }.bind(this)
        )

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page)
      },

      unbindEvents: function () {
        window.off('click' + this.config.namespace)
        window.off('keyup' + this.config.namespace)

        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page)
      },
    })

    return Drawers
  })()

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]',
    }

    var classes = {
      listVisible: 'disclosure-list--visible',
    }

    function Disclosure(disclosure) {
      this.container = disclosure
      this._cacheSelectors()
      this._setupListeners()
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(
            selectors.disclosureList
          ),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          ),
        }
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers()

        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        )

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          )
        }, this)

        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        )

        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        )

        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        )

        document.body.addEventListener('click', this.eventHandlers.onBodyClick)
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut:
            this._onDisclosureToggleFocusOut.bind(this),
        }
      },

      _connectOptions: function (event) {
        event.preventDefault()

        this._submitForm(event.currentTarget.dataset.value)
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false

        if (disclosureLostFocus) {
          this._hideList()
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget)

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        )

        if (isVisible && !childInFocus) {
          this._hideList()
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== slate.utils.keyboardKeys.ESCAPE) return
        this._hideList()
        this.cache.disclosureToggle.focus()
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target)
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        )

        if (isVisible && !isOption) {
          this._hideList()
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value
        this.cache.disclosureForm.submit()
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible)
        this.cache.disclosureToggle.setAttribute('aria-expanded', false)
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true'
        this.cache.disclosureList.classList.toggle(classes.listVisible)
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded)
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        )

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          )
        }, this)

        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        )

        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        )

        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        )

        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        )
      },
    })

    return Disclosure
  })()

  /**
   * @deprecated
   * @returns 
   */
  theme.initQuickShop = function () {
    var ids = []
    var products = document.querySelectorAll('.grid-product')

    if (!products.length || !theme.settings.quickView) {
      return
    }

    products.forEach((product) => {
      product.addEventListener('mouseover', productMouseover)
    })

    function productMouseover(evt) {
      var el = evt.currentTarget
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover)
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return
        }
        var productId = el.dataset.productId
        var handle = el.dataset.productHandle
        var btn = el.querySelector('.quick-product__btn')
        theme.preloadProductModal(handle, productId, btn)
      }
    }
  }


  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle)
    var url = window.route_prefix + "products/" + handle + "?view=modal";

    fetch(url)
      .then(function (response) {
        return response.text()
      })
      .then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser()
        var doc = parser.parseFromString(html, 'text/html')
        var div = doc.querySelector(
          '.product-section[data-product-handle="' + handle + '"]'
        )
        if (!holder) {
          return
        }

        holder.append(div)

        // Setup quick view modal
        var modalId = 'QuickShopModal-' + productId
        var name = 'quick-modal-' + productId
        new theme.Modals(modalId, name)
        // Register product template inside quick view
        theme.sections.register('product', theme.Product, holder)

        // Register collapsible elements
        theme.collapsibles.init()

        // Register potential video modal links (when video has sound)
        theme.videoModal()

        if (btn) {
          btn.classList.remove('quick-product__btn--not-ready')
        }
      })
  }

  theme.customerTemplates = function () {
    checkUrlHash()
    initEventListeners()
    resetPasswordSuccess()
    customerAddressForm()

    function checkUrlHash() {
      var hash = window.location.hash

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm()
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document
        .getElementById('RecoverPasswordForm')
        .classList.toggle('hide')
      var loginForm = document
        .getElementById('CustomerLoginForm')
        .classList.toggle('hide')
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword')
      if (recoverForm) {
        recoverForm.addEventListener('click', function (evt) {
          evt.preventDefault()
          toggleRecoverPasswordForm()
        })
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById(
        'HideRecoverPasswordLink'
      )
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function (evt) {
          evt.preventDefault()
          toggleRecoverPasswordForm()
        })
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success')

      // check if reset password form was successfully submitted
      if (!formState) {
        return
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide')
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm')
      var addressForms = document.querySelectorAll('.js-address-form')

      if (!newAddressForm || !addressForms.length) {
        return
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll('.js-address-country').forEach((el) => {
          var countryId = el.dataset.countryId
          var provinceId = el.dataset.provinceId
          var provinceContainerId = el.dataset.provinceContainerId

          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId,
          })
        })
      }, 1000)

      // Toggle new/edit address forms
      document
        .querySelector('.address-new-toggle')
        .addEventListener('click', function () {
          newAddressForm.classList.toggle('hide')
        })

      document.querySelectorAll('.address-edit-toggle').forEach((el) => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId
          document
            .getElementById('EditAddress_' + formId)
            .classList.toggle('hide')
        })
      })

      document.querySelectorAll('.address-delete').forEach((el) => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId
          var confirmMessage = evt.currentTarget.dataset.confirmMessage

          if (
            confirm(
              confirmMessage || 'Are you sure you wish to delete this address?'
            )
          ) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {
                parameters: { _method: 'delete' },
              })
            }
          }
        })
      })
    }
  }

  // General sections
  theme.HeaderSection = (function () {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]',
    }

    function HeaderSection(container) {
      this.container = container
      this.sectionId = this.container.getAttribute('data-section-id')

      this.init()
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.reinitSection('slideshow-section')

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'))
          }, 500)
        }

        this.initDrawers()
        this.initDisclosures()
        // theme.headerNav.init()
        theme.announcementBar.init()
      },

      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale)
        var currencyEl = this.container.querySelector(selectors.currency)

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl)
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl)
        }
      },

      initDrawers: function () {
        if (theme.isMobile()) {
          let mobile_menu_trigger_el = document.querySelector('.js-drawer-open-nav2');

          let mobile_search_trigger_el = document.querySelector('.js-search-mobile-trigger');
          theme.defer.openMobileMenuFn(null, true, theme.initSearchEvents)
          let menuClick = (el, evt) => {
            evt.preventDefault()
            evt.stopPropagation()
            //el.classList.add('btn--loading')
            theme.defer.openMobileMenuFn(el, false, theme.initSearchEvents)
            mobile_search_trigger_el.removeEventListener('click', search_listener)
            mobile_menu_trigger_el.removeEventListener('click', menu_listener)
          }
          let menu_listener = (evt) => menuClick(mobile_menu_trigger_el, evt);
          let search_listener = (evt) => menuClick(mobile_search_trigger_el, evt);
          mobile_menu_trigger_el.addEventListener('click', menu_listener)
          mobile_search_trigger_el.addEventListener('click', search_listener)
        }
        //theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav')
        //        theme.NavDrawer2 = new theme.Drawers('NavDrawer2', 'nav2')
        // theme.NavDrawer3 = new theme.Drawers('NavDrawer3', 'nav3')

        if (theme.settings.cartType === 'drawer') {
          // @deprecated
          //let nav_cart_el = document.querySelector('.js-drawer-open-cart')
          let cartListener = async () => {
            if (!document.querySelector('#CartDrawer')) {
              await theme.defer.mobileCartFn()
            }
            //document.querySelector('#CartDrawer').open(true)
            //nav_cart_el.removeEventListener('click',cartListener)
          }
          cartListener()
          //nav_cart_el.addEventListener('click',cartListener)

          //window.cartDrawerInstance = new theme.CartDrawer()
        }

        theme.collapsibles.init(document.getElementById('NavDrawer'))

      },

      onBlockSelect: function (evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId)
      },

      onBlockDeselect: function () {
        theme.announcementBar.onBlockDeselect()
      },

      onUnload: function () {
        theme.NavDrawer.close()
        theme.announcementBar.unload()

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy()
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy()
        }
      },
    })

    return HeaderSection
  })()

  theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init()
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function () {
        if (!document.querySelector('#LoginModal')) {
          return
        }

        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true,
        })

        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open()
        }
      },
    })

    return PasswordHeader
  })()

  theme.Product = (function () {
    var videoObjects = {}

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
    }

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
    }

    function Product(container) {
      this.container = container
      var sectionId = (this.sectionId =
        container.getAttribute('data-section-id'))

      this.inModal = container.dataset.modal === 'true'
      this.modal
      this.settings = {
        enableHistoryState:
          container.dataset.enableHistoryState == 'true' || false,
        namespace: '.product-' + sectionId,
        inventory: container.dataset.inventory || false,
        incomingInventory: container.dataset.incomingInventory || false,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping,
      }

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false
        this.settings.namespace = '.product-' + sectionId + '-modal'
        this.modal = document.getElementById('QuickShopModal-' + sectionId)
      }

      this.selectors = {
        bundleVariantsJson: 'BundleVariantsJson',
        variantsJson: 'VariantsJson-' + sectionId,
        misterJson: 'MisterJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
        form: '#AddToCartForm-' + sectionId,

        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,

        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: 'Sku-' + sectionId,
        inventory: 'ProductInventory-' + sectionId,
        incomingInventory: 'ProductIncomingInventory-' + sectionId,

        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.grid-product-variant-input',
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

        modalFormHolder: '#ProductFormHolder-' + sectionId,
        availabilityContainer: '#StoreAvailabilityHolder-' + sectionId,
      }

      this.cache = {
        form: container.querySelector(this.selectors.form),
        mainSlider: container.querySelector(this.selectors.mainSlider),
        thumbSlider: container.querySelector(this.selectors.thumbSlider),
        thumbScroller: container.querySelector(this.selectors.thumbScroller),
        productImageMain: container.querySelector(
          this.selectors.productImageMain
        ),

        // Price-related
        priceWrapper: container.querySelector(this.selectors.priceWrapper),
        comparePriceA11y: container.querySelector(
          this.selectors.comparePriceA11y
        ),
        comparePrice: container.querySelector(this.selectors.comparePrice),
        price: container.querySelector(this.selectors.price),
        savePrice: container.querySelector(this.selectors.savePrice),
        priceA11y: container.querySelector(this.selectors.priceA11y),
      }

      this.firstProductImage = this.cache.mainSlider.querySelector('img')
      if (!this.firstProductImage) {
        this.settings.hasImages = false
      }

      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]')
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName
      }

      this.init()
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal)
          document.addEventListener(
            'modalOpen.QuickShopModal-' + this.sectionId,
            this.openModalProduct.bind(this)
          )
          document.addEventListener(
            'modalClose.QuickShopModal-' + this.sectionId,
            this.closeModalProduct.bind(this)
          )
        }

        if (!this.inModal) {
          this.formSetup()
          this.colorV2Setup()
          this.productSetup()
          this.videoSetup()
          this.initProductSlider()
          this.customMediaListners()
          this.addIdToRecentlyViewed()
        }
      },

      formSetup: function () {
        if (theme.settings.dynamicVariantsEnable && this.cache.form) {
          this.variantSelectors = this.cache.form.querySelectorAll(
            this.selectors.singleOptionSelector
          )
        }

        this.initQtySelector()
        this.availabilitySetup()
        this.initVariants()

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet()
        }
      },

      colorV2Setup: function () {
        var $container = $(this.container)
        $container.find('.grid-product-variant-color-cates > div').on('click', function () {
          $container.find('.grid-product-variant-color-cates > div').removeClass('active')
          $(this).addClass('active')
          var target = $(this).data('target')
          if (target == 'all') {
            $container.find('.grid-product-variant-colors .variant-radio').removeClass('hide')
          } else {
            $container.find('.grid-product-variant-colors .variant-radio').addClass('hide')
            $container.find('.grid-product-variant-colors .variant-color-' + target).removeClass('hide')
          }
        })
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(
          this.selectors.availabilityContainer
        )
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container)
        }
      },

      productSetup: function () {
        this.setImageSizes()
        this.initOrderPrediction()
        this.initImageZoom()
        this.initModelViewerLibraries()
        this.initShopifyXrLaunch()
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage)
        }
      },

      initOrderPrediction: function () {
        var $date = $(this.container).find('.payment-prediction--date')
        var duration = []
        var now = new Date()
        var i = 0

        function formatDate(date) {
          const Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
          return Months[date.getMonth()] + ' ' + date.getDate()
        }

        while (true) {
          if (now.getDay() !== 0 && now.getDay() !== 6) {
            if (i == 3) {
              duration.push(formatDate(now))
              break
            }
            i++
          }
          now.setDate(now.getDate() + 1)
        }
        $date.text(duration[0])
      },

      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute('data-product-handle')
        var url = this.container.getAttribute('data-product-url')
        var aspectRatio = this.container.getAttribute('data-aspect-ratio')
        var featuredImage = this.container.getAttribute('data-img-url')

        // Remove current product if already in set of recent
        if (!theme.recentlyViewed?.recent?.products) {
          theme.recentlyViewed.recent = {
            products: {},
            viewed: []
          }
        }
        if (theme.recentlyViewed.recent.products.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent.products[handle]
        }

        // Add it back to the end
        theme.recentlyViewed.recent.products[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage,
        }
        if (theme.recentlyViewed.recent.viewed.includes(handle)) {
          theme.recentlyViewed.recent.viewed.splice(theme.recentlyViewed.recent.viewed.indexOf(handle), 1)
        }
        theme.recentlyViewed.recent.viewed.unshift(handle)

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem(
            'theme-recent',
            JSON.stringify(theme.recentlyViewed.recent)
          )
        }
      },

      initVariants: function () {
        var _this = this
        var variantJson = document.getElementById(this.selectors.variantsJson)

        if (!variantJson) {
          return
        }
        if (document.getElementById(this.selectors.bundleVariantsJson)) {
          this.bundleVariantsObject = JSON.parse(document.getElementById(this.selectors.bundleVariantsJson).innerHTML)
        }
        variantJson.querySelectorAll('option')
        this.variantsObject = formatVariantDataByDiscountPriceData(JSON.parse(variantJson.innerHTML));
        var misterJson = document.getElementById(this.selectors.misterJson)
        if (misterJson) {
          var chunks = misterJson.innerHTML.split('|||')
          var misterAvailability = JSON.parse(chunks[0]).filter(e => e)
          var misterObject = JSON.parse(chunks[1])

          for (var handle in misterObject) {
            var product = misterObject[handle]
            for (var v in product) {
              var v1 = product[v]
              for (var m of misterAvailability) {
                if (v1.id == m.id) {
                  for (var key in m) {
                    v1[key] = m[key]
                  }
                  break
                }
              }
            }
          }
          this.misterObject = misterObject
        }

        $('.product-image-main .grid-product-badges').addClass('hide')
        for (const variant of this.variantsObject) {
          if (variant.featured_media && variant.featured_media.id) {
            const mediaId = variant.featured_media.id
            if ($(`.product-image-main[data-media-id=${mediaId}]`).length) {
              $(`.product-image-main[data-media-id=${mediaId}]`).find('.grid-product-badges').removeClass('hide')
            }
          }
        }

        // CA Free Shipping
        this.caShippingFree = (document.querySelector('[data-ca-shipping-free]').getAttribute('data-ca-shipping-free') ?? '').split(',').map(e => +e)
        //=============  To Display compare_at_price of Ca =========================
        // this.variantsObject.forEach(item => {
        //   let compareAtPrice = variantJson.dataset[`priceV-${item.id}`]
        //   if (compareAtPrice && parseInt(compareAtPrice) >= item.price) {
        //     item.compare_at_price = parseInt(compareAtPrice)
        //   }
        // })

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          productId: this.sectionId
        }
        this.variants = new theme.Variants(options)
        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant
            ? this.variants.currentVariant.id
            : this.variants.variants[0].id

          this.storeAvailability.updateContent(variant_id)
          this.container.on(
            'variantChange' + this.settings.namespace,
            this.updateAvailability.bind(this)
          )
        }

        theme.getCurrentProductVariant = () => {
          return this.variants.currentVariant
        }

        this.container.on(
          'variantChange' + this.settings.namespace,
          this.updateCartButton.bind(this)
        )

        this.container.on(
          'variantChange' + this.settings.namespace,
          this.updateGif.bind(this)
        )
        this.updateGif(this.variants.currentVariant)

        this.container.on('variantChange' + this.settings.namespace, evt => {
          var variant = evt.detail.variant

          $(this.container).find('.add-mister').each(function () {
            var handle = $(this).data('handle')
            var target = $(this).data('target')
            var mister
            if (_this.misterObject[handle]) {
              mister = _this.misterObject[handle][variant.id]
            }
            if (!mister) {
              if (_this.misterObject[target]) {
                mister = _this.misterObject[target][variant.id]
              }
            }
            $(this).prop('checked', false)
            $(_this.cache.form).find('.mister-input[data-target=' + target + ']').remove()
            if (mister && mister.available) {
              $(this).closest('.product-options').removeClass('hide')
              var $a = $(this).closest('.grid-product-variant-addon').find('.addon-body a')
              $(this).closest('.grid-product-variant-addon').find('.addon-body .addon-price').html(theme.Currency.formatMoney(
                mister.price,
                theme.settings.moneyFormat
              ))
              $a.attr('href', mister.url)
              $a.find('span').html(mister.title)
            } else {
              $(this).closest('.product-options').addClass('hide')
            }
          })
          this.updateCAFreeShipping(variant)
          this.updateBundleLink(variant)
          this.updateWoodGrainPDP(variant);
          
        })
        this.updateBundleLink(this.variants.currentVariant)
        this.updateWoodGrainPDP(this.variants.currentVariant)
        $(this.container).on('change', '.add-mister', function (e) {
          var value = $(e.target).prop('checked')
          var handle = $(e.target).data('handle')
          var target = $(e.target).data('target')
          if (value) {
            var quantity = $(".product-single__meta input.js-qty__num").val()
            var variant_id = _this.variants.currentVariant
              ? _this.variants.currentVariant.id
              : _this.variants.variants[0].id
            var mister
            if (_this.misterObject[handle]) {
              mister = _this.misterObject[handle][variant_id]
            }
            if (!mister) {
              if (_this.misterObject[target]) {
                mister = _this.misterObject[target][variant_id]
              }
            }
            $(_this.cache.form).append('<input type="hidden" class="mister-input" name="items[][id]" data-target="' + target + '" value="' + mister.id + '" />')
            $(_this.cache.form).append('<input type="hidden" class="mister-input mister-quantity" name="items[][quantity]" data-target="' + target + '" value="' + quantity + '" />')
            mister.selling_plan && $(_this.cache.form).append('<input type="hidden" class="mister-input" name="items[][selling_plan]" data-target="' + target + '" value="' + mister.selling_plan + '" />')
            if (mister.preOrder == "true") {
              $(_this.cache.form).append('<input type="hidden" class="mister-input" name="items[][properties][_is_fullfillDate]" data-target="' + target + '" value="Ships by: ' + ts2shortDateFormat(mister.estimatedFulfillmentDateTs * 1000) + '" />')
              $(_this.cache.form).append('<input type="hidden" class="mister-input" name="items[][properties][_is_fullfillDate_ts]" data-target="' + target + '" value="' + mister.estimatedFulfillmentDateTs + '" />')
              $(_this.cache.form).append('<input type="hidden" class="mister-input" name="items[][properties][_is_preorder]" data-target="' + target + '" value="Note: Pre-order item" />')
            } else {
              $(_this.cache.form).append('<input type="hidden" class="mister-input" name="items[][properties[_is_fullfillDate]]" data-target="' + target + '" value="In Stock" />')
            }
            if (mister.compareAtPrice) {
              $(_this.cache.form).append('<input type="hidden" class="mister-input" name="items[][properties[original_price]]" data-target="' + target + '" value="' + mister.compareAtPrice / 100 + '" />')
            }
          } else {
            $(_this.cache.form).find('.mister-input[data-target=' + target + ']').remove()
          }
        })

        $(this.container).on('change', '#upgrade-shipping', (e) => {
          var value = $(e.target).prop('checked')
          if (value) {
            $(this.cache.form).append('<input type="hidden" class="upgrade-input" name="items[1][properties][_is_upgrade_delivery]" value="true" />')
            $(this.cache.form).append('<input type="hidden" class="upgrade-input" name="items[1][id]" value="40771195043875" />')
          } else {
            $(this.cache.form).find('.upgrade-input').remove()
            $(this.cache.form).find("[name='items[1][quantity]']").remove();
          }
        })

        this.container.on(
          'variantColorChange' + this.settings.namespace,
          this.updateColorName.bind(this)
        )
        this.container.on(
          'variantImageChange' + this.settings.namespace,
          this.updateVariantImage.bind(this)
        )
        this.container.on(
          'variantPriceChange' + this.settings.namespace,
          this.updatePrice.bind(this)
        )
        this.container.on(
          'variantUnitPriceChange' + this.settings.namespace,
          this.updateUnitPrice.bind(this)
        )

        if (document.getElementById(this.selectors.sku)) {
          this.container.on(
            'variantSKUChange' + this.settings.namespace,
            this.updateSku.bind(this)
          )
        }

        if (this.settings.inventory || this.settings.incomingInventory) {
          this.container.on(
            'variantChange' + this.settings.namespace,
            this.updateInventory.bind(this)
          )
        }

        // Update individual variant availability on each selection
        if (
          theme.settings.dynamicVariantsEnable &&
          document.getElementById(this.selectors.currentVariantJson)
        ) {
          this.currentVariantObject = JSON.parse(
            document.getElementById(this.selectors.currentVariantJson).innerHTML
          )
          this.initialOptions = {}
          $(this.container).find('select.grid-product-variant-input').each((i, e) => {
            var name = $(e).data('index')
            var options = $(e).find('option').map((i, a) => a.value).get()
            this.initialOptions[name] = options
          })
          $(this.container).on('change' + this.settings.namespace, this.selectors.singleOptionSelector,
            this.variantAvailability.bind(this))

          // Set default state based on current selected variant
          this.variantAvailability(null, this.currentVariantObject)
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          this.settings.imageSetIndex = this.cache.form.querySelector(
            '.variant-input-wrap[data-handle="' +
            this.settings.imageSetName +
            '"]'
          ).dataset.index
          this.container.on(
            'variantChange' + this.settings.namespace,
            this.updateImageSet.bind(this)
          )
        }

        this.updateCAFreeShipping(this.variants.currentVariant)
      },

      initQtySelector: function () {
        var self = this
        var query = $.qs()
        if (query.quantity) {
          $(".product-single__meta input.js-qty__num, .mobile-sticky-product-details input.js-qty__num").val(query.quantity[0])
        }
        this.container.querySelectorAll('.js-qty__wrapper').forEach((el) => {
          new theme.QtySelector(el, {
            namespace: '.product',
            onChange: function (qty) {
              if ($(".product-single__meta input.js-qty__num").length && $(".mobile-sticky-product-details input.js-qty__num").length) {
                $(".product-single__meta input.js-qty__num").val(qty)
                $(".mobile-sticky-product-details input.js-qty__num").val(qty)
                $(".mobile-sticky-product-details .vego-select-contaner[data-target=quantity]").vselect('select', qty)
              }
              $(self.cache.form).find('.mister-quantity').val(qty)
              theme.productForm.updateProductPoints(self.variants.currentVariant)
            }
          })
        })
      },

      initAjaxProductForm: function () {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct(this.cache.form)
        }
      },

      updateCAFreeShipping: function (variant) {
        if ($('.pdp-ca-free-shipping').length) {
          if (!this.caShippingFree.includes(variant.id)) {
            $('.pdp-ca-free-shipping').hide()
          } else {
            $('.pdp-ca-free-shipping').show()
          }
        }
      },

      /*============================================================================
          Dynamic variant availability
            - To disable, set dynamicVariantsEnable to false in theme.liquid
        ==============================================================================*/
      enableVariantOptionByValue: function (array, index) {
        var group = this.cache.form.querySelector(
          '.variant-input-wrap[data-index="' + index + '"]'
        )
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption(group, array[i])
        }
      },

      variantAvailability: function (evt, variant) {
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        var valuesToManage = {
          option1: [],
          option2: [],
          option3: [],
        }

        var ignoreIndex = null
        var variants
        // If working with an event, get variants to loop through
        // based on the group index of recently selected option.
        //
        // If variant object passed explicitly (on load), get variants
        // that overlap with all potential combinations
        if (evt) {
          var el = evt.currentTarget
          var val = el.value
          var index = el.dataset.index
          variants = this.variantsObject.filter(function (el) {
            return el[index] === val
          })
        } else {
          var availableVariants = this.variantsObject.filter(function (el) {
            if (variant.id === el.id) {
              return false
            }

            if (
              variant.option2 === el.option2 &&
              variant.option3 === el.option3
            ) {
              return true
            }

            if (
              variant.option1 === el.option1 &&
              variant.option3 === el.option3
            ) {
              return true
            }

            if (
              variant.option1 === el.option1 &&
              variant.option2 === el.option2
            ) {
              return true
            }
          })

          // IE11 can't handle shortform of {variant} so extra step is needed
          var variantObject = {
            variant: variant,
          }

          variants = Object.assign({}, variantObject, availableVariants)
        }
        // Disable all options to start.
        // If coming from a variant change event, do not disable
        // options inside current index group
        this.cache.form
          .querySelectorAll('.variant-input-wrap')
          .forEach((group) => {
            var groupIndex = group.dataset.index
            if (evt && groupIndex === index) {
              ignoreIndex = index
              return
            }
            this.disableVariantGroup(group)
          })

        // Loop through each available variant to gather variant values
        for (var property in variants) {
          if (variants.hasOwnProperty(property)) {
            var item = variants[property]
            var value1 = item.option1
            var value2 = item.option2
            var value3 = item.option3
            var soldOut =
              item.inventory_management &&
              item.inventory_policy === 'deny' &&
              item.inventory_quantity < 1

            if (value1 && ignoreIndex !== 'option1') {
              valuesToManage.option1.push({
                value: value1,
                soldOut: soldOut,
              })
            }
            if (value2 && ignoreIndex !== 'option2') {
              valuesToManage.option2.push({
                value: value2,
                soldOut: soldOut,
              })
            }
            if (value3 && ignoreIndex !== 'option3') {
              valuesToManage.option3.push({
                value: value3,
                soldOut: soldOut,
              })
            }
          }
        }
        for (var [option, values] of Object.entries(valuesToManage)) {
          var initialOptions = this.initialOptions[option]
          if (initialOptions) {
            var sortOption = []
            for (var o1 of initialOptions) {
              for (var o2 of values) {
                if (o1 === o2.value) {
                  sortOption.push(o2)
                  break
                }
              }
            }
            valuesToManage[option] = sortOption
          }
        }
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values)
          this.manageSelectOption(option, values)
        }
      },

      manageSelectOption: function (option, values) {
        function isMixedOptions(group) {
          return $(group).find('input[type=radio]').length > 0 && $(group).find('select').length > 0
        }
        var group = this.cache.form.querySelector(
          '.variant-input-wrap[data-index="' + option + '"]'
        )
        var $select
        if (isMixedOptions(group)) {
          var mediaCls = !theme.isMobile() ? 'small--hide' : 'medium-up--hide'
          $select = $(group).find(
            'select.grid-product-variant-input[data-index="' + option + '"].' + mediaCls
          )
        } else {
          $select = $(group).find('select.grid-product-variant-input[data-index="' + option + '"]')
        }
        if ($select && $select.length > 0 && values.length) {
          var arr = []
          values.forEach(obj => { arr.push(obj.value) })
          var optionValues = $select.find('option').map(function () {
            return this.value
          }).get()
          let diff = arr.filter(x => !optionValues.includes(x))
            .concat(optionValues.filter(x => !arr.includes(x)));
          if (diff.length) {
            try {
              $select.vselect('setOptions', arr)
            } catch (e) {
              setTimeout(() => {
                $select.vselect('setOptions', arr)
              }, 200)
            }
          }
        }
      },

      manageOptionState: function (option, values) {
        var group = this.cache.form.querySelector(
          '.variant-input-wrap[data-index="' + option + '"]'
        )
        if (!group) return;
        // Loop through each option value
        values.forEach((obj) => {
          this.enableVariantOption(group, obj)
        })
      },

      enableVariantOption: function (group, obj) {
        var self = this
        // Selecting by value so escape it
        var value = obj.value.replace(
          /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
          '\\$1'
        )
        var $input = $(group).find(
          'input.grid-product-variant-input[value="' + value + '"]'
        )
        if (!$input.length) {
          return
        }
        $input.each(function () {
          if (!theme.isMobile()) {
            if (
              $(this).is('.medium-up--hide') ||
              $(this).closest('.medium-up--hide').length > 0
            ) {
              return
            }
          } else {
            if (
              $(this).is('.small--hide') ||
              $(this).closest('.small--hide').length > 0
            ) {
              return
            }
          }
          var input = this
          if (input) {
            var label = input.parentElement.querySelector('label')
            // Variant exists - enable & show variant
            input.disabled = false
            input.classList.remove(classes.hidden, classes.disabled)
            label.classList.remove(classes.hidden, classes.disabled)
            label.parentElement.classList.remove(classes.hidden)
            if (self.variants?.needReset) {
              input.checked = true
              theme.utils.trigger(input, 'change')
              self.variants.needReset = false
            }
            // Variant sold out - cross out option (remains selectable)
            if (obj.soldOut) {
              input.disabled = true
              input.classList.add(classes.disabled)
              label.classList.add(classes.disabled)
            }
          }
        })

        if ($input.hasClass(classes.hidden)) {
          $(group).find('.grid-product-variant-input:visible').prop('checked', true)
        }
      },

      // Hide and disable input/label inside a variant group
      disableVariantGroup: function (group) {
        group.querySelectorAll('input').forEach((input) => {
          input.disabled = true
          input.classList.add(classes.hidden)
          input.classList.remove(classes.disabled)
        })
        group.querySelectorAll('label').forEach((label) => {
          label.classList.add(classes.hidden)
          label.classList.remove(classes.disabled)
          label.parentElement.classList.add(classes.hidden)
        })
      },

      /*============================================================================
          Variant change methods
        ==============================================================================*/
      updateColorName: function (e) {
        // Updates on radio button change, not variant.js
        var label = $(this.container).find('.variant-color-label')
        if (label.length) {
          label.text(e.detail.color)
        }
      },
      updateWoodGrainPDP:function(variant){
        if (!$(".woodgrain-options").length)return;
        $(".woodgrain-options").hide();
        $(`.woodgrain-options-v-${variant.id}`).show();
        
        if(variant.title.includes("2.0' x 8.0'") || variant.id == '40974813921315' || variant.id =='40974813888547')$('.woodgrain-28').show()
        if(variant.title.includes("2.0' x 6.0'") || variant.id == '40974813659171' || variant.id =='40974813626403')$('.woodgrain-26').show()
        if(variant.title.includes("2.0' x 4.0'") || variant.id == '40974813364259' || variant.id =='40974813397027' )$('.woodgrain-24').show()
        $(`.woodgrain-${variant.id}`).show()
      },
      updateBundleLink: function (evt) {
        evt = evt?.detail?.variant || evt
        if (this.bundleVariantsObject) {
          const linkVariant = this.bundleVariantsObject.find(e => e.option1 == evt.option1)
          if (linkVariant) {
            let qty = 4
            const matched = linkVariant.name.match(/^(\d+)-Pack/)
            if (matched) {
              qty = matched[1]
            }
            const unitPrice = (linkVariant.price / qty / 100).toFixed(2)
            const href = $('.bundle-entry a').attr('href')
            const newHref = href.split('?')[0] + `?variant=${linkVariant.id}`
            $('.bundle-entry a').text(`4 Pack For $${unitPrice} Each`).attr('aria-label', `Go to 4 Pack For $${unitPrice} Each`).attr('href', newHref)
          }
        }
      },
      updateGif: function (evt) {
        evt = evt?.detail?.variant || evt
        let handle = this.container.getAttribute('data-product-handle')
        if (handle == 'worm-farm-worm-composter') {
          if (evt.option1.toLowerCase() !== 'lime') {
            $('.composter-g1').hide()
            $('.composter-g2').show()
          } else {
            $('.composter-g1').show()
            $('.composter-g2').hide()
          }
        }
        if (handle == 'foodcube' || handle == 'foodcube-slim-the-next-generation-of-raised-garden-self-watering-elevated' || handle == 'foodcube-slim' || handle == 'foodcube-the-next-generation-of-raised-garden-self-watering-elevated') {
          if (evt.id == 40579370188835 || evt.id == 40579374415907) {
            $('.composter-g1').hide()
            $('.composter-g2').show()
          } else {
            $('.composter-g1').show()
            $('.composter-g2').hide()
          }
        }

      },
      updateCartButton: function (evt) {
        // var variant = evt.detail.variant
        // var $cartBtn = $('.product-single__form .add-to-cart')
        // var $cartBtnText = $cartBtn.find('span')
        // if (variant) {
        //   if (variant.available) {
        //     // Available, enable the submit button and change text
        //     $cartBtn.prop('disabled', false)
        //     var defaultText = $cartBtnText.data('defaultText')
        //     $cartBtnText.text(defaultText)
        //   } else {
        //     // Sold out, disable the submit button and change text
        //     $cartBtn.prop('disabled', true)
        //     $cartBtnText.text(theme.strings.soldOut)
        //   }
        // } else {
        //   // The variant doesn't exist, disable submit button
        //   $cartBtn.prop('disabled', true)
        //   $cartBtnText.text(theme.strings.unavailable)
        // }
      },

      updatePrice: function (evt) {

        var variant = evt.detail.variant
        var discount = evt.detail.discount?.discounted
        var compareAtPrice = variant.compare_at_price
        var price = variant.price
        var appliedDiscount = false
        let composterStickyPrice = ''
        let handle = this.container.getAttribute('data-product-handle')
        let compostersavedAmount = 0
        if (discount) {
          if (evt.detail.discount.compareAtPrice) {
            compareAtPrice = evt.detail.discount.compareAtPrice
          }
          if (evt.detail.discount.auCompareAtPrice && theme.isAu()) {
            compareAtPrice = evt.detail.discount.auCompareAtPrice;
          } else if (evt.detail.discount.caCompareAtPrice && theme.isCA()) {
            compareAtPrice = evt.detail.discount.caCompareAtPrice;
          }
          if (evt.detail.discount.price) {
            price = evt.detail.discount.price
          }
          if (compareAtPrice > price) {

            if (this.cache.price) this.cache.price.innerHTML = theme.Currency.formatMoney(
              price,
              theme.settings.moneyFormat
            )

            $('.product-price-contaner > .product__price').text(theme.Currency.formatMoney(
              price,
              theme.settings.moneyFormat
            ))

            var save
            var savedAmount = compareAtPrice - price
            var savedPercent = Math.round((compareAtPrice - price) * 100 / compareAtPrice)

            if (evt.detail.discount.percent || savedPercent >= savedAmount / 100) {
              save = savedPercent + '% OFF'
            } else {
              save = 'SAVE ' + theme.Currency.formatMoney(
                savedAmount,
                '${{amount_no_decimals}}'
              )
            }
            if ($('.limit-save').length) {
              $('.limit-save').text(theme.Currency.formatMoney(
                savedAmount,
                '${{amount_no_decimals}}'
              ))
            }
            $('.product-price-contaner > .product__price').addClass(classes.onSale)
            $('.product-price-contaner .product__price--compare').text(theme.Currency.formatMoney(
              compareAtPrice,
              theme.settings.moneyFormat
            )).removeClass(classes.hidden)

            $('.product-price-contaner .product__price-savings').text(save).removeClass(classes.hidden)

            // if (handle == 'kitchen-composter') {
            //   if (variant.option2 == "Annual Subscription") {
            //     composterStickyPrice = '+$16.66/mo'
            //     compostersavedAmount = 4000
            //   } else if (variant.option2 == "Quarterly Subscription") {
            //     composterStickyPrice = '+$19.98/mo'
            //     compostersavedAmount = 0
            //   }
            //   $('.mobile-sticky-product-details .product-price-contaner > .product__price').text(theme.Currency.formatMoney(
            //     price,
            //     theme.settings.moneyFormat
            //   ) + composterStickyPrice)
            //   savedAmount = savedAmount + compostersavedAmount
            //   save = 'SAVE ' + theme.Currency.formatMoney(
            //     savedAmount,
            //     theme.settings.moneyFormat
            //   )
            //   $('.mobile-sticky-product-details .product-price-contaner .product__price-savings').text(save).removeClass(classes.hidden)
            // }
            appliedDiscount = true
          }
        }
        if (!appliedDiscount && variant) {
          // Regular price
          $('.product-price-contaner > .product__price').text(theme.Currency.formatMoney(
            variant.price,
            theme.settings.moneyFormat
          ))

          // Sale price, if necessary
          if (compareAtPrice > price) {
            $('.product-price-contaner .product__price--compare').text(theme.Currency.formatMoney(
              compareAtPrice,
              theme.settings.moneyFormat
            )).removeClass(classes.hidden)

            $('.product-price-contaner > .product__price').addClass(classes.onSale)

            // if (!this.cache.savePrice.classList.contains(classes.hidden)) {
            //   var savings = variant.compare_at_price - variant.price

            //   if (theme.settings.saveType == 'percent') {
            //     savings =
            //       Math.round((savings * 100) / variant.compare_at_price) + '%'
            //   } else {
            //     savings = theme.Currency.formatMoney(
            //       savings,
            //       theme.settings.moneyFormat
            //     )
            //   }
            //   this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
            //     '[saved_amount]',
            //     savings
            //   )
            // }
          } else {
            $('.product-price-contaner > .product__price').removeClass(classes.onSale)
            $('.product-price-contaner .product__price-savings').addClass(classes.hidden)
            $('.product-price-contaner .product__price--compare').addClass(classes.hidden)
          }
        }
        this.updatePripertiesVariantPrice(variant)

      },
      /**
       * ## update compare at price 
       * =============  To Display compare_at_price =========================
       * 1. form properties[original_price] value
       * 2. sync compare_at_price displayed in ui
       * @param {*} variant 
       */
      updatePripertiesVariantPrice: function (variant) {
        let handle = this.container.getAttribute('data-product-handle')
        let compareAtPrice = theme.unityCompareAtPrice(variant.compare_at_price, variant.id)
        let formEl = this.container.querySelector('form');

        let v_compare_at_price = formEl.querySelector('[name="properties[original_price]"]');
        if (!v_compare_at_price && compareAtPrice && compareAtPrice > variant.price) {
          v_compare_at_price = document.createElement('input')
          v_compare_at_price.setAttribute('type', 'hidden')
          v_compare_at_price.setAttribute('name', 'properties[original_price]')
          formEl.appendChild(v_compare_at_price)
        }
        if (v_compare_at_price) {
          if (compareAtPrice > variant.price) {
            v_compare_at_price.setAttribute('value',
              theme.Currency.formatMoney(
                compareAtPrice,
                theme.settings.moneyFormat
              ).replace(theme.settings.moneyFormat.replace(`{{amount}}`, ''), '')
            )
          } else {
            $(v_compare_at_price).remove()
          }
        }

        // ##  keep right compare at price after switching
        let compareEl = formEl.querySelector('.grid-product__price--original,.product__price--compare');
        // if (handle == 'kitchen-composter' && variant.option2 !== 'Vego Kitchen Composter') {
        //   if (compareEl) compareEl.innerHTML = theme.Currency.formatMoney(
        //     compareAtPrice,
        //     theme.settings.moneyFormat
        //   ) + '+19.98/mo';
        // } else {
        if (compareEl) compareEl.innerHTML = theme.Currency.formatMoney(
          compareAtPrice,
          theme.settings.moneyFormat
        );
        // }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML =
            theme.Currency.formatMoney(
              variant.unit_price,
              theme.settings.moneyFormat
            )
          this.container.querySelector(
            this.selectors.unitPriceBaseUnit
          ).innerHTML = theme.Currency.getBaseUnit(variant)
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.remove(classes.visuallyHide)
        } else {
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.add(classes.visuallyHide)
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant
          ? variant
          : this.variants
            ? this.variants.currentVariant
            : null
        if (!variant) return

        var setValue = (this.settings.currentImageSet = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        ))
        var set = this.settings.imageSetName + '_' + setValue

        // Always start on index 0
        this.settings.currentSlideIndex = 0

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex,
        }
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt
          ? evt.detail.variant
          : this.variants
            ? this.variants.currentVariant
            : null
        if (!variant) {
          return
        }

        var setValue = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        )

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return
        }

        this.initProductSlider(variant)
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider
          .querySelectorAll('.product__thumb-item')
          .forEach((thumb) => {
            thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set)
          })
      },

      getImageSetName: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-$/, '')
          .replace(/^-/, '')
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant
        var newSku = ''

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku
          }
          document.getElementById(this.selectors.sku).textContent = newSku
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant

        // Hide stock if no inventory management or policy is continue
        if (
          !variant ||
          !variant.inventory_management ||
          variant.inventory_policy === 'continue'
        ) {
          this.toggleInventoryQuantity(false)
          this.toggleIncomingInventory(false)
          return
        }

        if (
          variant.inventory_management === 'shopify' &&
          window.inventories &&
          window.inventories[this.sectionId]
        ) {
          var variantInventoryObject =
            window.inventories[this.sectionId][variant.id]
          var quantity = variantInventoryObject.quantity
          var showInventory = true
          var showIncomingInventory = false

          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false
          }

          this.toggleInventoryQuantity(showInventory, quantity)

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (
            !showInventory &&
            variantInventoryObject.incoming &&
            quantity <= theme.settings.inventoryThreshold
          ) {
            showIncomingInventory = true
          }

          this.toggleIncomingInventory(
            showIncomingInventory,
            variant.available,
            variantInventoryObject.next_incoming_date
          )
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.variant
        if (!variant) {
          return
        }

        this.storeAvailability.updateContent(variant.id)
      },

      toggleInventoryQuantity: function (show, qty) {
        if (!this.settings.inventory) {
          show = false
        }

        var el = document.getElementById(this.selectors.inventory)

        if (show) {
          el.classList.remove(classes.hidden)
          el.textContent = theme.strings.stockLabel.replace('[count]', qty)
        } else {
          el.classList.add(classes.hidden)
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        if (!this.settings.incomingInventory) {
          show = false
        }

        var el = document.getElementById(this.selectors.incomingInventory)

        if (!el) {
          return
        }

        if (show) {
          var string = available
            ? theme.strings.willNotShipUntil.replace('[date]', date)
            : theme.strings.willBeInStockAfter.replace('[date]', date)

          if (!date) {
            string = theme.strings.waitingForStock
          }

          el.classList.remove(classes.hidden)
          el.textContent = string
        } else {
          el.classList.add(classes.hidden)
        }
      },

      /*============================================================================
          Product videos
        ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(
          selectors.productVideo
        )

        if (!productVideos.length) {
          return false
        }

        productVideos.forEach((vid) => {
          var type = vid.dataset.videoType
          if (type === 'youtube') {
            this.initYoutubeVideo(vid)
          } else if (type === 'mp4') {
            this.initMp4Video(vid)
          }
        })
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(div.id, {
          videoId: div.dataset.youtubeId,
          videoParent: selectors.videoParent,
          autoplay: false, // will handle this in callback
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
          events: {
            onReady: this.youtubePlayerReady.bind(this),
            onStateChange: this.youtubePlayerStateChange.bind(this),
          },
        })
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return
        }

        var obj = videoObjects[iframeId]
        var player = obj.videoPlayer

        if (obj.options.style !== 'sound') {
          player.mute()
        }

        obj.parent.classList.remove('loading')
        obj.parent.classList.add('loaded')

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo()
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(
          selectors.startingSlide + ' ' + '#' + id
        )
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id
        var obj = videoObjects[iframeId]

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable')
            }
            break
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo()
            }
            break
          case 3: // buffering
            obj.attemptedToPlay = true
            break
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4',
        }

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id)
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo() // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id) // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute('data-video-type')
      },

      _getVideoDivId: function (video) {
        return video.id
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector('#' + id)
        var playPromise = player.play()

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Playing as expected
            })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute('controls', '')
              player
                .closest(selectors.videoParent)
                .setAttribute('data-video-style', 'unmuted')
            })
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector('#' + id)
        if (player && typeof player.pause === 'function') {
          player.pause()
        }
      },

      /*============================================================================
          Product images
        ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(
          this.selectors.imageContainer
        )
        if (!container) {
          return
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId)
        container.addEventListener(
          'photoswipe:afterChange',
          function (evt) {
            if (this.flickity) {
              this.flickity.goToSlide(evt.detail.index)
            }
          }.bind(this)
        )
      },

      getThumbIndex: function (target) {
        if ($('.product__photos-v2').length) {
          return 0
        } else {
          return target?.dataset.index
        }
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant
        var imageSrc = variant.featured_image && variant.featured_image.src && variant.featured_image.src.split('?')[0]
        if (imageSrc) {
          $('.variant-color-swatch__label').each(function () {
            $(this).find('.variant-color-swatch__image').each(function () {
              $(this).addClass('hide')
              if ($(this).attr('data-option2')) {
                var match = false
                for (var i = 2; i < 4; i++) {
                  if ($(this).attr('data-option' + i) == variant['option' + i]) {
                    match = true
                    break
                  }
                }
                if (match) {
                  $(this).removeClass('hide')
                }
              } else {
                $(this).removeClass('hide')
              }
            })
          })
        }
        

        var sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_media.preview_image.src,
          this.settings.imageSize
        )
        var newImage = this.container.querySelector(
          '.product-main-slide[data-id="' + variant.featured_media.id + '"]'
        )
        var imageIndex = this.getThumbIndex(newImage)

        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex)
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image
        if (
          this.cache.mainSlider.querySelectorAll(selectors.slide).length < 1
        ) {
          return
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy()
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(
            selectors.startingSlide
          )

          this.settings.currentSlideIndex = this._slideIndex(activeSlide)
        }

        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider?.dataset.position === 'beside',
          pageDots: false, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onChange: this.onSlideChange.bind(this),
          },
        }

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant)
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs)
          this.updateImageSetThumbs(mainSliderArgs.imageSet)
        }

        this.flickity = new theme.Slideshow(
          this.cache.mainSlider,
          mainSliderArgs
        )
      },

      onSlideChange: function (index) {

        if (!this.flickity) return
        var allSlides = this.cache.mainSlider.querySelectorAll(selectors.slide)
        var prevSlide = allSlides[this.settings.currentSlideIndex]
        var nextSlide = allSlides[index]

        prevSlide.setAttribute('tabindex', '-1')
        nextSlide.setAttribute('tabindex', 0)

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide)

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide)

        // Update current slider index
        this.settings.currentSlideIndex = index
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo)
        if (video) {
          var videoType = this._getVideoType(video)
          var videoId = this._getVideoDivId(video)
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo()
              return
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId)
            return
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media)
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true,
            })
          )
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo)
        if (video) {
          var videoType = this._getVideoType(video)
          var videoId = this._getVideoDivId(video)
          if (videoType === 'youtube') {
            if (
              videoObjects[videoId].videoPlayer &&
              videoObjects[videoId].options.style !== 'sound'
            ) {
              videoObjects[videoId].videoPlayer.playVideo()
              return
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId)
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media)
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true,
            })
          )
          slide
            .querySelector('.shopify-model-viewer-ui__button')
            .setAttribute('tabindex', 0)
          slide
            .querySelector('.product-single__close-media')
            .setAttribute('tabindex', 0)
        }
      },

      _slideIndex: function (el) {
        if ($('.product__photos-v2').length) {
          return 0
        }
        return el.getAttribute('data-index')
      },

      /*============================================================================
          Products when in quick view modal
        ==============================================================================*/
      openModalProduct: function () {
        var initialized = false

        if (!this.settings.modalInit) {
          var formHolder = this.container.querySelector(
            this.selectors.modalFormHolder
          )
          var url = formHolder.dataset.url
          var template = formHolder.dataset.template

          // Use stripped down ajax version for faster loading,
          // unless preorder template is used so we show right button
          if (template !== 'preorder') {
            url = url + '?view=ajax'
          }

          fetch(url)
            .then(function (response) {
              return response.text()
            })
            .then(
              function (html) {
                var parser = new DOMParser()
                var doc = parser.parseFromString(html, 'text/html')
                this.cache.form = doc.querySelector(
                  '#AddToCartForm-' + this.sectionId
                )

                formHolder.innerHTML = ''
                formHolder.append(this.cache.form)
                formHolder.classList.add('product-form-holder--loaded')

                this.formSetup()

                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init()
                }
                document.dispatchEvent(
                  new CustomEvent('quickview:loaded', {
                    detail: {
                      productId: this.sectionId,
                      flickity: this.flickity
                    },
                  })
                )
              }.bind(this)
            )

          this.productSetup()
          this.videoSetup()

          // Setup product inventory data
          this.updateModalProductInventory()

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider()
            } else {
              document.addEventListener(
                'quickview:loaded',
                function (evt) {
                  if (evt.detail.productId === this.sectionId) {
                    this.initProductSlider()
                  }
                }.bind(this)
              )
            }
          } else {
            this.initProductSlider()
          }
          this.customMediaListners()
          this.addIdToRecentlyViewed()
          this.settings.modalInit = true
        } else {
          initialized = true
        }
        // //@deprecated
        AOS?.refreshHard()

        document.dispatchEvent(
          new CustomEvent('quickview:open', {
            detail: {
              initialized: initialized,
              productId: this.sectionId,
            },
          })
        )
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {}
        this.container
          .querySelectorAll('.js-product-inventory-data')
          .forEach((el) => {
            var sectionId = el.dataset.sectionId
            window.inventories[sectionId] = {}

            el.querySelectorAll('.js-variant-inventory-data').forEach((el) => {
              window.inventories[sectionId][el.dataset.id] = {
                quantity: el.dataset.quantity,
                incoming: el.dataset.incoming,
                next_incoming_date: el.dataset.date,
              }
            })
          })
      },

      closeModalProduct: function () {
        this.stopVideos()
      },

      /*============================================================================
          Product media (3D)
        ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(
          this.selectors.media
        )
        if (modelViewerElements.length < 1) return

        theme.ProductMedia.init(modelViewerElements, this.sectionId)
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          'shopify_xr_launch',
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
              ':not(.' +
              self.classes.hidden +
              ')'
            )
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true,
              })
            )
          }.bind(this)
        )
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.addEventListener(
            'click',
            function () {
              var slide = this.cache.mainSlider.querySelector(
                selectors.currentSlide
              )
              var media = slide.querySelector(this.selectors.media)
              if (media) {
                media.dispatchEvent(
                  new CustomEvent('mediaHidden', {
                    bubbles: true,
                    cancelable: true,
                  })
                )
              }
            }.bind(this)
          )
        })

        var modelViewer = this.container.querySelector('model-viewer')
        if (modelViewer) {
          modelViewer.addEventListener(
            'shopify_model_viewer_ui_toggle_play',
            function (evt) {
              this.mediaLoaded(evt)
            }.bind(this)
          )

          modelViewer.addEventListener(
            'shopify_model_viewer_ui_toggle_pause',
            function (evt) {
              this.mediaUnloaded(evt)
            }.bind(this)
          )
        }
      },

      mediaLoaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.remove(classes.hidden)
          })

        if (this.flickity) {
          this.flickity.setDraggable(false)
        }
      },

      mediaUnloaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.add(classes.hidden)
          })

        if (this.flickity) {
          this.flickity.setDraggable(true)
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId)

        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy()
        }
      },
    })

    return Product
  })()

  theme.Testimonials = (function () {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false,
    }

    function Testimonials(container) {
      this.container = container
      this.timeout
      var sectionId = container.getAttribute('data-section-id')
      this.slideshow = container.querySelector('#Testimonials-' + sectionId)
      this.namespace = '.testimonial-' + sectionId

      if (!this.slideshow) {
        return
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      })
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function () {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults)

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(
            function () {
              this.flickity.goToSlide(1)
            }.bind(this),
            1000
          )
        }
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy()
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play()
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector(
          '.testimonials-slide--' + evt.detail.blockId
        )
        var index = parseInt(slide.dataset.index)

        clearTimeout(this.timeout)

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index)
          this.flickity.pause()
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play()
        }
      },
    })

    return Testimonials
  })()

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected',
    }

    function Photoswipe(container, sectionId) {
      this.container = container
      this.sectionId = sectionId
      this.namespace = '.photoswipe-' + this.sectionId
      this.gallery
      this.images
      this.items
      this.inSlideshow = false

      if (!container || container.dataset.zoom === 'false') {
        return
      }

      if (container.dataset.hasSlideshow === 'true') {
        this.inSlideshow = true
      }
      this.init()
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        // $(selectors.images).each(function () {
        //   $(this).imageZoom({ zoom: 200 });
        // });
        this.container
          .querySelectorAll(selectors.trigger + ', .photoswipe__image')
          .forEach((trigger) => {
            trigger.on('click' + this.namespace, this.triggerClick.bind(this))
          })
      },

      triggerClick: function (evt) {
        this.items = this.getImageData()

        var image = this.inSlideshow
          ? this.container.querySelector(selectors.activeImage)
          : evt.currentTarget

        var index = this.inSlideshow
          ? this.getChildIndex(image)
          : image.dataset.index

        this.initGallery(this.items, index)
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0
        if (el != null) {
          while ((el = el.previousSibling) != null) {
            i++
          }
        }
        // 1-based index required
        return i + 1
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(
            selectors.slideshowTrack + selectors.images
          )
          : this.container.querySelectorAll(selectors.images)

        var items = []
        var options = {}

        this.images.forEach((el) => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5,
          }

          items.push(item)
        })

        return items
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0]

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop
            var thumbnail = items[index].el
            var rect = thumbnail.getBoundingClientRect()
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
          },
        }

        this.gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        )

        this.gallery.init()
        this.gallery.listen('afterChange', this.afterChange.bind(this))
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex()
        this.container.dispatchEvent(
          new CustomEvent('photoswipe:afterChange', {
            detail: {
              index: index,
            },
          })
        )
      },
    })

    return Photoswipe
  })()

  theme.BackgroundImage = (function () {
    var selectors = {
      parallaxContainer: '.parallax-container',
    }

    function backgroundImage(container) {
      this.container = container
      if (!container) {
        return
      }

      var sectionId = container.getAttribute('data-section-id')
      this.namespace = '.' + sectionId

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
      })
    }

    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function () {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(
            selectors.parallaxContainer
          )
          var args = {
            namespace: this.namespace + '-parallax',
            desktopOnly: true,
          }

          theme.parallaxSections[this.namespace] = new theme.Parallax(
            parallaxContainer,
            args
          )
        }
      },

      onUnload: function (evt) {
        if (!this.container) {
          return
        }
        if (
          theme.parallaxSections[this.namespace] &&
          typeof theme.parallaxSections[this.namespace].destroy === 'function'
        ) {
          theme.parallaxSections[this.namespace].destroy()
        }
        delete theme.parallaxSections[this.namespace]
      },
    })

    return backgroundImage
  })()

  theme.Blog = (function () {
    function Blog(container) {
      this.tagFilters()
    }

    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function () {
        var filterBy = document.getElementById('BlogTagFilter')

        if (!filterBy) {
          return
        }

        filterBy.addEventListener('change', function () {
          location.href = filterBy.value
        })
      },
    })

    return Blog
  })()

  theme.SlideshowSection = (function () {
    var selectors = {
      parallaxContainer: '.parallax-container',
    }

    function SlideshowSection(container) {
      this.container = container
      var sectionId = container.getAttribute('data-section-id')
      this.slideshow = container.querySelector('#Slideshow-' + sectionId)
      this.namespace = '.' + sectionId

      if (!this.slideshow) {
        return
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
      })
    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function () {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide')

        theme.loadImageSection(this.slideshow)

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            autoPlay: this.slideshow.dataset.autoplay
              ? parseInt(this.slideshow.dataset.speed)
              : false,
          }

          $('.vego-slide-video').map((item) => {
            const $video = $('.video-div', item)
            new theme.YouTube($video.attr('id'), {
              videoId: $video.data('video-id'),
              videoParent: `#${$(item).attr('id')}`,
            })
          })

          this.flickity = new theme.Slideshow(this.slideshow, {
            ...sliderArgs,
            onChange: (index) => {
            },
          })
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected')
        }

        if (this.container.hasAttribute('data-parallax')) {
          // Create new parallax for each slideshow image
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(
            function (el, i) {
              new theme.Parallax(el, {
                namespace: this.namespace + '-parallax-' + i,
              })
            }.bind(this)
          )
        }
      },

      forceReload: function () {
        this.onUnload()
        this.init()
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy()
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play()
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector(
          '.slideshow__slide--' + evt.detail.blockId
        )
        var index = parseInt(slide.dataset.index)

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index)
          this.flickity.pause()
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play()
        }
      },
    })

    return SlideshowSection
  })()

  theme.VideoSection = (function () {
    var selectors = {
      videoParent: '.video-parent-section',
    }

    function videoSection(container) {
      this.container = container
      this.sectionId = container.getAttribute('data-section-id')
      this.namespace = '.video-' + this.sectionId
      this.videoObject

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500,
      })
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function () {
        var dataDiv = this.container.querySelector('.video-div')
        if (!dataDiv) {
          return
        }
        var type = dataDiv.dataset.type

        switch (type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId
            this.initYoutubeVideo(videoId)
            break
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId
            this.initVimeoVideo(videoId)
            break
          case 'mp4':
            this.initMp4Video()
            break
        }
      },

      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube('YouTubeVideo-' + this.sectionId, {
          videoId: videoId,
          videoParent: selectors.videoParent,
        })
      },

      initVimeoVideo: function (videoId) {
        //   this.videoObject = new theme.VimeoPlayer(
        //     'Vimeo-' + this.sectionId,
        //     videoId,
        //     {
        //       videoParent: selectors.videoParent,
        //     }
        //   )
      },

      initMp4Video: function () {
        var mp4Video = 'Mp4Video-' + this.sectionId
        var mp4Div = document.getElementById(mp4Video)
        var parent = mp4Div.closest(selectors.videoParent)

        if (mp4Div) {
          parent.classList.add('loaded')

          var playPromise = document.querySelector('#' + mp4Video).play()

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise
              .then(function () {
                // playback normal
              })
              .catch(function () {
                mp4Div.setAttribute('controls', '')
                parent.classList.add('video-interactable')
              })
          }
        }
      },

      onUnload: function (evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '')
        if (
          this.videoObject &&
          typeof this.videoObject.destroy === 'function'
        ) {
          this.videoObject.destroy()
        }
      },
    })

    return videoSection
  })()

  theme.Recommendations = (function () {
    var selectors = {
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product',
    }

    function Recommendations(container) {
      this.container = container
      this.sectionId = container.getAttribute('data-section-id')
      this.url = container.dataset.url

      selectors.recommendations = 'Recommendations-' + this.sectionId

      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 800,
      })
    }

    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function () {
        var section = document.getElementById(selectors.recommendations)

        if (!section || section.dataset.enable === 'false') {
          return
        }

        var id = section.dataset.productId
        var limit = section.dataset.limit

        var url =
          this.url +
          '?section_id=product-recommendations&limit=' +
          limit +
          '&product_id=' +
          id

        fetch(url)
          .then(function (response) {
            return response.text()
          })
          .then(
            function (html) {
              // Convert the HTML string into a document object
              var parser = new DOMParser()
              var doc = parser.parseFromString(html, 'text/html')
              var div = doc.querySelector(selectors.sectionClass)
              var placeholder = section.querySelector(selectors.placeholder)
              placeholder.innerHTML = ''
              placeholder.appendChild(div)

              if (!div) {
                this.container.classList.add('hide')
                return
              }

              theme.reinitProductGridItem(section)

              // If no results, hide the entire section
              var results = div.querySelectorAll(selectors.productResults)
              if (results.length === 0) {
                this.container.classList.add('hide')
              }
            }.bind(this)
          )
      },
    })

    return Recommendations
  })()

  theme.FooterSection = (function () {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]',
    }

    function FooterSection(container) {
      this.container = container

      this.container = container
      this.localeDisclosure = null
      this.currencyDisclosure = null

      this.init()
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale)
        var currencyEl = this.container.querySelector(selectors.currency)

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl)
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl)
        }

        // Change email icon to submit text
        var newsletterInput = document.querySelector(
          '.footer__newsletter-input'
        )
        newsletterInput.addEventListener('keyup', function () {
          newsletterInput.classList.add('footer__newsletter-input--active')
        })

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container)
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy()
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy()
        }
      },
    })

    return FooterSection
  })()

  theme.YotpoReview = (function () {
    function YotpoReview() {
      if ($('.index-review').length) {
        this.init()
        this.relayout()
      }
    }

    YotpoReview.prototype.relayout = function () {
      var yotpoCard = $('.review-header .yotpo-bottomline')
      if (yotpoCard.length) {
        var $a = yotpoCard.find('a.text-m')
        $a.attr('href', '/pages/happy-customers')
        $a.text(' (' + $a.text() + ')')

        $('.review-header .yotpo .sr-only').prependTo($a)
      } else {
        setTimeout(this.relayout.bind(this), 1000)
      }
    }

    YotpoReview.prototype.init = function () {
      var width = document.documentElement.offsetWidth - 80
      if (!theme.isMobile()) {
        $('.review-slider .review-slide-item').width(width)
      }
      var reviewV3 = $('.review-slider').closest('.index-review').hasClass('index-review-v3')

      var prevArrow = '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"/></svg></button>'
      var nextArrow = '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"/></svg></button>'
      if (reviewV3) {
        prevArrow = '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"/></svg></button>'
        nextArrow = '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"/></svg></button>'
      }

      $('.review-slider')
        .slick({
          arrows: true,
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          draggable: false,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                draggable: true,
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true
              },
            }
          ],
        })
        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
          AOS.refreshHard()
        })
        .css('overflow', 'initial')
    }
    return YotpoReview
  })()
  theme.gridAddOns = () => {
    let classArr = [
      'feature-add-ons-seedling-trays',
      'feature-add-ons-action-seedlings',
      'feature-add-ons-action',
      'feature-add-ons-bundle'
    ]

    classArr.forEach(item => {
      let pEl = $(`.page-section-featured-products-box .${item} .grid-product__group`);
      if (!pEl?.length) return
      const itemEls = $(`.page-section-featured-products-box .${item} .grid-product__group>div`)
      if (!theme.isMobile()) {
        itemEls.width((pEl.width() - 60) / 4)
        if (itemEls.length < 5) return;
      } else {
        if (!pEl.hasClass('mobile-slick-initialized') && itemEls.length) {
          Array.from({
            length: Math.ceil(itemEls.length / 2)
          })
            .forEach((item, index) => {
              let divEl = $('<div></div>');
              pEl.append(divEl)
              Array.from({
                length: 2
              }).map((item, childIndex) => {
                let currentEl = $(itemEls[index * 2 + childIndex]);
                if (itemEls[index * 2 + childIndex]) {
                  divEl.append(currentEl.detach())
                }
              })
            })
          pEl.addClass('mobile-slick-initialized')
        }
      }
      pEl.slick({
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: true,
        infinite: true,
        prevArrow: theme.isMobile() ? `.${item}-btns .slick-prev` : '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
        nextArrow: theme.isMobile() ? `.${item}-btns .slick-next` : '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              draggable: true,
              arrows: true,
              infinite: true,
              dots: false,
              adaptiveHeight: false,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      }).on('afterChange', function () { AOS.refreshHard() });
    })

  }
  theme.announcementBarSlickInit = () => {

  }
  theme.CollectionHeader = (function () {
    var hasLoadedBefore = false

    function CollectionHeader(container) {
      this.namespace = '.collection-header'

      var heroImageContainer = container.querySelector('.collection-hero')
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload()
        }
        theme.loadImageSection(heroImageContainer)

        if (container.dataset && container.dataset.parallax) {
          var parallaxContainer = container.querySelector('.parallax-container')
          var args = {
            namespace: this.namespace + '-parallax',
          }
          theme.parallaxSections[this.namespace] = new theme.Parallax(
            parallaxContainer,
            args
          )
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader()
      }

      hasLoadedBefore = true
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper')
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload()
          }
        }
      },

      onUnload: function () {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy()
          delete theme.parallaxSections[this.namespace]
        }
      },
    })

    return CollectionHeader
  })()

  theme.CollectionSidebar = (function () {
    var drawerStyle = false

    function CollectionSidebar(container) {
      this.container = container
      this.init()
    }

    CollectionSidebar.prototype = Object.assign(
      {},
      CollectionSidebar.prototype,
      {
        init: function () {
          this.onUnload()

          drawerStyle = this.container.dataset.style === 'drawer'
          theme.FilterDrawer = new theme.Drawers(
            'FilterDrawer',
            'collection-filters',
            true
          )
        },

        forceReload: function () {
          this.init()
        },

        onSelect: function () {
          if (theme.FilterDrawer) {
            if (!drawerStyle) {
              theme.FilterDrawer.close()
              return
            }

            if (drawerStyle || theme.config.bpSmall) {
              theme.FilterDrawer.open()
            }
          }
        },

        onDeselect: function () {
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close()
          }
        },

        onUnload: function () {
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close()
          }
        },
      }
    )

    return CollectionSidebar
  })()

  theme.Collection = (function () {
    var isAnimating = false

    var selectors = {
      sortSelect: '#SortBy',

      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',

      collectionGrid: '.collection-grid__wrapper',
      sidebar: '#CollectionSidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list a',
      filters: '.collection-filter',
    }

    var config = {
      combineTags: false,
    }

    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
    }

    function Collection(container) {
      this.container = container
      this.sectionId = container.getAttribute('data-section-id')
      this.namespace = '.collection-' + this.sectionId

      this.init()
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function () {
        this.initSort()
        this.colorSwatchHovering()
        this.initFilters()
        theme.reinitSection('collection-sidebar')
      },

      initSort: function () {
        this.sortSelect = this.container.querySelector(selectors.sortSelect)

        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue()
          this.sortSelect.addEventListener(
            'change',
            this.onSortChange.bind(this)
          )
          this.initParams()
        }
      },

      initParams: function () {
        this.queryParams = {}

        if (location.search.length) {
          var aKeyValue
          var aCouples = location.search.substr(1).split('&')
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=')
            if (aKeyValue.length > 1) {
              this.queryParams[decodeURIComponent(aKeyValue[0])] =
                decodeURIComponent(aKeyValue[1])
            }
          }
        }
      },

      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort
      },

      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute('data-default-sortby')
      },

      onSortChange: function () {
        this.queryParams.sort_by = this.getSortValue()

        if (this.queryParams.page) {
          delete this.queryParams.page
        }

        window.location.search = new URLSearchParams(
          Object.entries(this.queryParams)
        )
      },

      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(
          selectors.colorSwatchImage
        )
        if (!colorImages.length) {
          return
        }

        this.container
          .querySelectorAll(selectors.colorSwatch)
          .forEach((swatch) => {
            swatch.addEventListener('mouseenter', function () {
              var id = swatch.dataset.variantId
              var image = swatch.dataset.variantImage
              var el = document.querySelector(
                '.grid-product__color-image--' + id
              )
              el.style.backgroundImage = 'url(' + image + ')'
              el.classList.add('is-active')
            })
            swatch.addEventListener('mouseleave', function () {
              var id = swatch.dataset.variantId
              document
                .querySelector('.grid-product__color-image--' + id)
                .classList.remove('is-active')
            })
          })
      },

      /*====================
          Collection filters
        ====================*/
      initFilters: function () {
        var tags = document.querySelectorAll(selectors.tags)

        if (!tags.length) {
          return
        }

        // Ajax pagination
        window.addEventListener(
          'popstate',
          function (state) {
            if (state) {
              this.getNewCollectionContent(location.href)
            }
          }.bind(this)
        )

        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition()

          window.on(
            'resize',
            theme.utils.debounce(500, this.setFilterStickyPosition)
          )
        }

        config.combineTags =
          document
            .querySelector(selectors.sidebar)
            .getAttribute('data-combine-tags') == 'true'

        document.querySelectorAll(selectors.tags).forEach((tag) => {
          tag.addEventListener('click', this.tagClick.bind(this))
        })
      },

      tagClick: function (evt) {
        var el = evt.currentTarget

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close()
        }

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return
        }

        evt.preventDefault()
        if (isAnimating) {
          return
        }

        isAnimating = true

        var parent = el.parentNode
        var newUrl = el.href

        if (config.combineTags) {
          if (parent.classList.contains(classes.activeTag)) {
            parent.classList.remove(classes.activeTag)
          } else {
            parent.classList.add(classes.activeTag)

            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if (el.closest('li').classList.contains(classes.removeTagParent)) {
              parent.remove()
            } else {
              var newTag = document.createElement('li')
              var newTagLink = document.createElement('a')
              newTag.classList.add('tag', 'tag--remove')
              newTagLink.classList.add('btn', 'btn--small')
              newTagLink.innerText = el.innerText
              newTag.appendChild(newTagLink)

              // Append new tag in both drawer and sidebar
              document
                .querySelectorAll(selectors.activeTagList)
                .forEach((list) => {
                  list.appendChild(newTag)
                })
            }
          }
        } else {
          // Remove active state on all tags, re-add to new one
          document.querySelectorAll(selectors.tags).forEach((tag) => {
            tag.parentNode.classList.remove(classes.activeTag)
          })
          parent.classList.add(classes.activeTag)
        }

        this.updateScroll(true)

        history.pushState({}, '', newUrl)
        document.querySelector(selectors.collectionGrid).classList.add('unload')
        this.getNewCollectionContent(newUrl)
      },

      getNewCollectionContent: function (url) {
        url = url.indexOf('?') === -1 ? url + '?view=ajax' : url + '&view=ajax'

        var ajaxContainer = document.getElementById('CollectionAjaxResult')

        fetch(url)
          .then(function (response) {
            return response.text()
          })
          .then(
            function (html) {
              var parser = new DOMParser()
              var doc = parser.parseFromString(html, 'text/html')

              var newContent = doc.getElementById('CollectionAjaxContent')

              ajaxContainer.innerHTML = ''
              ajaxContainer.append(newContent)

              theme.reinitSection('collection-template')
              this.updateScroll(false)
              theme.reinitProductGridItem()

              isAnimating = false

              // trigger resize?
            }.bind(this)
          )
      },

      updateScroll: function (animate) {
        var scrollTo
        if (theme.config.bpSmall) {
          // 60 is ~ height of sticky filters
          scrollTo = document.querySelector('[data-scroll-to]').offsetTop - 60
        } else {
          scrollTo =
            document.getElementById('CollectionAjaxResult').offsetTop + 1
        }

        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight
          scrollTo = scrollTo - headerHeight
        }

        if (animate) {
          window.scrollTo({ top: scrollTo, behavior: 'smooth' })
        } else {
          window.scrollTo({ top: scrollTo })
        }
      },

      setFilterStickyPosition: function () {
        var headerHeight = document.querySelector('.site-header').offsetHeight
        document.querySelector(selectors.filters).style.top =
          headerHeight + 10 + 'px'

        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector('.grid__item--sidebar')
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px'
        }
      },

      forceReload: function () {
        this.init()
      },
    })

    return Collection
  })()

  /**
   * @deprecated
   */
  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container
      var sectionId = this.container.getAttribute('data-section-id')
      this.cookieName = 'newsletter-' + sectionId

      if (!container) {
        return
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return
      }

      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode,
      }

      this.modal = new theme.Modals(
        'NewsletterPopup-' + sectionId,
        'newsletter-popup-modal'
      )

      // Open modal if errors or success message exist
      if (
        container.querySelector('.errors') ||
        container.querySelector('.note--success')
      ) {
        this.modal.open()
      }

      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true)
        return
      }

      document.addEventListener(
        'modalClose.' + container.id,
        this.closePopup.bind(this)
      )

      if (!this.data.cookie || this.data.testMode === 'true') {
        this.initPopupDelay()
      }
    }

    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (Shopify && Shopify.designMode) {
          return
        }
        setTimeout(
          function () {
            this.modal.open()
          }.bind(this),
          this.data.secondsBeforeShow * 1000
        )
      },

      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' })
          return
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry })
      },

      onLoad: function () {
        this.modal.open()
      },

      onSelect: function () {
        this.modal.open()
      },

      onDeselect: function () {
        this.modal.close()
      },
    })

    return NewsletterPopup
  })()


  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false
    }

    var testKey = 'test'
    var storage
    if (type === 'session') {
      storage = window.sessionStorage
    }
    if (type === 'local') {
      storage = window.localStorage
    }

    try {
      storage.setItem(testKey, '1')
      storage.removeItem(testKey)
      return true
    } catch (error) {
      return false
    }
  }

  theme.reinitSection = function (section) {
    for (var i = 0; i < theme.sections.instances.length; i++) {
      var instance = theme.sections.instances[i]
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload()
        }
      }
    }
  }
  theme.isMobile = () => {
    return window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) || window.innerWidth < 750
  }
  theme.isSafari = () => {
    return (
      /Safari/.test(navigator.userAgent) &&
      !/Chrome/.test(navigator.userAgent) &&
      !/CriOS/.test(navigator.userAgent)
    )
  }
  theme.isIOS = () => {
    var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios device
    return isiOS
  }
  theme.isIOSV2 = function () {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  theme.isIpadOS = function () {
    const ua = window.navigator.userAgent;
    if (ua.indexOf('iPad') > -1 && ua.indexOf('macintosh') > -1 && 'ontouchend' in document) {
      return true;
    }
    return navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform);
  }
  /***
   * ## get right compare at price for different marketing
   */
  theme.unityCompareAtPrice = (compareAtPrice, varaintId) => {
    if (theme.config.discountInfo?.[varaintId]?.auCompareAtPrice && theme.isAu()) {
      compareAtPrice = theme.config.discountInfo[varaintId].auCompareAtPrice;
    } else if (
      theme.config.discountInfo?.[varaintId]?.caCompareAtPrice &&
      theme.isCa()
    ) {
      compareAtPrice = theme.config.discountInfo[varaintId].caCompareAtPrice;
    }
    return compareAtPrice
  }
  /**
   * 
   * @returns true is landscape, false is vertical screen
   */
  theme.isLandscape = () => {
    return window.orientation === 90 || window.orientation === -90
  }
  /**
   * <div
   * data-descresp="true"
   * data-mobiledesc="{{block.settings.descMobile}}"
   * data-desc="{{block.settings.desc}}" >
   * </div>
   * @param {*} scope
   */
  theme.resetMobileText = function () {
    const NeedToSetEle = 'data-descresp="true"'

    $(`[${NeedToSetEle}]`).each((index, item) => {
      $(item).html(
        theme.isMobile() ? $(item).data('mobiledesc') : $(item).data('desc')
      )
    })
  }
  /**
   * Vego Garden Bed VS Other Brands
   */
  theme.expandVs = () => {
    $('.vs-action').click(() => {
      $('.page-vs-columns').height('auto')
      $('.vs-action').hide();
    })
  }
  theme.setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  theme.EMAIL_KEY = 'p_ref'
  theme.TRHEE_D_KEY = '3d_ref'
  theme.getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }

    }
    return "";
  }
  theme.getEmailLinkCookie = () => {
    return theme.getCookie(theme.EMAIL_KEY)
  }
  /**
   * ## Handle visit from email
   */
  theme.emailLinkHandle = () => {
    let postOrderRef = new URLSearchParams(window.location.search).get(theme.EMAIL_KEY)
    if (postOrderRef) {
      theme.setCookie(theme.EMAIL_KEY, postOrderRef, 30)
    }
  }
  /**
   * Compare other brands
   */
  theme.compareOtherBrands = () => {
    if (!$(`.vego-compare-other-brands-graph`).length) return;
    function elClick(e) {
      let img = document.querySelector(`.${e.target.dataset.img}`)
      if (img) {
        let displayVal = img.style.display;
        img.style.display = displayVal == 'none' ? 'block' : 'none'
      }
    }
    window.onload = () => {

      document.addEventListener('click', (e) => {
        if (e.target.tagName === 'BUTTON' && Array.from(e.target.classList).indexOf('vego-product-link')) {
          document.querySelectorAll('.product-img')
            .forEach(el => {
              if (Array.from(el.classList).indexOf(e.target.dataset.img) == -1)
                el.style.display = 'none'
            })

        } else if (Array.from(e.target.classList).indexOf('product-img') == -1) {
          document.querySelectorAll('.product-img')
            .forEach(el => {
              el.style.display = 'none'
            })
        }
      })
      document.querySelectorAll('.vego-proudct-link')
        .forEach(el => {
          el.addEventListener('click', elClick)
        })
    }
  }
  theme.setMarketLocalizationAndCartCurrency = () => {
    //let isOtherMarket = window.location.pathname.startsWith('/en-ca')

    let LOCALIZATION = 'localization'
    let CART_CURRENCY = 'cart_currency'
    Cookies.remove(CART_CURRENCY, { path: '/' })
    Cookies.remove(CART_CURRENCY, { path: '/en-ca' })
    Cookies.remove(CART_CURRENCY, { path: '/en-au' })
    Cookies.remove(LOCALIZATION, { path: '/' })
    Cookies.remove(LOCALIZATION, { path: '/en-ca' })
    Cookies.remove(LOCALIZATION, { path: '/en-au' })
    if (theme.isCA()) {
      Cookies.set(CART_CURRENCY, 'CAD', { path: '/en-au' })
      Cookies.set(CART_CURRENCY, 'CAD', { path: '/en-ca' })
      Cookies.set(LOCALIZATION, 'CA', { path: '/en-ca' })
      Cookies.set(LOCALIZATION, 'CA', { path: '/en-au' })
    } else {
      Cookies.set(CART_CURRENCY, 'USD', { path: '/' })
      Cookies.set(LOCALIZATION, 'US', { path: '/' })
    }
  }
  // listen cookies' change
  theme.cookieListener = () => {
    if (window.cookieStore) {
      window.cookieStore.addEventListener('change', ({ changed }) => {
        let localizationAndCartCurrencyChanged = false
        for (const { name, value } of changed) {
          if (name == 'cart_currency' || name == 'localization') {
            if (theme.pathMarketPrefix()) {
              if (value.indexOf('CA') > -1 && !theme.pathMarketPrefix()) localizationAndCartCurrencyChanged = true
              else if (value.indexOf('US') > -1 && theme.pathMarketPrefix()) localizationAndCartCurrencyChanged = true
            }
          }
        }
        if (localizationAndCartCurrencyChanged) theme.setMarketLocalizationAndCartCurrency()
      });
    }
  }
  theme.bundle = () => {
    if ($('.bundle-slider').length > 1) {
      const groups = []
      $('.bundle-slider').each((index, el) => {

        const group = Array.from(el.classList).find(item => !['bundle-item-section', 'bundle-slider'].includes(item))
        if (group) {
          if (!groups[group]) groups[group] = [];
          groups[group].push(el);
        } else {
          console.log('no bundle slide appear')
        }
      })


      Object.keys(groups)
        .forEach(groupKey => {

          if (groups[groupKey].length < 2) return;
          const firstEl = groups[groupKey][0]
          groups[groupKey].slice(1)
            .reverse()
            .forEach((otherEl) => {

              let parent = otherEl.parentNode
              firstEl.parentNode.insertBefore(otherEl, firstEl.nextSibling)
              parent.remove()
            })
          $(firstEl.parentNode).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(firstEl.parentNode).css('backgroundColor', $(slick.$slides[nextSlide]).css('backgroundColor'))
          });
          $(firstEl.parentNode).on('init', function (event, slick) {
            $(firstEl.parentNode).css('backgroundColor', $(slick.$slides[0]).css('backgroundColor'))
          });
          $(firstEl.parentNode).slick({
            dots: true,
            slidesToShow: 1,
            centerPadding: '0px',
            slidesToScroll: 1,
            draggable: false,
            prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
            arrows: true,// !!$('.bundle-detail-item').length,
            infinite: true,
            responsive: [
              {
                breakpoint: window.innerWidth,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          })
            .on('afterChange', function (event, slick, currentSlide, nextSlide) {
              AOS.refreshHard()
            })
            .css('overflow', 'initial')

        })


    }

  }
  theme.getTimeDiff = ($item) => {
    if (!$item.length) return false;
    const endAt = $item.data('countdown')
    const startAt = $item.data('countdownStart')
    const countdownUnit = $item.data('countdownUnit')
    var countDownDate = new Date(`${endAt} UTC-6:00`);
    var countDownStartDate = new Date(`${startAt} UTC-6:00`);
    var ONE_HOUR = 60 * 60 * 1000;
    function getTimeDiff() {

      var remain = (countDownDate - new Date().getTime()) //PST - user's local time
      var isStart = (new Date().getTime() - countDownStartDate) > 0 && remain > 0 //PST - user's local time
      let days = Math.floor(remain / (ONE_HOUR * 24))
      let hrs = Math.floor((remain - days * ONE_HOUR * 24) / ONE_HOUR);
      let mins = Math.floor((remain - days * ONE_HOUR * 24 - hrs * ONE_HOUR) / (ONE_HOUR / 60));
      let secs = Math.floor((remain - days * ONE_HOUR * 24 - hrs * ONE_HOUR - mins * (ONE_HOUR / 60)) / 1000);
      return {
        isStart,
        hrs,
        hrsDay: Math.floor((remain) / ONE_HOUR),
        days, mins, secs, expire: remain < 0,
        countdownUnit
      }
    }
    return getTimeDiff()
  }
  // BOGO for special color
  theme.changeTag = ($item) => {
    let card_item = $item.closest('[data-product-handle="9-in-1-modular-raised-garden-bed"]');
    if (card_item.length) {
      let current_val = card_item.find(':checked+.color-swatch__label span').text().trim()
      if (window.innerWidth < 768) { current_val = card_item.find('.vego-select').text().trim() || card_item.find('[name="Color"]').val().trim() }
      if (current_val == 'Terra Cotta' || current_val == 'Sky Blue') {
        card_item.addClass('tc_sb')
        card_item.find('.grid-product-badge-save-tag').show()
        card_item.find('.grid-product-badge--discount').html?.('Extra BOGO 30% Off')
      } else {
        card_item.find('.grid-product-badge-save-tag').hide()
        card_item.removeClass('tc_sb')
      }
    }
  }
  theme.countdown = (action) => {
    //BEGIN count down
    function prependZero(val) {
      if (val == 0 || val < 10 && val > 0) {
        return '0' + val
      }
      return val
    }
    let countTimer = {};
    function clock($item, showDayAt,keyIndex) {
      var remainMiliSeconds = theme.getTimeDiff($item);
      $('.product-flash-sale-countdown').css({ 'display': 'inline-flex' })
      if (!remainMiliSeconds || remainMiliSeconds.expire || !remainMiliSeconds.isStart) {
        $item.hide();
        $item.closest('.product-count-down').hide()
        $('.product-flash-sale-countdown').hide()
        return clearTimeout(countTimer[keyIndex]);
      }
      $item.show()
      const showDays = remainMiliSeconds.days >= showDayAt
      var day = prependZero(remainMiliSeconds.days)
      var hour = showDays ? prependZero(remainMiliSeconds.hrs) : prependZero(remainMiliSeconds.hrsDay);
      var min = prependZero(remainMiliSeconds.mins);
      var sec = prependZero(remainMiliSeconds.secs);
      $item.find(".count-down-time").html(
        (showDays ? `<div class="label-min"><div><div>${day}</div><span>DAY</span></div><span>:</span></div>` : '') +
        `<div class="label-min"><div><div>${hour}</div><span>HRS</span></div><span>:</span></div>` +
        `<div class="label-min"><div><div>${min}</div><span>MIN</span></div><span>:</span></div>` +
        `<div class="label-min"><div><div>${sec}</div><span>SEC</span></div></div>`
      );
      let pcc_el = $item.find(".product-card-count-down-time");
      let enable_label = pcc_el.data('enableLabel')
      pcc_el.html(
        (showDays ? `<div class="label-min"><div><div>${day}</div>${enable_label ? `<span>DAY</span>` : ''}</div><span>:</span></div>` : '') +
        `<div class="label-min"><div><div>${hour} </div>${enable_label ? `<span>HRS</span>` : ''}</div><span>:</span></div>` +
        `<div class="label-min"><div><div>${min} </div>${enable_label ? `<span>MIN</span>` : ''}</div><span>:</span></div>` +
        `<div class="label-min"><div><div>${sec} </div>${enable_label ? `<span>SEC</span>` : ''}</div></div>`
      );
      countTimer[keyIndex] = setTimeout(
        () => clock($item, showDayAt, keyIndex),
        1000
      );
      // theme.changeTag($item)

    }

    if (action == 'destory') {
      if (countTimer) {
        clearTimeout(countTimer)
      }
    } else {
      console.log($(".count-down-component").length);
      $('.count-down-component').each((index, item) => {
        //if (!$('.count-down-component').length) return false;
        //const endAt = $('.count-down-component').data('countdown')
        // const endStart = $('.count-down-component').data('countdownStart')
        const showDayAt = parseInt($(item).data('day') ?? '100')
        clock($(item), showDayAt,index)
        $(item).click(function () {
          if ($(item).data('countdownLink')) {
            window.location.href = $(item).data('countdownLink')
          }
        })
      })
      // $('.count-down-component').click(function () {
      //   window.open(`https://vegogarden.com/collections/all`)
      // })
      //END count down
    }
  }

  theme.reinitProductGridItem = function (scope) {
    /**
     * @deprecated
     */
    if (AOS) {
      AOS.refreshHard()
    }

    theme.initQuickShop()

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls()
      SPR.loadBadges()
    }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init()
  }
  /**
   * rolling beds scroll events
   */
  theme.rollingAddon = () => {
    $('.rolling-addons-dots span').click((e) => {
      let $hash = $(e.currentTarget).data('href')
      let offsetLen = $(`.rolling-addons-container .grid`).offset().left - $(`.rolling-addons-container .grid [data-product-id="${$hash}"]`).offset().left
      $(e.currentTarget).addClass('active').siblings('span').removeClass('active')
      $('.rolling-addons-container').scrollLeft(Math.abs(offsetLen))
    })
  }
  theme.productFaq = () => {
    const faqProblem = '.page-section-faq-problem-box details'
    if (window.location.href.indexOf('school-gardens') > -1 || window.location.href.indexOf('bundle-lp') > -1) return;
    const faqTagesChange = function (faqProblem) {
      $(faqProblem).map((index, item) => {
        $(item).removeAttr('open')
        if ($(item).attr("data-tags")) {
          if ($(item).attr("data-tags").indexOf($faqHtml?.replace?.('&amp;', '&')) >= 0) {
            $(item).show()
          } else {
            $(item).hide()
          }
        }
      })
    }

    let $faqHtml = $(".page-section-faq-products-box .page-section-faq-tags-box div.active").data('tag')
    const $faqTags = $(".page-section-faq-products-box .page-section-faq-tags-box div")

    const faqChange = window.faqChange = function () {
      faqTagesChange(faqProblem)
      $('.page-section-faq-problem-box details:visible').each(function (i) {
        if (i < (theme.isMobile() ? 1 : 3)) {
          $(this).attr('open', true)
        }
      })
      if (!$faqHtml) {
        $(faqProblem).show().attr('open', true)
      }
      // $(`.page-section-faq-problem-box details[open] > p`).textFolder({
      //   btnbg: '#EBECCE',
      // })
    }

    // $(faqProblem).on('toggle', function () {
    //   if (this.open) {
    //     $(this).find('> p').textFolder({
    //       btnbg: '#EBECCE',
    //       hideLess: theme.isMobile()
    //     })
    //   }
    // })

    $faqTags.on('click', (e) => {
      if ($(e.currentTarget).hasClass('active') === false) {
        $faqTags.map((index, item) => {
          $(item).removeClass("active")
        })
        $(e.currentTarget).addClass('active')
        $faqHtml = e.currentTarget.dataset.tag
        faqChange()
        if (!theme.isMobile()) {
          const left = $(`${faqProblem}-left details:not(:hidden)`).attr("data-index")
          const right = $(`${faqProblem}-right details:not(:hidden)`).attr("data-index")
          if (right < left) {
            $(".page-section-faq-products-bg-box .page-section-faq-problem-box").css({ "flex-direction": "row-reverse" })
          } else {
            $(".page-section-faq-products-bg-box .page-section-faq-problem-box").css({ "flex-direction": "row" })
          }
        }
      }
    })

    // $(window).resize(faqChange);
    if (!$(faqProblem).closest('.page-section-faq-problem-box-global').length) faqChange();
  }

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === 'function') {
              options.callback()
              observer.unobserve(entry.target)
            }
          }
        })
      },
      { rootMargin: '0px 0px ' + threshold + 'px 0px' }
    )

    observer.observe(options.element)
  }

  /*============================================================================
      Things that don't require DOM to be ready
    ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session')
  theme.config.hasLocalStorage = theme.isStorageSupported('local')
  // @deprecated
  AOS?.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true,
  })

  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline')
      document.documentElement.off('keyup.tab')
    }
  })



  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true
      document.dispatchEvent(new CustomEvent('matchSmall'))
    } else {
      theme.config.bpSmall = false
      document.dispatchEvent(new CustomEvent('unmatchSmall'))
    }
  })


  theme.cookieListener()

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init()
    theme.videoModal()
  }
  const ua = typeof window === 'object' ? window.navigator.userAgent : '';

  let _isIOS = -1;
  let _isAndroid = -1;

  /**
   * @deprecated
   * @returns 
   */
  function isIOS() {
    if (_isIOS === -1) {
      _isIOS = /iPhone|iPod|iPad/i.test(ua) ? 1 : 0;
    }
    return _isIOS === 1;
  }

  function isAndroid() {
    if (_isAndroid === -1) {
      _isAndroid = /Android/i.test(ua) ? 1 : 0;
    }
    return _isAndroid === 1;
  }
  theme.isAndroid = isAndroid

  /**
   *  scroll discount input to visible area when the soft keyboard opened
   */
  /**
   * ## 计算位置
   * @param {*} e
   */
  function calcPosition(e) {
    let svgEle = e.currentTarget.getBoundingClientRect();
    let info = e.currentTarget.closest('.info').getBoundingClientRect();
    let tipsEle = e.currentTarget.closest('.info').querySelector('.tips');
    let divEle = e.currentTarget.closest('div').getBoundingClientRect();
    let appendPosition = 86.5;
    if (theme.isMobile()) {
      appendPosition = 80.5;
    }
    tipsEle.style.left = `${(info.width - divEle.width) / 2 + divEle.width - (svgEle.width / 2) - appendPosition}px`
  }

  const layoutMobile = () => {

    let boxEl = $('.design-galleries-img-box');
    if (boxEl.length) {
      try {

        if (theme.isMobile()) $('.design-galleries-img-box .design-galleries-img-item').css('width', '90vw')
        boxEl
          .slick({
            dots: theme.isMobile(),
            slidesToShow: 4,
            centerPadding: '160px',
            slidesToScroll: !theme.isMobile() ? 4 : 1,
            draggable: true,
            arrows: false,
            infinite: true,
            variableWidth: false,
            prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  dots: theme.isMobile(),
                  slidesToShow: 0,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 769,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  centerMode: true,
                  infinite: true,
                  variableWidth: true,
                  centerPadding: '10px'
                },
              },
            ],
          })
          .on('afterChange', function (event, slick, currentSlide, nextSlide) {
            AOS.refreshHard()
          })
        //.css('overflow', 'initial');
        // $('.design-galleries-img-item')
        //   .click((evt) => {
        //     $(evt.currentTarget).addClass('slick-current')
        //     $(evt.currentTarget).siblings().removeClass('slick-current')
        //   })
      } catch (error) {
        console.log(error);
      }
      boxEl.css('display', 'flex')
    }
  }

  /**
   * 
   * Update Mobile Image for menu
   **/
  theme.updateMobileImage = () => {
    if (theme.isMobile()) {
      Array.from(document.querySelectorAll('.menu-combine-item-image[data-m-bg]'))
        .forEach(el => {
          el.style.backgroundImage = 'url(' + el.getAttribute('data-m-bg') + ')';
        })
    }
  }
  DOMready(function () {
    theme.announcementBarSlickInit()
    var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve(); }) });
    initGorgiasChatPromise.then(function () {
      GorgiasChat.on('widget:opened', async (data) => {
        GorgiasChat.setCurrentInput("Help code:" + await window.NOIBUJS.requestHelpCode(false))
      })
    })

    localStorage.setItem('card-btn-abtest', 'a')
    theme.sections = new theme.Sections()
    setTimeout(() => theme.handle3D(), 1500)
    theme.handleUnvalidLink()
    theme.handleCa()
    theme.gridAddOns();
    theme.bundle()
    theme.updateMobileImage()

    document.addEventListener("click", function (e) {
      if (e.target.tagName == 'SHOPIFY-PAYMENT-TERMS') {
        Array.from(document.querySelectorAll('[data-nametag="shop-portal-provider"]')).map((el) => {
          el.setAttribute('style', 'all: unset !important; display: block !important;');
        })
      } else {
        Array.from(document.querySelectorAll('[data-nametag="shop-portal-provider"]')).map((el) => {
          el.setAttribute('style', 'all: unset !important; display: none !important;');
        })
      }
    })

    //
    theme.compareOtherBrands()
    theme.emailLinkHandle()
    layoutMobile()
    // count down
    theme.countdown()
    //$

    // Vego Garden Bed VS Other Brands
    theme.expandVs();


    // rolling add on
    theme.rollingAddon()
    // faq
    theme.productFaq();

    // $('.grid__item[data-product-handle="9-in-1-modular-raised-garden-bed"]').addClass('tc_sb')
    // $('.grid__item[data-product-handle="9-in-1-modular-raised-garden-bed"]').find('.grid-product-badge--discount').html?.('Extra BOGO 30% Off')

    if ($('.needs-collapse-drop')) {
      $('.needs-collapse-drop span').on('click', function () {
        $(this).closest('.composting-needs-section-box').toggleClass('active')
      })
    }

    if ($('.page-section-composter.as-seen-in-slider-composter').length && !theme.isMobile()) {
      $('.page-section-composter.as-seen-in-slider-composter').slick({
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 1000,
      })
    }

    if ($('.engineered-content-tab').length > 0) {
      $('.engineered-content-tab-item').on('click', function (e) {
        $('.engineered-content-tab-item').not(this).removeClass('active')
        $(this).toggleClass('active')
        $('.engineered-content-tab-image').removeClass('active')
        if($('.engineered-content-tab-item.active').length < 1){
          $('.engineered-content-tab-image-noTarget').addClass('active')
        }else{
          $(`.${$(this).data('target')}`).addClass('active')
        }
      })
    }


    if($('.rolling-tree-planter-review-slider').length > 0){
       var width = document.documentElement.offsetWidth - 80
      if (!theme.isMobile()) {
        $('.rolling-tree-planter-review-slider .review-slide-item').width(width)
      }
      var reviewV3 = $('.rolling-tree-planter-review-slider').closest('.index-review').hasClass('index-review-v3')

      var prevArrow = '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"/></svg></button>'
      var nextArrow = '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"/></svg></button>'
      if (reviewV3) {
        prevArrow = '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"/></svg></button>'
        nextArrow = '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"/></svg></button>'
      }

      $('.rolling-tree-planter-review-slider')
        .slick({
          arrows: true,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          draggable: false,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                draggable: true,
                adaptiveHeight: false,
                slidesToShow: 1.2,
                slidesToScroll: 1,
              },
            }
          ],
        })
        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
          AOS.refreshHard()
        })
        .css('overflow', 'initial')
    }

    if ($('.see-it-action-items').length > 0) {
      $('.see-it-action-items .see-it-action-item').on('click', function (e) {
        $('.see-it-action-items-popup video').attr('src',$(this).attr('data-video-src'))
        $('.see-it-action-items-popup').css({
          'display':'flex',
        })
      })
      $('.see-it-action-items-popup .icon-close').on('click', function (e) {
        $('.see-it-action-items-popup video').attr('src','')
        $('.see-it-action-items-popup').css({
          'display':'none',
        })
      })
    }
    if ($('.discover-flex-anchor-point').length > 0) {
      $('.discover-flex-anchor-point-item').on('click', function (e) {
        $('html, body').animate({
          scrollTop: $(`#${$(this).attr('data-anchor-point')}`).offset().top - 100
        }, 500);
      })
    }

    if ($('.whr_embed_hook_btn').length > 0) {
      $('.whr_embed_hook_btn').on('click', function (e) {
        $('html, body').animate({
          scrollTop: $(`#whr_embed_hook_title`).offset().top - 250
        }, 500);
      })
    }
    judgeMarketFn?.();
    if ($('.modes-content-slider').length) {
      $(".modes-content-slider").slick({
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev" aria-label="prev"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"></rect><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"></path></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              draggable: true,
              slidesToShow: 1.2,
              dots: true,
              arrows: false,
              infinite: true,
              adaptiveHeight: false,
            },
          },
        ],
      });
    }

    if ($('.send_gift_card_to_recipient_box').length) {
      $('.send_gift_card_to_recipient_checkbox').on('change', () => {
        $('.send-gift-to-friend-all').toggleClass('hide')
      })
      $('.gift-card-card-form-textarea').on('input', function () {
        $('.gift-card-message-length').text($(this).val().length)
      })
      $('.gift-card-card-form-input[type="email"]').on('blur', function () {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let match = emailRegex.test($(this).val())
        $('.gift-send-email-error ').addClass('hide')
        if (!match) {
          $('.gift-send-email-error ').removeClass('hide')
        }
        console.log(match);

      })

    }

    if ($('.as-soon-in-reviews').length && theme.isMobile()) {
      $('.as-soon-in-reviews').slick({
        draggable: true,
        dots: true,
        arrows: false,
        infinite: true,
        adaptiveHeight: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
      })
    }

    if ($('.videos-page-section-2-slider-index').length && theme.isMobile()) {
      $('.videos-page-section-2-slider-index').slick({
        dots: true,
        slidesToShow: 1.3,
        slidesToScroll: 1,
        arrows: false,
        prevArrow: '<button type="button" class="slick-prev" aria-label="prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74" fill="none"><path d="M37 69.375C54.8525 69.375 69.375 54.8525 69.375 37C69.375 19.1475 54.8525 4.625 37 4.625C19.1475 4.625 4.625 19.1475 4.625 37C4.625 54.8525 19.1475 69.375 37 69.375ZM26.1775 35.268L37.7584 23.8142C38.2093 23.3701 38.7968 23.1459 39.3842 23.1459C39.9807 23.1459 40.5774 23.3749 41.0283 23.8327C41.9256 24.7415 41.9186 26.2031 41.0098 27.1026L31.0799 36.9238L40.9289 46.8004C41.8307 47.7047 41.8284 49.1685 40.9243 50.0703C40.02 50.9746 38.5563 50.9699 37.6544 50.0657L26.1705 38.5495C26.1681 38.5472 26.1681 38.5449 26.1659 38.5426C26.1637 38.5402 26.1613 38.5402 26.1589 38.538C25.9462 38.3229 25.7936 38.0732 25.6826 37.8119C25.678 37.8027 25.6664 37.7934 25.6641 37.7842C25.3218 36.9446 25.493 35.9455 26.1775 35.268Z" fill="white"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74" fill="none"><path d="M37 4.625C19.1475 4.625 4.625 19.1475 4.625 37C4.625 54.8525 19.1475 69.375 37 69.375C54.8525 69.375 69.375 54.8525 69.375 37C69.375 19.1475 54.8525 4.625 37 4.625ZM47.8225 38.732L36.2416 50.1858C35.7907 50.6299 35.2032 50.8541 34.6158 50.8541C34.0193 50.8541 33.4226 50.6251 32.9717 50.1673C32.0744 49.2585 32.0814 47.7969 32.9902 46.8974L42.9201 37.0762L33.0711 27.1996C32.1693 26.2953 32.1716 24.8315 33.0757 23.9297C33.98 23.0254 35.4437 23.0301 36.3456 23.9343L47.8295 35.4505C47.8319 35.4528 47.8319 35.4551 47.8341 35.4574C47.8363 35.4598 47.8387 35.4598 47.8411 35.462C48.0538 35.6771 48.2064 35.9268 48.3174 36.1881C48.322 36.1973 48.3336 36.2066 48.3359 36.2158C48.6782 37.0554 48.507 38.0545 47.8225 38.732Z" fill="white"/></svg></button>',

      })
    }

    if ($('.review-slick').length) {
      $('.review-slick').slick({
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        // autoplay:true,
        speed: 1000,
        autoplaySpeed: 1000,
        prevArrow: '.review-slick-btn .slick-btns-box button.slick-prev',
        nextArrow: '.review-slick-btn .slick-btns-box button.slick-next',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              draggable: true,
              slidesToShow: 1.2,
              dots: true,
              arrows: true,
              infinite: true,
              adaptiveHeight: false,
            },
          },
        ],
      })
    }

    if ($('.monitor-manage-item').length) {
      $('.monitor-manage-item').on('click', function () {
        $(this).toggleClass('active')
      })
    }

    if (theme.isMobile()) {
      if ($('.why-choose-section-content').length) {
        $('.why-choose-section-content').on('click', function () {
          $(this).toggleClass('active')
        })
      }
    }

    if (!theme.isMobile()) {
      window.addEventListener('scroll', function () {
        $('.is-focused>.megamenu, .site-nav--has-dropdown .megamenu').css({
          'max-height': 0,
          'pointer-events': 'none',
          'opacity': 0
        })
        $('.is-focused>.megamenu, .site-nav--has-dropdown').find('.site-nav__link--has-dropdown .one-level-menu span').addClass('line-hide')
        // $('#globalnavVisible').hide()
      })
      $('.site-nav--has-dropdown').on('mouseover', function () {
        $(this).find('.megamenu').css({
          'max-height': $(this).find('.megamenu').prop('scrollHeight') ? $(this).find('.megamenu').prop('scrollHeight') : '100vh',
          'pointer-events': 'auto',
          'opacity': 1
        })
        $(this).find('.site-nav__link--has-dropdown .one-level-menu span').removeClass('line-hide')
        // $('#globalnavVisible').show()
      })
      $('.site-nav--has-dropdown').on('mouseout', function () {
        $('.is-focused>.megamenu, .site-nav--has-dropdown .megamenu').css({
          'max-height': 0,
          'pointer-events': 'none',
          'opacity': 0
        })
        $('.is-focused>.megamenu, .site-nav--has-dropdown').find('.site-nav__link--has-dropdown .one-level-menu span').addClass('line-hide')
        // $('#globalnavVisible').hide()
      })
    }

    if ($('.assembly-container-learn-more-btn').length > 0) {
      $('.assembly-container-learn-more-btn').on('click', function () {
        $(this).toggleClass('active')
        $(this).closest('.assembly-container').css('max-height', 'none')
      })
    }

    if ($('.cover-size-filter').length > 0) {
      let filterData = {
        'Round & Kid & Herb': [
          "2.0' Round ( Twin Pack )",
          "2.0'W x 3.5'L",
          "2.5' Round ( Twin Pack )",
          "3.5' Round",
          "2.0' Round",
          "2.5' Round"
        ],
        "4 in 1": [
          "2.0'W x 5.0'L",
          "3.5'W x 3.5'L",
          "3.5' x 3.5'",
          "2.0' x 5.0'",
          "2.0' x 3.5' & 3.5' x 3.5'",
          "2.0' x 5.0' & 3.5' x 5.0'"
        ],
        "6 in 1": [
          "3.5'W x 5.0'L",
          "2.0'W x 6.5'L",
          "2.0' x 5.0' & 3.5' x 5.0'",
          "2.0' x 6.5' & 3.5' x 6.5'",
          "3.5' x 5.0'",
          "2.0' x 6.5'",
        ],
        "9 in 1": [
          "3.5'W x 6.5'L",
          "2.0'W x 8.0'L",
          "2.0' x 6.5' & 3.5' x 6.5'",
          "2.0' x 8.0'",
          "3.5' x 6.5'",
          "5.0' x 5.0'"
        ],
        "10 in 1": [
          "2.5'W x 9.5'L",
          "4.0'W x 8.0'L",
          "4.0' x 8.0'",
          "2.5' x 9.5'"
        ],
        "Kids": [
          "2.0' x 3.5' & 3.5' x 3.5'",
          "2.0' x 3.5'"
        ],
        "Self-watering garden bed": [
          "2.0' x 8.0'",
          "2.0' x 4.0'",
          "2.0' x 6.0'"
        ],
        "Round": [
          "3.5' Round",
          "2.0' Round (Herb Twin Pack)",
          "2.0' Round"
        ],
        "L&U Shape": [
          "L Large",
          "L Standard",
          "U Large",
          "U Standard",
          "U Jumbo"
        ],
      }
      $('.cover-size-filter-item').on('click', function () {
        $('.cover-size-filter-item').removeClass('active')
        $(this).addClass('active')
        var $variantBox = $(this).closest('.grid-product-variant')
        $variantBox.find('.variant-radio').hide()
        if (filterData[$(this).data('target')]) {
          filterData[$(this).data('target')].map((item) => {
            $variantBox.find(`.variant-radio[data-name="${item}"]`).show()
          })
        } else {
          $variantBox.find('.variant-radio').show()
        }
        $variantBox.find(`.variant__button-label:visible`).eq(0).click()
      })
    }

    if ($('.grid-config-tabs').length > 0) {
      $('.grid-config-tab').on('click', function () {
        $(this).closest('.grid-config-tabs').find('.grid-config-tab').removeClass('active')
        $(this).addClass('active')
        var text = $(this).text()
        if (text == 'All') {
          $('.grid-config').show()
        } else {
          $('.grid-config').hide()
          $(`.grid-config[data-config="${text}"]`).show()
        }
      })
    }

    if (!theme.isMobile()) {
      $('.metal-vs-wood .info svg').hover((e) => {
        calcPosition(e);
        if ($(e.currentTarget).closest('.info').hasClass('checked')) {
          $(e.currentTarget).closest('.info').removeClass('checked')
        } else {
          $('.info').removeClass('checked')
          $(e.currentTarget).closest('.info').addClass('checked')
        }
      })
    }
    $('.metal-vs-wood .info svg').click((e) => {
      calcPosition(e);
      if ($(e.currentTarget).closest('.info').hasClass('checked')) {
        $(e.currentTarget).removeClass('checked')
      } else {
        $('.info').removeClass('checked')
        $(e.currentTarget).closest('.info').addClass('checked')
      }
    })
    if ($('.youtube_iframe').length > 0) {
      Array.from($('.youtube_iframe')).map(function (e, i) {
        let youtubePlayer;
        youtubePlayer = new theme.YouTube('youtube_iframe_box', {
          videoId: $(e).attr('data-youtube-id'),
          width: '100%',
          height: '100%',
          events: {
            onReady: function () {
            }
          }
        })
        $(e).on('click', function () {
          $(this).find('img').hide()
          $(this).find('#youtube_iframe_box').show()
          youtubePlayer.play()
        })
      })

    }


    if ($('.labor-day-sale-tab').length) {
      $('.labor-day-sale-tab').find('li').on('click', function () {
        $('.labor-day-sale-tab-section .labor-day-sale-tab-c').hide().addClass('page-section-pt0').removeClass('active')
        $('.labor-day-sale-tab').find('li').removeClass('active')
        $(this).addClass('active')
        let domtarget = $(this).attr('data-target')
        $(`#${domtarget}`).show().removeClass('page-section-pt0')[0]
        if (location.pathname.includes("collections/greenhouses")){
           $(`#${domtarget}`).addClass('active')
            if (domtarget != "greenhouses-accessories"){
              $(".model-comparsion.labor-day-sale-tab-c").show();
              $("#greenhouses-accessories").css("marginTop", "0px");
            }
            if (domtarget == "all") {
              $(".labor-day-sale-tab-section .labor-day-sale-tab-c")
                .show()
                .removeClass("page-section-pt0");
            } else if (domtarget == "greenhouses-accessories"){
                $(".model-comparsion.labor-day-sale-tab-c").hide();
                $(`#${domtarget}`).show().css("marginTop", "60px");
            }
        }else{
          if (domtarget == "all") {
            $(".labor-day-sale-tab-section .labor-day-sale-tab-c")
              .show()
              .addClass("page-section-pt0");
            $(".labor-day-sale-tab-section ")
              .find(".labor-day-sale-tab-c")
              .eq(0)
              .show()
              .removeClass("page-section-pt0");
          }
        }
        window.scrollTo(0, offsetCalc($(`#${domtarget}`)[0]).top - 200)
        //
        AOS?.refreshHard?.()
      })
    }
    if (theme.isMobile()) {
      if ($('.product-introduction-mob-slider').length) {
        $('.product-introduction-mob-slider').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1.15,
          slidesToScroll: 1
        })
      }
    } else {
      if ($('.product-introduction-pc-slider').length) {
        $('.product-introduction-pc-slider').slick({
          arrows: true,
          dots: false,
          slidesToShow: 3.2,
          slidesToScroll: 1,
          draggable: true,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"/></svg></button>',
          // prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
          // nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            }
          ],
        })
        $('.product-introduction-pc-slider').css('opacity', 1)
      }
    }

    if ($('.lifeStyle-c').length > 0) {
      $('.lifeStyle-c').find('.lifeStyle-click').on('click', function () {
        $('.lifeStyle-c').find('.lifeStyle-click').removeClass('active')
        $('.lifeStyle-c').find('.lifeStyle-click-i').removeClass('active')
        $(this).addClass('active')
        $('.lifeStyle-c').find('.lifeStyle-click-i').map((index, ele) => {
          Array.from($(ele).find('video')).forEach((e, i) => {
            $(e).get(0).pause()
            $(e).get(0).currentTime = 0
          })
          if ($(ele).data('target') == $(this).data('id')) {
            $(ele).addClass('active')
            Array.from($(ele).find('video')).forEach((e, i) => {
              $(e).get(0).play()
            })
          }
        })
      })
      $('.lifeStyle-c').find('.lifeStyle-click-i-content').on('click', function () {
        $('.lifeStyle-c').find('.lifeStyle-click-i-content').removeClass('active')
        $('.lifeStyle-c').find('.lifeStyle-click-i-video').removeClass('active')
        $(this).addClass('active')
        $('.lifeStyle-c').find('.lifeStyle-click-i-video').map((index, ele) => {
          Array.from($(ele).find('video')).forEach((e, i) => {
            $(e).get(0).pause()
            $(e).get(0).currentTime = 0
          })
          if ($(ele).data('target') == $(this).data('id')) {
            $(ele).addClass('active')
            Array.from($(ele).find('video')).forEach((e, i) => {
              $(e).get(0).play()
            })
          }
        })
      })
    }

    if ($('.discount-json').length) {
      theme.config.discountInfo = JSON.parse($('.discount-json').text())
    }


    //----------------  welcome(back) event ------------------------

    function listItemActive($item) {
      $item.siblings('div').removeClass('active');
      $item.addClass('active');
    }


    $('.vego-push-mobile-handlers .vego-push-handler').hover((e) => {
      const _this = e.currentTarget;
      const $handler = $('.vego-push .vego-push-item:nth-child(' + ($(_this).index() + 1) + ')');
      listItemActive($handler)
      listItemActive($(_this))
    })
    $('.vego-push-mobile-handlers .vego-push-handler').click((e) => {
      const _this = e.currentTarget;
      const $handler = $('.vego-push .vego-push-item:nth-child(' + ($(_this).index() + 1) + ')');
      listItemActive($handler)
      listItemActive($(_this))
    })

    //---------- cart event ----------

    //BEGIN === PRE ORDER
    //hide buy it now for pre order
    $('.add-to-cart').map((index, item) => {
      if ($(item).text().toLowerCase().indexOf('pre order') > -1) {
        $(item).closest('form').find('.shopify-payment-button').hide()
      }
    })

    //----------------  handle click event with Safari mode ------------------------

    $('.point-circle').hover((e) => {
      e.stopPropagation();
      e.preventDefault();
      $('.point-checkbox').closest('.hot-point').removeClass('checked')
      $(e.currentTarget).closest('.hot-point').addClass('checked')
    }, () => {
      $('.point-checkbox').closest('.hot-point').removeClass('checked')
    })
    $('.point-circle').click((e) => {

      if (theme.isMobile()) {
        e.stopPropagation();
        e.preventDefault();
        let $pointCheckbox = $(e.currentTarget).siblings('.point-checkbox');


        if (!$pointCheckbox.hasClass('checked')) {
          $('.point-checkbox').removeClass('checked')
          $pointCheckbox.addClass('checked')
        } else {
          $pointCheckbox.removeClass('checked')
        }
      }
    })

    if (theme.isMobile()) {
      $('.why-vego').click((e) => {
        if ($(e.target).closest('.hot-point').length === 0) {
          $('.point-checkbox').removeClass('checked')
        }
      })
    }

    //----------------  Mother's Day ------------------------

    if (window.location.search.indexOf('openCart=true') > -1) {
      setTimeout(() => {
        document.querySelector('.header-item--split-right .js-drawer-open-cart')?.click()
      }, 0)
    }

    try {

      // sections
      theme.sections.register('header', theme.HeaderSection)
      theme.sections.register('product', theme.Product)
      theme.sections.register('blog', theme.Blog)
      theme.sections.register('password-header', theme.PasswordHeader)
      theme.sections.register('photoswipe', theme.Photoswipe)
      theme.sections.register('product-recommendations', theme.Recommendations)
      theme.sections.register('slideshow-section', theme.SlideshowSection)
      theme.sections.register('background-image', theme.BackgroundImage)
      theme.sections.register('testimonials', theme.Testimonials)
      theme.sections.register('video-section', theme.VideoSection)
      theme.sections.register('footer-section', theme.FooterSection)

      theme.sections.register('newsletter-popup', theme.NewsletterPopup)
      theme.sections.register('collection-header', theme.CollectionHeader)
      theme.sections.register('collection-sidebar', theme.CollectionSidebar)
      theme.sections.register('collection-template', theme.Collection)
    } catch (e) {
      console.log(e);
    }
    theme.initGlobals()

    // theme.initQuickShop()
    theme.rteInit()

    //fix blank issue appears of right page when first time loaded page sometimes
    function fixedPageBlank() {
      $('#HeaderWrapper').css('overflow', 'hidden')
      setTimeout(() => {
        $('#HeaderWrapper').css('overflow', 'visible')
      }, 300)
    }
    $(window).resize(fixedPageBlank)
    fixedPageBlank()

    /**
     * update search result list
     */

    theme.BundleProducts.init()

    if (theme.settings.cartType === 'drawer') {
      new theme.AjaxProduct()
    }

    theme.happyCustomers.init()


    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates()
    }

    document.dispatchEvent(new CustomEvent('page:loaded'))
    $(window).resize(function () {
      theme.resetMobileText()
    })
    theme.resetMobileText() //set mobile image when user access with mobile
    new theme.YotpoReview()


    //BEGIN ==== Successfully TIPs and POSITION after submitting LETTER FORM

    // Banner Video
    // if ($('.section-hero-banner-video').length) {
    //   $('.section-hero-banner-video').each(function (i, e) {
    //     var video = $(e).find('.video-div')[0];
    //     // pause when out of view
    //     var observer = new IntersectionObserver(
    //       (entries, observer) => {
    //         entries.forEach((entry) => {
    //           if (entry.isIntersecting) {
    //             video.play()
    //           } else {
    //             video.pause()
    //           }
    //         })
    //       },
    //       { rootMargin: '0px 0px 50px 0px' }
    //     )
    //     if (video.canPlayType('application/vnd.apple.mpegurl')) {
    //       video.src = 'https://cdn.shopify.com/s/files/1/0286/2271/6963/files/light.m3u8?v=1672131693';
    //       video.addEventListener('canplay', function () {
    //         video.play();
    //         observer.observe(video)
    //       });
    //     } else if (Hls.isSupported()) {
    //       var hls = new Hls();
    //       // bind them together
    //       hls.loadSource('https://cdn.shopify.com/s/files/1/0286/2271/6963/files/light.m3u8?v=1672131693');
    //       hls.attachMedia(video);
    //       hls.on(Hls.Events.MANIFEST_PARSED, function () {
    //         video.play();
    //         observer.observe(video)
    //       });
    //       hls.on(Hls.Events.ERROR, function (event, data) {
    //         if (data.fatal) {
    //           switch (data.type) {
    //             case Hls.ErrorTypes.NETWORK_ERROR:
    //               // try to recover network error
    //               console.log('fatal network error encountered, try to recover');
    //               hls.startLoad();
    //               break;
    //             case Hls.ErrorTypes.MEDIA_ERROR:
    //               hls.recoverMediaError();
    //               break;
    //             default:
    //               hls.destroy();
    //               break;
    //           }
    //         }
    //       })
    //     }
    //     video.addEventListener('play', function () {
    //       video.classList.add('loaded')
    //     })
    //   })
    // }



    try {
      const CONTACT_ID = 'contact_id'
      const LAST_CONTACT = 'last_contact_top'
      let contactId = localStorage.getItem(CONTACT_ID)

      if (contactId) {
        let $form = $(`#${contactId}`)
        let noteText = $form.find('.note').data('note')
        if (noteText) {
          localStorage.removeItem(CONTACT_ID)
          $form.html(
            '<div class="note note--success" style="margin-top:1rem;">Thank you for subscribing!</div>'
          )

          setTimeout(function () {
            let lastPositionTop = localStorage.getItem(LAST_CONTACT)
            localStorage.removeItem(LAST_CONTACT)
            if (lastPositionTop) {
              window.scrollTo({
                top: parseInt(lastPositionTop) - 300,
                behavior: 'smooth',
              })
            }
          }, 1000)
        }
      }
      $('.contact-form').submit(function (e) {
        let id = $(e.currentTarget).attr('id')
        localStorage.setItem(CONTACT_ID, id)
        localStorage.setItem(LAST_CONTACT, $(e.currentTarget).offset().top)
      })
    } catch (e) {
      console.log(e)
    }
    //END ==== Successfully TIPs and POSITION after submitting LETTER FORM

    $('.search-bar-btn-box').on('click', function (e) {
      $('.input-group-field').val('')
    })
    if (theme.isMobile()) {
      if ($('.seacrch-label li:hidden').length > 1) {
        $('.search-content .grid__item .seacrch-label ul').css({
          'justify-content': 'normal',
        })
        $('.search-content .grid__item .seacrch-label ul li').css({
          'margin-right': '30px',
        })
      } else {
        $('.search-content .grid__item .seacrch-label ul').css({
          'justify-content': 'space-between',
        })
        $('.search-content .grid__item .seacrch-label ul li').css({
          'margin-right': '0',
        })
      }
      $('.search-content .input-search-bar-box').on('click', function (e) {
        if ($('.input-group-field').val() === '') e.preventDefault()
      })
    }
    $(window).resize(function () {
      if (window.location.href.indexOf('search') !== -1) {
        if ($(window).width() > 768) {
          $('.main-content').css({
            'min-height': 'auto'
          })
        } else {
          $('.main-content').css({
            'min-height': 'auto',
          })
        }
      } else {
        if ($(window).width() > 768) {
          $('.main-content').css({
            // 'min-height': '700px',
            'padding-bottom': '0',
          })
        } else {
          $('.main-content').css({
            ///  'min-height': '300px',
            'padding-bottom': '0',
          })
        }
      }
    })

    try {
      //open the first one default
      setTimeout(() => {
        $($('#NavDrawer .mobile-nav__toggle button')[0]).click()
      }, 1000)
    } catch (error) {
      console.log(error);
    }

    if ($('#return-form').length) {
      var t = new URLSearchParams(location.search)
      if (t.get('order_id')) {
        $('#return-form input[name=order]').val(t.get('order_id'))
      }
      if (t.get('email')) {
        $('#return-form input[name=email]').val(t.get('email'))
      }
      var type = 2
      const orderBase = 'https://app.vegogarden.com/order-edit/order'
      const api = {
        captcha: orderBase + '/cancel-applying?accessToken=elt27u2mh066gzwebz9fl3rhgzbynfas',
        cancel: orderBase + '/cancel?accessToken=elt27u2mh066gzwebz9fl3rhgzbynfas'
      }
      var rule1 = {
        order: {
          required: true
        },
        email: {
          required: true,
          email: true
        }
      }
      var rule2 = {
        ...rule1,
        captcha: {
          required: true
        }
      }
      var rule3 = {
        ...rule2,
        reason: {
          required: true
        }
      }
      function getValues($form) {
        var values = {}
        $form.find('input,textarea').each(function () {
          values[this.name] = $(this).val()
        })
        return values
      }
      function validate($form, rules) {
        var values = getValues($form)
        var errors = []
        for (var key in rules) {
          if (values.hasOwnProperty(key)) {
            var fieldRule = rules[key]
            var value = values[key]
            for (var rule in fieldRule) {
              validateField($form, key, value, rule, fieldRule[rule], errors)
            }
          }
        }
        if (errors.length > 0) {
          return false
        }
        return true
      }

      function validateField($form, key, value, rule, ruleValue, errors) {
        if (rule === 'required' && ruleValue) {
          if (value === undefined || value.trim() === '') {
            if (errors) {
              errors.push({
                name: key,
                rule: rule
              })
            }
            $form.find('[name=' + key + ']').addClass('error')
            return
          } else {
            $form.find('[name=' + key + ']').removeClass('error')
          }
        }
        if (rule === 'email' && ruleValue) {
          if (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
            if (errors) {
              errors.push({
                name: key,
                rule: rule
              })
            }
            $form.find('[name=' + key + ']').addClass('error')
            return
          } else {
            $form.find('[name=' + key + ']').removeClass('error')
          }
        }
      }

      function formatMessage(message, data) {
        if (!data) {
          return message
        }
        // return message.replace('{createdAt}', formatDateText(new Date(data * 1000), 'dd,DD HH:mm:ss'))
        return message.replace('{createdAt}', ts2shortDateFormat(new Date(data * 1000)))

      }

      $('.brand-tab').on('click', function () {
        type = $(this).data('action')
        next = type == 1 ? 2 : 1
        if (type == 2) {
          next = 1
          $('.edit-reason').addClass('hide')
        } else {
          next = 2
          $('.edit-reason').removeClass('hide')
        }
        $('.brand-tab[data-action=' + type + ']').addClass('active')
        $('.brand-tab[data-action=' + next + ']').removeClass('active')
      })

      $('#return-form').on('change', 'input,textarea', function (e) {
        var name = e.currentTarget.name
        if (rule3[name]) {
          for (var rule in rule3[name]) {
            validateField($(e.delegateTarget), name, e.currentTarget.value, rule, rule3[name][rule])
          }
        }
      })

      function refresh(sec) {
        if (sec == 0) {
          $('#captcha-btn').text('Send').prop('disabled', false)
        } else {
          $('#captcha-btn').text(sec + 's').prop('disabled', true)
          setTimeout(() => refresh(sec - 1), 1000)
        }
      }
      $('#captcha-btn').on('click', (e) => {
        e.preventDefault()
        if (validate($('#return-form'), rule1)) {
          var values = getValues($('#return-form'))
          $.post(api.captcha, {
            orderId: values.order,
            email: values.email
          }, function (res) {
            if (res.code !== 200) {
              $('#ReturnError').text(formatMessage(res.message || 'Cancel Order Successfully', res.data)).removeClass('hide')
            } else {
              refresh(60)
            }
          }).fail(function () {
            $('#ReturnError').text('network error').removeClass('hide')
          })
        }
      })
      $('#return-form').on('submit', function (e) {
        e.preventDefault()
        $('#ReturnError').addClass('hide')
        if (validate($('#return-form'), type == 2 ? rule2 : rule3)) {
          var values = getValues($('#return-form'))
          var body = {
            orderId: values.order,
            email: values.email,
            verifyCode: values.captcha,
            type: type
          }
          if (type == 1) {
            body.note = values.reason
          }
          $.post(api.cancel, body, function (res) {
            if (res.code !== 200) {
              $('#ReturnError').text(formatMessage(res.message, res.data)).removeClass('hide')
            } else {
              $('#ReturnSuccess').text(formatMessage(res.message, res.data)).removeClass('hide')
            }
          }).fail(function () {
            $('#ReturnError').text('network error').removeClass('hide')
          })
        }
      })
    }
    if (!theme.isMobile()) {
      var $items = $('.as-seen-in-slider').find('.as-seen-in-item')
      var itemLen = $items.length
      var a = Math.ceil(itemLen / 5)
      for (let i = 0; i < a; i++) {
        var $wrapper = $('<div class="as-seen-in-wrapper"></div>')
        $('.as-seen-in-slider').append($wrapper)
        for (let j = 0; i < 5; j++) {
          var n = i * 5 + j
          if (n >= itemLen) {
            break
          }
          $wrapper.append($items.get(n))
        }
      }
      $('.as-seen-in-slider')
        .slick({
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: false,
          prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
        })
        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
          AOS.refreshHard()
        })
        .css('overflow', 'initial')

      $('.more-video-slider')
        .slick({
          autoplay: true,
          centerMode: true,
          arrows: false,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          draggable: false,
          prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.37806 6L10.2858 12V-9.53674e-07L1.37806 6Z" fill="#3A5B39"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10.622 6L1.71423 12L1.71423 -9.53674e-07L10.622 6Z" fill="#3A5B39"/></svg></button>',
        })
        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
          AOS.refreshHard()
        })
        .css('overflow', 'initial')
    } else {
      var $items = $('.as-seen-in-slider .as-seen-in-item')
      if ($items.length > 4) {
        var boxes = []
        for (var i = 0; i < Math.ceil($items.length / 4); i++) {
          boxes[i] = $('<div class="as-seen-in-mobile-slider-item"><div class="as-seen-in-mobile-item"></div></div>')
          $('.as-seen-in-slider').append(boxes[i])
        }
        $items.each(function (i, e) {
          $(e).appendTo(boxes[Math.floor(i / 4)].find('.as-seen-in-mobile-item'))
        })
        $('.as-seen-in-slider')
          .slick({
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            prevArrow: $('.recommended-by-action-btns .slick-prev'),
            nextArrow: $('.recommended-by-action-btns .slick-next')
          })
          .on('afterChange', function (event, slick, currentSlide, nextSlide) {
            AOS.refreshHard()
          })
          .css('overflow', 'initial')
      }

      if ($('.grid-ingredients').length) {
        var $items = $('.grid-ingredients .ingredient-item')
        var boxes = []
        for (var i = 0; i < Math.round($items.length / 6); i++) {
          boxes[i] = $('<div class="as-seen-in-mobile-slider-item"><div class="as-seen-in-mobile-item"></div></div>')
          $('.grid-ingredients').append(boxes[i])
        }
        $items.each(function (i, e) {
          $(e).appendTo(boxes[Math.floor(i / 6)].find('.as-seen-in-mobile-item'))
        })
        $('.grid-ingredients')
          .slick({
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            prevArrow: $('.recommended-by-action-btns .slick-prev'),
            nextArrow: $('.recommended-by-action-btns .slick-next')
          })
          .on('afterChange', function (event, slick, currentSlide, nextSlide) {
            AOS.refreshHard()
          })
          .css('overflow', 'initial')
      }
      $('.sustainability-features .sustainability-feature-item:nth-child(3)').after($('.sustainability-features .sustainability-feature-item:nth-child(2)'))
      let config = {}
      if (window.location.pathname.indexOf('bundle-lp') > -1) {
        config = {
          centerMode: true
        }
      }
      let el_stick = $('.sustainability-features')
      el_stick.slick({
        arrows: false,
        dots: true,
        infinite: true,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        ...config
      })
      el_stick.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        AOS.refreshHard()
      });

      /**
       * @deprecated
       
      $('.grid-configs-gp-sm').textFolder({
        height: 450,
        restore: true
      })*/
    }

    $('.color-ways-nav-item').on('mouseover', function () {
      var target = $(this).data('target')
      $('.color-ways-nav-item.active').removeClass('active')
      $(this).addClass('active')
      $('.color-ways-item.active').removeClass('active')
      $(`.color-ways-item[data-id=${target}]`).addClass('active')
    })

    $('.kids-gallery-slider').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3" /></svg></button>',
      nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3" /></svg></button>'
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
      AOS.refreshHard()
    })



    let el_slick = $('.media-quote-slider');
    let slide_config = {
      arrows: true,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      draggable: false,
      prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"/></svg></button>',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            draggable: true,
            centerMode: true,
            centerPadding: '30px',
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1
          },
        }
      ],
    }
    el_slick.slick(slide_config)
      .css('overflow', 'initial')
    el_slick.on('afterChange', function (event, slick, currentSlide, nextSlide) {
      AOS.refreshHard()
    });

    if (theme.isMobile()) {
      $('.start-your-garden-slider >.start-your-garden-item:nth-child(3)').insertBefore($('.start-your-garden-slider >.start-your-garden-item:nth-child(1)'))
      let el__start_your_garden_slick = $('.start-your-garden-slider');
      el__start_your_garden_slick.slick({
        arrows: false,
        dots: true,
        infinite: true,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px',
        adaptiveHeight: false,
      }).css('overflow', 'initial')
      el__start_your_garden_slick.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        AOS.refreshHard()
      });
    }

    function initTabSlick(index) {
      var $group = $('.includes-container #configurations-tab').find('.vego-tab-content-item').eq(index).find('.arch-trellis-include-group-mobile');
      if (!$group[0].slick) {
        $group.slick({
          arrows: false,
          dots: true,
          draggable: true,
          adaptiveHeight: false,
          slidesToShow: 1,
          slidesToScroll: 1
        })
        $group.on('afterChange', function (event, slick, currentSlide, nextSlide) {
          AOS.refreshHard()
        });
      }
    }

    $('.includes-container #configurations-tab').on('change.vegotab', function (e, index) {
      initTabSlick(index)
    })

    if ($('#assembly-video-products').length) {
      setTimeout(() => {
        var json = $('#assembly-video-products').val()
        window.cartDrawerInstance.initVideoRecommendProduct(JSON.parse(json))
      }, 3000)
    }

    $('.assembly-video-manual-btn').on('click', function () {
      var url = $(this).closest('.assembly-video-manuals').find('select').val()
      window.open(url)
    })
    if (theme.isMobile()) {
      $('.assembly-vedio-section .small--hide').remove()
    } else {
      $('.assembly-vedio-section .medium-up--hide').remove()
    }
  })
  window.addEventListener('load', function () {
    document.querySelectorAll('.js-userway').forEach(function (item) {
      item.addEventListener('click', function () {
        document.querySelector('#userwayAccessibilityIcon').click()
      })
    })


    //BEGIN === compare code
    let rightSize = document.querySelector('.find-the-right-size')
    let compareClose = document.querySelectorAll('.compare-close')
    let compareClose1 = document.querySelector('.compare-close-1')


    rightSize && rightSize.addEventListener('click', () => {
      document.querySelector('.Product-Comparison-hover_V2').style.display = 'block'
    })

    !!compareClose.length && compareClose.forEach(item => item.addEventListener('click', () => {
      document.querySelector('.Product-Comparison-hover_V2').style.display = 'none'
    }))

    compareClose1 && [compareClose1].forEach(item => item.addEventListener('click', () => {
      document.querySelector('.Product-Comparison-hover_V2').style.display = 'none'
    }))


    function rmClass(classList, rmArr) {
      return [...classList].filter(item => rmArr.indexOf(item) == -1).join(' ')
    }

    function rmEle(rowTitleCellLeft) {
      rowTitleCellLeft.forEach(item => item.remove())
    }

    function appendEle(rowTitleCell, rowTitleCellLeft) {
      rowTitleCell.append(rowTitleCellLeft)
    }

    function createElement(classArr, styObj) {
      var div = document.createElement("div");
      Object.keys(styObj).map(key => {
        div.style[key] = styObj[key];
      })
      div.classList = classArr.join(' ')
      return div;
    }

    let rectangle13 = document.querySelectorAll('.Rectangle-113-square');
    !!rectangle13.length && rectangle13.forEach(function (ele, index) {
      let classList = [...ele.classList].filter(item => item == 'hover')
      if (classList.length) {

        function mouseEnter() {
          let eleIndex = index % 8
          let eleRowIndex = Math.floor(index / 8)

          let rowTitleCell = document.querySelector('.Rectangle-113-container-row-tilte > .Rectangle-113:nth-child(' + (eleIndex + 1) + ')');
          if (rowTitleCell) {
            rowTitleCell.classList = [...rowTitleCell.classList, 'active'].join(' ')
            appendEle(rowTitleCell, createElement([`border-right`], { height: ((eleRowIndex) * 60 + 60) + 'px' }))
            appendEle(rowTitleCell, createElement([`border-left`], { height: ((eleRowIndex) * 60 + 60) + 'px' }))
          }
          let coulmnTitleCell = document.querySelector('.Rectangle-113-square-title > .Rectangle-113:nth-child(' + (eleRowIndex + 1) + ')');
          if (coulmnTitleCell) {
            coulmnTitleCell.classList = [...coulmnTitleCell.classList, 'active'].join(' ')
            appendEle(coulmnTitleCell, createElement([`border-bottom`], { width: ((eleIndex + 1) * 118.5 + 60) + 'px' }))
            appendEle(coulmnTitleCell, createElement([`border-top`], { width: ((eleIndex + 1) * 118.5 + 60) + 'px' }))
          }
          ele.classList = [...ele.classList, 'active'].join(' ')
          appendEle(ele, createElement([`cell-border`], {}))
        }

        function mouseLeave() {
          let eleIndex = index % 8
          let eleRowIndex = Math.floor(index / 8)
          let rowTitleCell = document.querySelector('.Rectangle-113-container-row-tilte > .Rectangle-113:nth-child(' + (eleIndex + 1) + ')');
          if (rowTitleCell) {
            rowTitleCell.classList = rmClass(rowTitleCell.classList, ['active'])
            rmEle(document.querySelectorAll('.border-left', rowTitleCell))
            rmEle(document.querySelectorAll('.border-right', rowTitleCell))
          }
          let coulmnTitleCell = document.querySelector('.Rectangle-113-square-title > .Rectangle-113:nth-child(' + (eleRowIndex + 1) + ')');
          if (coulmnTitleCell) {
            coulmnTitleCell.classList = rmClass(coulmnTitleCell.classList, ['active'])
            rmEle(document.querySelectorAll('.border-bottom', coulmnTitleCell))
            rmEle(document.querySelectorAll('.border-top', coulmnTitleCell))
          }
          rmEle(document.querySelectorAll('.cell-border', ele))
          ele.classList = rmClass(ele.classList, ['active'])
        }

        ele.addEventListener('mouseover', mouseEnter)
        ele.addEventListener('mousemove', mouseEnter)
        ele.addEventListener('mouseleave', mouseLeave)
      }
    })
    //end of compare code


    //BEGIN cart
    let $apply = document.querySelector(".docapp-coupon-input--button-text")
    if ($apply && theme.isMobile()) {
      let $timer = setInterval(() => {

        let $discount = document.querySelector('.docapp-cart-discount')

        //only for National Gardening Day : Step 3
        // let isGift = $discount.textContent?.trim?.().indexOf?.('00 Gift')>-1;
        // if ($discount && !isGift) {
        if ($discount) {
          let $total = document.querySelector('.docapp-est-total')
          if ($total) {
            $total.style.height = '160px';
            $total.style.paddingTop = '50px'
          };

          $discount.style.display = 'block';
          $timer && clearInterval($timer)

        }
      }, 500)

    }
    //END cart

    //BEGIN ADD TO CART
    if (document.querySelector(".color-swatch-custom")) {

      let customColors = $('.color-swatch-custom');

      customColors.click(e => {

        if ($(e.target).closest('.grid-product__colors').siblings('form').length == 0) {
          return;
        } else {
          $(e.target).addClass('color-swatch-active');
          $(e.target).siblings('span').removeClass('color-swatch-active');

          $('select.variants-custom', $(e.target).closest('.grid-product__colors').siblings('form'))
            .map((index, item) => {
              const $val = $(e.target).data('variant-id');
              $(item).val($val).change();

              theme.productForm.updatePreOrder($(item));

            })

          const siblingEle = $(e.target).closest('.grid-product__colors').siblings('.color-label-custom');

          if (siblingEle.length) {
            siblingEle.html(`COLOR - ` + $(e.target).text().trim())
            const color = $(e.target).text().trim().split(' ')[1].toLowerCase();
            siblingEle.css('color', color === 'white' ? '#cbc5b6' : color)
          }


          const $priceContent = $('.grid-product__price', $(e.target).closest('.grid-product__colors').siblings('.grid-product__content'));
          if ($(e.target).data('save') === '$0' || $(e.target).data('save').indexOf('-') > -1) {

            $priceContent.html(`<span class="visually-hidden">Regular price</span><span class="visually-hidden">Sale price</span>` + $(e.target).data('discount'))

          } else {

            $priceContent.html(
              `<span class="visually-hidden">Regular price</span><span class="grid-product__price--original" data-uw-rm-sr="price" aria-label="Previous price was ` + $(e.target).data('price') + `">`
              + $(e.target).data('price') + `</span> <span class="visually-hidden">Sale price</span>`
              + $(e.target).data('discount') + `<span class="grid-product__price--savings" data-uw-rm-sr="">Save ` + $(e.target).data('save') + `</span>`
            )

          }


        }

      })
      //$('.color-swatch-custom:first-child').click()

    }
    //ENd ADD To CARD


    //BEGIN === PRE ORDER
    //hide buy it now for pre order


    //update between add to cart and pre order when switching variant
    //init value when loaded
    $('.pre-order-select').map((index, item) => {
      theme.productForm.updatePreOrder($(item));
    })
    //END === PRE ORDER

    // Synchronize Tolstoy shopping cart contents
    window.addEventListener("message", message => {
      if (message.data.name === 'addToCart' || message.data.name === 'cartItemQuantityChange') {
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: {
                addToCartBtn: null,
                drawer: 0
              },
            })
          )
        }, 1000)
      }
    });
  })



  jQuery(document).ready(function ($) {
    // $('.btn.add-to-cart').click(function () {
    //   gtag('event', 'conversion', { 'send_to': 'AW-595754296/FhcHCMD6x6cDELj6iZwC' });
    // });
    // $('.btn.cart__checkout').click(function () {
    //   gtag('event', 'conversion', { 'send_to': 'AW-595754296/6paVCOXTkacDELj6iZwC' });
    // });

    if ($('.composter-tab').length > 0) {
      $('.composter-tab').on('click', '.tab', function (e) {
        e.stopPropagation()
        $(this).closest('.composter-tab-c').find('.tab-content').removeClass('active')
        $(this).closest('.composter-tab-c').find('.composter-tab .tab').removeClass('active')
        $(this).addClass('active')
        $(this).closest('.composter-tab-c').find('.tab-content').map((index, ele) => {
          if ($(ele).data('id') == $(this).data('target')) {
            $(ele).addClass('active')
          }
        })

      })
    }

    if ($('.processed-content').length > 0) {
      $('.processed-content ul li').on('click', function () {
        $(this).find('.li-p').toggle()
        $(this).find('.li-c svg').toggleClass('active')
      })
    }
    judgeMarketFn?.()
    theme.bgsetInit()
    if (theme.isMobile()) {
      $('.processed-slider').slick({
        arrows: true,
        dots: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: theme.isMobile() ? `.processed-slider-page-width .feature-add-ons-action-btns .slick-prev` : '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
        nextArrow: theme.isMobile() ? `.processed-slider-page-width .feature-add-ons-action-btns .slick-next` : '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
      });
      $('.subscription-slider').slick({
        arrows: true,
        dots: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: theme.isMobile() ? `.subscription-section .feature-add-ons-action-btns .slick-prev` : '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
        nextArrow: theme.isMobile() ? `.subscription-section .feature-add-ons-action-btns .slick-next` : '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
      });
      $('.indoor-slider').slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      })
    }

    function pictureHd() {
      const windowWidth = window.innerWidth
      $('.picture-hd').each(function () {
        var width = $(this).width()
        if (width > 0) {
          const pcGroup = [540, 720, 900, 1080, 1440]
          var pcSizes = ''
          for (let i = 0; i < pcGroup.length; i++) {
            const w = pcGroup[i]
            const mediaWitdh = w / 2 / width * windowWidth
            pcSizes += `(max-width: ${mediaWitdh.toFixed(0)}px) ${w / 2}px`
            if (i < pcGroup.length - 1) {
              pcSizes += ','
            }
          }
          $(this).find('.picture-pc').attr('sizes', pcSizes)
        }
      })
    }

    // pictureHd()

    window.on('scroll', function () {
      var scroll = window.scrollY;
      if (scroll < 245) {
        $('.scroll-top').removeClass('open');
      } else {
        $('.scroll-top').addClass('open');
      }
    });

    svg4everybody({
      polyfill: true,
      validate: function (src, svg, use) {
        if ($(svg).hasClass('vegoicon') && src.indexOf('#') > -1) {
          return true
        }
        return false
      }
    })

    ///////////////////////////////////////////////////
    // 03. Scroll Up Js
    if ($('.scroll-top').length) {
      $(".scroll-top").on('click', function () {
        // animate
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        // $('html, body').animate({
        //   scrollTop: 0
        // }, 1000);
      });
    }

    if ($('#choose-options').length) {
      $(".scroll-choose-options").on('click', function () {
        window.scrollTo({
          top: document.getElementById('choose-options').offsetTop,
          behavior: 'smooth',
        });
        // $('html, body').animate({
        //     scrollTop: $('#choose-options').offset().top
        // }, 1000);
      });
    }

    function slickSaleSlider(classname, mobileEnable = true, num = 4) {
      if ($(classname).hasClass('flickity-addons-pc') && theme.isMobile()) {
        $(classname).css('opacity', 1)
        return
      }
      if (!mobileEnable && theme.isMobile()) {
        $(classname).css('opacity', 1)
        return
      }
      $(classname).on('init', function () {
        $(this).css('opacity', 1)
      })
      if (!theme.isMobile() && num == 4) {
        let el_slick = $(classname);
        el_slick.slick({
          arrows: true,
          dots: false,
          slidesToShow: num,
          slidesToScroll: 1,
          draggable: true,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="50" height="50" rx="25" transform="matrix(1 -9.04025e-08 -8.45413e-08 -1 0 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 34.6999C28.6518 34.3055 28.6454 33.6723 28.251 33.2858L19.7961 25L28.251 16.7142C28.6454 16.3277 28.6518 15.6945 28.2653 15.3001C27.8787 14.9056 27.2456 14.8992 26.8511 15.2858L17.6674 24.2858C17.4755 24.4739 17.3674 24.7313 17.3674 25C17.3674 25.2687 17.4755 25.5261 17.6674 25.7142L26.8511 34.7142C27.2456 35.1008 27.8787 35.0944 28.2653 34.6999Z" fill="#FEF9EB"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="50" y="50" width="50" height="50" rx="25" transform="rotate(-180 50 50)" fill="#3A5B39"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7347 34.6999C21.3482 34.3055 21.3546 33.6723 21.749 33.2858L30.2039 25L21.749 16.7142C21.3546 16.3277 21.3482 15.6945 21.7347 15.3001C22.1213 14.9056 22.7544 14.8992 23.1489 15.2858L32.3326 24.2858C32.5245 24.4739 32.6326 24.7313 32.6326 25C32.6326 25.2687 32.5245 25.5261 32.3326 25.7142L23.1489 34.7142C22.7544 35.1008 22.1213 35.0944 21.7347 34.6999Z" fill="#FEF9EB"/></svg></button>',
          // prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
          // nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            }
          ],
        })
        el_slick.on('afterChange', function (event, slick, currentSlide, nextSlide) {
          $.$$updateInput()
          $(this).find('.slick-cloned').each(function () {
            var index = $(this).data('slickIndex')
            var radios = $(this).find('.variant-radio')
            $(this).find('.grid-product').data('vego.collection.product', null)
            $(this).find('.grid-product').collecionProduct()
            if (radios.length) {
              radios.each(function () {
                var $label = $(this).find('label')
                var attrFor = $label.attr('for')
                var id = attrFor + '-' + index
                $label.attr('for', id)
                $(this).find('input[type=radio]').attr('id', id)
              })
            }
            if ($(this).find('select.grid-product-variant-input:enabled').length) {
              $(this).find('select.grid-product-variant-input:enabled').data('vego.select', null)
              $(this).find('select.grid-product-variant-input:enabled').closest('.vego-select-contaner').find('.vego-select-dropdown').remove()
              $(this).find('select.grid-product-variant-input:enabled').closest('.vego-select-contaner').find('.vego-select').remove()
              $(this).find('select.grid-product-variant-input:enabled').vselect()
            }
          })
          AOS.refreshHard()
        })
      } else {
        let num_ = 2;
        let dots_ = false, arrows_ = true;
        let config = classname == '.flickity-bundle-lp' ? { initialSlide: 1, centerMode: true } : {}

        if (classname == '.why-gao-list') {
          num_ = 1;
          dots_ = true;
          arrows_ = false;
          config = {
            centerMode: true,
            slidesToShow: 1,
            adaptiveHeight: false,
            centerPadding: '30px',
            slidesToScroll: 0,
          }
        }
        $(classname).slick({
          arrows: true,
          dots: dots_,
          touchThreshold: 500,
          slidesToShow: num_,
          slidesToScroll: num_,
          draggable: true,
          infinite: true,
          prevArrow: `${classname}-btn .slick-prev`,
          nextArrow: `${classname}-btn .slick-next`,
          ...config
        }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
          // $.$$updateInput()
          // $(this).find('.slick-cloned').each(function () {
          //   var index = $(this).data('slickIndex')
          //   $(this).find('.grid-product').data('vego.collection.product', null)
          //   $(this).find('.grid-product').collecionProduct()
          //   if (radios.length) {
          //     radios.each(function () {
          //       var $label = $(this).find('label')
          //       var attrFor = $label.attr('for')
          //       var id = attrFor + '-' + index
          //       $label.attr('for', id)
          //       $(this).find('input[type=radio]').attr('id', id)
          //     })
          //   }
          //   if ($(this).find('select.grid-product-variant-input:enabled').length) {
          //     $(this).find('select.grid-product-variant-input:enabled').data('vego.select', null)
          //     $(this).find('select.grid-product-variant-input:enabled').closest('.vego-select-contaner').find('.vego-select-dropdown').remove()
          //     $(this).find('select.grid-product-variant-input:enabled').closest('.vego-select-contaner').find('.vego-select').remove()
          //     $(this).find('select.grid-product-variant-input:enabled').vselect()
          //   }
          // })
          AOS.refreshHard()
        })
      }
      if ($(`${classname}-b`).length) {
        slickSaleSlider(`${classname}-b`)
      }
    }
    if (theme.isMobile()) slickSaleSlider('.why-gao-list')
    if (!theme.isMobile()) slickSaleSlider(".flickity-addons-holiday-pick-v2");
    slickSaleSlider('.flickity-addons-holiday-pick')
    slickSaleSlider('.flickity-addons-best-sellers')
    // if (window.location.href.indexOf('on-sale') > -1) slickSaleSlider('.flickity-addons-mothers-day-collection')
    // if(window.location.href.indexOf('on-sale'))slickSaleSlider('.flickity-addons-mothers-day-collection-1')
    slickSaleSlider('.flickity-addons-new-year-sale')
    // slickSaleSlider('.flickity-addons-new-arrivals')

    // slickSaleSlider('.flickity-addons-novel-raised-garden-beds')
    // slickSaleSlider('.flickity-addons-modern-metal-raised-garden-beds')
    // slickSaleSlider('.flickity-addons-advanced-garden-beds')
    // slickSaleSlider('.flickity-addons-add-ons')
    // slickSaleSlider('.flickity-addons-vego-composting')


    // slickSaleSlider('.flickity-addons-vego-watering')
    // slickSaleSlider('.flickity-addons-seeding-tray-suite')
    // slickSaleSlider('.flickity-addons-accessories',true, 2)
    // slickSaleSlider('.flickity-addons-soil-amendments',true, 2)
    slickSaleSlider('.flickity-addons-foodcube-accessories')
    // slickSaleSlider('.flickity-addons-extension-kit')
    slickSaleSlider('.flickity-addons-gifts-under-50')
    slickSaleSlider('.flickity-addons-gifts-under-100')
    slickSaleSlider('.flickity-addons-gifts-under-150')
    slickSaleSlider('.flickity-addons-gifts-under-200')
    slickSaleSlider('.flickity-addons-gifts-under-300')
    slickSaleSlider('.flickity-addons-gifts-under-400')
    // slickSaleSlider('.flickity-addons-evergrove-garden-bed')
    slickSaleSlider('.flickity-addons-add-ons-c', false, 4)
    if (location.pathname != '/pages/on-sale' && location.pathname != '/collections/ez-planters' && location.pathname != '/products/seedling-humidity-dome-10-x-20-with-vego-grow-light') {
      slickSaleSlider('.flickity-addons-planters')
      slickSaleSlider('.flickity-addons-ezcube-planter')
      // slickSaleSlider('.flickity-addons-classic-metal-raised-garden-beds')
    }
    if (window.innerWidth < 768) slickSaleSlider('.flickity-bundle-lp')

    if ($('.flickity-one-three').length) {
      $('.flickity-one-three').on('init', function () {
        $(this).css('opacity', 1)
      })
      $('.flickity-one-three').slick({
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: true,
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"><rect width="34" height="34" rx="17" transform="matrix(-1 0 0 1 34 0)" fill="#3A5B39"/><path d="M12 17L19 22V12L12 17Z" fill="#FEF9EB"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><rect width="40" height="40" rx="20" transform="matrix(-1 0 0 1 40 0)" fill="#3A5B39"/><path d="M25.8824 20L17.6471 25.8823V14.1176L25.8824 20Z" fill="#FEF9EB"/></svg></button>',
        // prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
        // nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              draggable: true,
              adaptiveHeight: false,
              slidesToShow: 1,
              slidesToScroll: 1
            },
          }
        ],
      })
    }

    if ($('.plants-slider').length) {
      $('.plants-slider')
        .slick({
          arrows: true,
          dots: false,
          slidesToShow: 5,
          slidesToScroll: 1,
          draggable: false,
          prevArrow: false,
          nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M24.9996 4.16602C13.494 4.16602 4.16626 13.4938 4.16626 24.9993C4.16626 36.5049 13.494 45.8327 24.9996 45.8327C36.5051 45.8327 45.8329 36.5049 45.8329 24.9993C45.8329 13.4938 36.5051 4.16602 24.9996 4.16602ZM24.9996 8.33268C34.1892 8.33268 41.6663 15.8098 41.6663 24.9993C41.6663 34.1896 34.1892 41.666 24.9996 41.666C15.81 41.666 8.33293 34.1896 8.33293 24.9993C8.33293 15.8098 15.81 8.33268 24.9996 8.33268Z" fill="white"/><circle cx="24.5" cy="25.5" r="18.5" style="--fill:white;" fill="white"/><path d="M21.5282 34.0268C21.1159 34.0273 20.7128 33.9055 20.3698 33.6767C20.0269 33.4479 19.7596 33.1224 19.6018 32.7415C19.4441 32.3606 19.4029 31.9414 19.4837 31.5371C19.5644 31.1328 19.7634 30.7616 20.0553 30.4705L26.9997 23.5261C27.1931 23.3325 27.4227 23.179 27.6754 23.0742C27.9282 22.9694 28.1991 22.9155 28.4727 22.9155C28.7462 22.9155 29.0172 22.9694 29.2699 23.0742C29.5226 23.179 29.7522 23.3325 29.9456 23.5261C30.1391 23.7194 30.2927 23.949 30.3974 24.2018C30.5022 24.4545 30.5561 24.7254 30.5561 24.999C30.5561 25.2726 30.5022 25.5435 30.3974 25.7962C30.2927 26.0489 30.1391 26.2786 29.9456 26.4719L23.0011 33.4164C22.808 33.6101 22.5784 33.7638 22.3256 33.8686C22.0728 33.9733 21.8018 34.0271 21.5282 34.0268Z" style="--fill: #BFCD89;" fill="#BFCD89"/><path d="M28.4721 27.0829C28.1985 27.0832 27.9275 27.0293 27.6747 26.9244C27.4219 26.8195 27.1924 26.6657 26.9992 26.4718L20.0548 19.5274C19.8613 19.334 19.7079 19.1045 19.6032 18.8518C19.4985 18.5991 19.4446 18.3283 19.4446 18.0548C19.4446 17.7813 19.4985 17.5105 19.6032 17.2578C19.7079 17.0051 19.8613 16.7756 20.0548 16.5822C20.2481 16.3887 20.4777 16.2351 20.7305 16.1304C20.9832 16.0256 21.2541 15.9717 21.5277 15.9717C21.8013 15.9717 22.0722 16.0256 22.3249 16.1304C22.5777 16.2351 22.8073 16.3887 23.0006 16.5822L29.9451 23.5267C30.2368 23.8178 30.4355 24.189 30.5161 24.5931C30.5967 24.9973 30.5555 25.4163 30.3978 25.7971C30.2401 26.1778 29.9729 26.5032 29.6301 26.732C29.2873 26.9608 28.8843 27.0827 28.4721 27.0822" style="--fill: #BFCD89;" fill="#BFCD89"/></svg></button>',
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                draggable: true,
                adaptiveHeight: false,
                slidesToShow: 2.3,
                slidesToScroll: 1
              },
            }
          ],
        })
        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
          AOS.refreshHard()
        })
        .css('overflow', 'initial')
    }

    setTimeout(function () {
      $('.flickity-featured-products').each(function () {
        if (!$(this).hasClass('slick-initialized')) {
          $(this).css('opacity', 1)
        }
      })
    }, 0)
    // if (!theme.isMobile()) {
    // } else {
    //   if ($('.page-section-flash-sale').length) {
    //     var wi = $('.flickity-addons-add-ons-c').width()
    //     var $items = $('.flickity-addons-add-ons-c .flickity-item')
    //     $items.each(function () {
    //       $(this).width((wi - 8) / 2)
    //     })
    //     var boxes = []
    //     for (var i = 0; i < Math.round($items.length / 4); i++) {
    //       boxes[i] = $('<div class="flickity-addons-slider-item"><div class="flickity-addons-item"></div></div>')
    //       $('.flickity-addons-add-ons-c').append(boxes[i])
    //     }
    //     $items.each(function (i, e) {
    //       $(e).appendTo(boxes[Math.floor(i / 4)].find('.flickity-addons-item'))
    //       boxes[Math.floor(i / 4)].find('.flickity-addons-item').width(wi)
    //     })
    //     $('.flickity-addons-add-ons-c').slick({
    //       arrows: true,
    //       dots: false,
    //       slidesToShow: 4,
    //       slidesToScroll: 1,
    //       draggable: true,
    //       infinite: true,
    //       prevArrow: `.flash-sale-action-btns .slick-prev`,
    //       nextArrow: `.flash-sale-action-btns .slick-next`,
    //     });
    //     $('.flickity-addons-add-ons-c').on('afterChange').each(function (e) {
    //       $.$$updateInput()
    //       $(this).find('.slick-cloned').each(function () {
    //         var index = $(this).data('slickIndex')
    //         var radios = $(this).find('.variant-radio')
    //         $(this).find('.grid-product').data('vego.collection.product', null)
    //         $(this).find('.grid-product').collecionProduct()
    //         if (radios.length) {
    //           radios.each(function () {
    //             var $label = $(this).find('label')
    //             var attrFor = $label.attr('for')
    //             var id = attrFor + '-' + index
    //             $label.attr('for', id)
    //             $(this).find('input[type=radio]').attr('id', id)
    //           })
    //         }
    //         if ($(this).find('select.grid-product-variant-input:enabled').length) {
    //           $(this).find('select.grid-product-variant-input:enabled').data('vego.select', null)
    //           $(this).find('select.grid-product-variant-input:enabled').closest('.vego-select-contaner').find('.vego-select-dropdown').remove()
    //           $(this).find('select.grid-product-variant-input:enabled').closest('.vego-select-contaner').find('.vego-select').remove()
    //           $(this).find('select.grid-product-variant-input:enabled').vselect()
    //         }
    //       })
    //     })
    //   }
    // }
    /* prevent resize in flickity if still animating */
    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function () {
      if (!this.isAnimating) {
        resize.call(this);
      }
    };
    // var observer = new MutationObserver(function (mutations) {
    //   mutations.forEach(function (mutationRecord) {
    //     if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length && mutationRecord.addedNodes[0].id === 'attentive_overlay') {
    //       var $head = $('#attentive_creative').contents().find("head");
    //       console.log($head)
    //       $head.append('<style>:focus-visible {outline: none;} #bubbleWrapper {background-color: #E3A346;}</style>')
    //     }
    //   });
    // });
    // observer.observe(document.body, {childList: true});
    function initFreshChat() {
      window.fcWidget.init({
        "config": {
          "headerProperty": {
            "appName": "Vego Garden Live Chat",
            hideChatButton: true,
          }
        },
        "host": "https://wchat.freshchat.com",
        "token": "0178129b-d8b8-4baa-8ba8-542253a10ea8"
      });
      window.fcWidget.on("widget:opened", function (resp) {
        document.getElementById('fresh-chat-opener').style.visibility = "hidden"
      });
      window.fcWidget.on("widget:closed", function (resp) {
        document.getElementById('fresh-chat-opener').style.visibility = "visible"
      });

      // Close loading style. TODO

      // First init by click, after init should open chat window.
      theme.chatBot.openChat();
    }

    $("#fresh-chat-opener, .open-fresh-chat-link").click(function () {

      // Close menu or set chat modal index higher than menu in mobile. TODO

      var id = 'freshchat-js-sdk';
      if (document.getElementById(id)) {
        theme.chatBot.openChat();
        return;
      }

      // Set loading style. TODO

      // var fcJS = document.createElement('script');
      // fcJS.id = id;
      // fcJS.async = true;
      // fcJS.src = 'https://wchat.freshchat.com/js/widget.js?t=' + Date.now();
      //fcJS.onload = initFreshChat;
      // document.head.appendChild(fcJS);
    });

    if ($('.page-section-faq').length) {
      function onSearch() {
        var text = $('.faq-search-box .search-input').val().toLowerCase();
        if (!text) {
          return
        }
        $('.faq-search-box .btn-clear').show()
        var find = false
        $('.page-section-faq-problem-box details').each(function () {
          var q = $(this).find('summary').text().trim();
          $(this).hide()
          if (q.toLowerCase().indexOf(text) > -1) {
            find = true
            $(this).show()
          }
        })
        $('.page-section-faq-tags-box').hide()
        if (find) {
          $('.page-section-faq-problem-box').show()
          $('.page-section-faq-problem-empty').hide()
        } else {
          $('.page-section-faq-problem-box').hide()
          $('.page-section-faq-problem-empty').show()
        }
      }
      $('.faq-search-box .search-input').on('keydown', function (e) {
        if (e.keyCode == 13) {
          onSearch()
        }
      })
      $('.faq-search-box .search-input-append').on('click', onSearch)
      $('.faq-search-box .btn-clear').on('click', function () {
        $('.faq-search-box .search-input').val('');
        $(this).hide()
        $('.page-section-faq-tags-box').show()
        $('.page-section-faq-problem-box').show()
        $('.page-section-faq-problem-empty').hide()
        var active = $('.page-section-faq-tags-box .active').text()
        $('.page-section-faq-problem-box details').each(function () {
          $(this).hide()
          if ($(this).data('tags') == active) {
            $(this).show()
          }
        })
      })
    }
    if (theme.isMobile()) {
      $('#bwpFrame').appendTo($('.payment-buttons.medium-up--hide .payment-button-group'))
    }

    new theme.Modals(
      'LanguageChanger',
      'language-changer'
    )

    new theme.Modals(
      'image-preview-modal',
      'view-image'
    )

    setTimeout(() => {
      if (location.pathname.includes('/products')) {
        var query = $.qs()
        if (query.immediately && query.immediately[0] == 1) {
          $('.btn.klaviyo-bis-trigger').click()
        }
      }
    }, 1000)

    // let checkKlaviyoTimeoutId

    // function checkKlaviyoModelShow() {
    //   return new Promise(function(resolve, reject){
    //     if (checkKlaviyoTimeoutId) {
    //       clearTimeout(checkKlaviyoTimeoutId)
    //       checkKlaviyoTimeoutId = null
    //     }
    //     checkKlaviyoTimeoutId = setTimeout(() => {
    //       let hasSkuInput = false, $input
    //       $('.needsclick > input').each(function() {
    //         if ($(this).attr('id') && $(this).attr('id').startsWith('sold_out_notify_sku')) {
    //           hasSkuInput = true
    //           $input = $(this)
    //         }
    //       })
    //       if (!hasSkuInput) {
    //         checkKlaviyoModelShow().then(resolve)
    //       } else {
    //         resolve($input)
    //       }
    //     }, 1000)
    //   })
    // }

    // function simulateInput(input, value) {
    //   const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    //   nativeSetter.call(input, value);
    //   input.dispatchEvent(new Event('input', { bubbles: true }));
    // }
    // $(document.body).on('click', '.btn-notify', function (e) {
    //   e.preventDefault()
    //   window._klOnsite = window._klOnsite || [];
    //   window._klOnsite.push(['openForm', 'Xr6wRT']);
    //   checkKlaviyoModelShow().then($input => {
    //     let variantId 
    //     if ($(this).closest('.grid-product').length) {
    //       const product = $(this).closest('.grid-product').data('vego.collection.product')
    //       variantId = product.current.id
    //     } else {
    //       variantId = theme.getCurrentProductVariant().id
    //     }
    //     if (variantId) {
    //       $input.attr('type', 'hidden')
    //       $input.closest('[data-testid=form-row]').hide()
    //       simulateInput($input[0], '' + variantId)
    //     }
    //   })
    // })

    function resizeBlockCard() {
      if ($('.block-card').length) {
        $('.block-card').css('height', 'auto')
        var maxHeight = 0, invidual = false
        if (theme.isMobile()) {
          $('.block-card').each(function () {
            var dataHeight = $(this).data('height')
            if (dataHeight) {
              if (dataHeight == 'image') {
                if (!maxHeight && $(this).next('.planter-grid-image')) {
                  maxHeight = $(this).next('.planter-grid-image').height()
                }
              } else if (dataHeight.startsWith('#')) {
                invidual = true
                $(this).height($(dataHeight).height())
              }
            }
          })
          if (!maxHeight) {
            maxHeight = 180
          }
        } else {
          $('.block-card').each(function () {
            if ($(this).height() > maxHeight) {
              maxHeight = $(this).height()
            }
          })
        }
        if (!invidual) {
          $('.block-card').height(maxHeight)
        }
      }
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutationRecord) {
        if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length) {
          resizeBlockCard()
        }
      });
    });
    var icons = $('.block-cart-link .vegoicon-arrow-right-rev')
    if (icons.length) {
      observer.observe(icons[icons.length - 1], { childList: true });
    }
    if ($('.block-card').length) {
      resizeBlockCard()
      window.on(
        'resize',
        theme.utils.debounce(250, resizeBlockCard)
      )
    }
    if ($('.compare-models').length) {
      var columnGroup = []
      $('.product-compare-column').each(function(i) {
        $(this).find('.product-compare-column-one').each(function(i2) {
          var row = columnGroup[i2]
          if (!row) {
            row = []
            columnGroup[i2] = row
          }
          row[i] = $(this)
        })
      })

      const resizeCompareColumn = function() {
        var maxHeadHeight = 0
        $('.product-compare-column-head').each(function() {
          $(this).css('height', 'auto')
          var height = $(this).height()
          if (height > maxHeadHeight) {
            maxHeadHeight = height
          }
        })
        $('.product-compare-column-head').each(function() {
          var height = $(this).height()
          if (height < maxHeadHeight) {
            $(this).css('height', maxHeadHeight + 'px')
          }
        })

        for (const row of columnGroup) {
          var maxOneHeight = 0
          row.forEach(function($e) {
            $e.css('height', 'auto')
            var height = $e.outerHeight()
            if (height > maxOneHeight) {
              maxOneHeight = height
            }
          })
          row.forEach(function($e) {
            var height = $e.outerHeight()
            if (height < maxOneHeight) {
              $e.css('height', maxOneHeight + 'px')
            }
          })
        }
      }
      resizeCompareColumn()
      window.on(
        'resize',
        resizeCompareColumn
      )
    }
    if ($('.elevated-compare').length) {
      var columnGroup = []
      $('.elevated-compare-row:not(.elevated-compare-row-head)').each(function(i) {
        $(this).find('.elevated-compare-info > div').each(function(i2) {
          var row = columnGroup[i]
          if (!row) {
            row = []
            columnGroup[i] = row
          }
          row[i2] = $(this)
        })
      })

      const resizeCompareColumn = function() {
        for (const row of columnGroup) {
          var maxOneHeight = 0
          row.forEach(function($e) {
            $e.css('height', 'auto')
            var height = $e.outerHeight()
            if (height > maxOneHeight) {
              maxOneHeight = height
            }
          })
          row.forEach(function($e) {
            var height = $e.outerHeight()
            if (height < maxOneHeight) {
              $e.css('height', maxOneHeight + 'px')
            }
          })
        }
      }
      resizeCompareColumn()
      window.on(
        'resize',
        resizeCompareColumn
      )
    }
  });
  document.addEventListener('rebuy.add', function (event) {
    // Your custom logic here
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: {
          product: event.detail.product,
          drawer: true
        },
      })
    )
  });
  document.addEventListener('rebuy:cart.change', function (event) {
    console.log('rebuy:cart.change event', event.detail);
    if (window.Rebuy.widgets[0] && window.Rebuy.widgets[0].status == 'ready') {
      setTimeout(() => {
        $('.rebuy-product-block').each(function () {
          if (!$(this).hasClass('splide__slide')) {
            $(this).addClass('splide__slide');
          }
        })
      }, 10)
    }
  });
  window.addEventListener("noibuSDKReady", () => {
    $('.noibu-code').removeClass('hide')
    var $btn = $('.noibu-code-btn')
    $btn.on('click', function () {
      window.NOIBUJS.requestHelpCode(false).then(function (code) {
        $('.noibu-code').find('.noibu-code-text').remove()
        $('.noibu-code').append(`<span class="noibu-code-text">${code}</span>`)
      })
    })
  });
})();


